var _style, _g, _g2, _polygon, _rect, _rect2, _rect3, _rect4, _g3, _path, _path2, _path3, _g4, _g5, _g6, _path4, _path5, _path6, _path7, _defs, _rect5, _rect6, _polygon2, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _polygon3, _rect23, _polygon4, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _polygon5, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _polygon6, _rect58, _polygon7, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _polygon8, _rect75, _polygon9, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _polygon0, _rect95, _polygon1, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _polygon10, _rect128, _polygon11, _polygon12, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _polygon13, _polygon14, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _polygon15, _rect161, _rect162, _polygon16, _rect163, _polygon17, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _polygon18, _rect179, _polygon19, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _polygon20, _polygon21, _polygon22, _polygon23, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _polygon24, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _polygon25, _defs2, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _polygon26, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _polygon27, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _polygon28, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _polygon29, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _polygon30, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _polygon31, _rect281, _polygon32, _rect282, _rect283, _rect284, _rect285, _polygon33, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _polygon34, _rect293, _rect294, _rect295, _rect296, _rect297, _polygon35, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _polygon36, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _polygon37, _rect327, _rect328, _rect329, _polygon38, _rect330, _rect331, _polygon39, _rect332, _rect333, _rect334, _rect335, _rect336, _polygon40, _rect337, _polygon41, _rect338, _rect339, _rect340, _rect341, _rect342, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _rect349, _rect350, _rect351, _rect352, _rect353, _rect354, _rect355, _rect356, _rect357, _rect358, _polygon42, _rect359, _rect360, _rect361, _rect362, _rect363, _rect364, _rect365, _polygon43, _rect366, _rect367, _rect368, _rect369, _rect370, _rect371, _polygon44, _rect372, _rect373, _rect374, _rect375, _rect376, _rect377, _rect378, _polygon45, _rect379, _rect380, _rect381, _rect382, _rect383, _rect384, _rect385, _rect386, _rect387, _rect388, _rect389, _rect390, _rect391, _rect392, _rect393, _rect394, _rect395, _rect396, _rect397, _rect398, _rect399, _polygon46, _rect400, _rect401, _rect402, _rect403, _rect404, _polygon47, _path8, _defs3, _rect405, _polygon48, _polygon49, _rect406, _rect407, _rect408, _rect409, _polygon50, _rect410, _rect411, _polygon51, _rect412, _polygon52, _rect413, _rect414, _polygon53, _rect415, _polygon54, _polygon55, _rect416, _polygon56, _polygon57, _rect417, _rect418, _rect419, _rect420, _polygon58, _rect421, _polygon59, _rect422, _rect423, _rect424, _polygon60, _polygon61, _rect425, _rect426, _rect427, _rect428, _rect429, _polygon62, _rect430, _polygon63, _rect431, _rect432, _polygon64, _rect433, _polygon65, _polygon66, _rect434, _polygon67, _rect435, _rect436, _polygon68, _polygon69, _rect437, _polygon70, _rect438, _rect439, _polygon71, _rect440, _polygon72, _polygon73, _rect441, _polygon74, _rect442, _polygon75, _rect443, _rect444, _rect445, _rect446, _rect447, _polygon76, _rect448, _polygon77, _rect449, _polygon78, _polygon79, _rect450, _polygon80, _polygon81, _rect451, _polygon82, _rect452, _rect453, _polygon83, _rect454, _polygon84, _polygon85, _rect455, _polygon86, _rect456, _rect457, _polygon87, _rect458, _rect459, _polygon88, _rect460, _polygon89, _rect461, _rect462, _rect463, _rect464, _polygon90, _rect465, _polygon91, _rect466, _rect467, _rect468, _rect469, _rect470, _polygon92, _rect471, _polygon93, _polygon94, _rect472, _rect473, _polygon95, _rect474, _polygon96, _rect475, _rect476, _polygon97, _rect477, _rect478, _polygon98, _rect479, _rect480, _rect481, _rect482, _polygon99, _polygon100, _rect483, _rect484, _rect485, _polygon101, _rect486, _polygon102, _rect487, _rect488, _polygon103, _polygon104, _rect489, _polygon105, _rect490, _polygon106, _polygon107, _rect491, _polygon108, _rect492, _rect493, _polygon109, _rect494, _rect495, _rect496, _polygon110, _path9, _defs4, _rect497, _polygon111, _polygon112, _rect498, _polygon113, _rect499, _polygon114, _polygon115, _polygon116, _polygon117, _rect500, _polygon118, _rect501, _rect502, _polygon119, _rect503, _rect504, _rect505, _polygon120, _rect506, _polygon121, _polygon122, _rect507, _rect508, _rect509, _rect510, _rect511, _rect512, _rect513, _polygon123, _rect514, _polygon124, _polygon125, _rect515, _polygon126, _rect516, _polygon127, _rect517, _polygon128, _polygon129, _polygon130, _polygon131, _rect518, _polygon132, _rect519, _rect520, _polygon133, _polygon134, _polygon135, _rect521, _rect522, _rect523, _polygon136, _polygon137, _rect524, _rect525, _rect526, _rect527, _rect528, _rect529, _rect530, _polygon138, _rect531, _polygon139, _polygon140, _rect532, _polygon141, _rect533, _polygon142, _rect534, _polygon143, _polygon144, _polygon145, _polygon146, _rect535, _polygon147, _polygon148, _polygon149, _polygon150, _polygon151, _polygon152, _rect536, _polygon153, _rect537, _polygon154, _polygon155, _rect538, _rect539, _rect540, _rect541, _rect542, _rect543, _polygon156, _polygon157, _rect544, _polygon158, _polygon159, _rect545, _polygon160, _rect546, _polygon161, _rect547, _polygon162, _rect548, _rect549, _polygon163, _rect550, _polygon164, _rect551, _polygon165, _polygon166, _polygon167, _polygon168, _rect552, _polygon169, _rect553, _polygon170, _polygon171, _polygon172, _rect554, _rect555, _polygon173, _rect556, _polygon174, _polygon175, _polygon176, _polygon177, _polygon178, _polygon179, _polygon180, _polygon181, _rect557, _polygon182, _polygon183, _polygon184, _polygon185, _rect558, _polygon186, _rect559, _polygon187, _rect560, _polygon188, _polygon189, _polygon190, _rect561, _rect562, _polygon191, _polygon192, _polygon193, _polygon194, _rect563, _rect564, _rect565, _rect566, _polygon195, _polygon196, _polygon197, _rect567, _rect568, _polygon198, _polygon199, _polygon200, _polygon201, _polygon202, _polygon203, _rect569, _polygon204, _polygon205, _polygon206, _rect570, _rect571, _polygon207, _rect572, _polygon208, _polygon209, _polygon210, _rect573, _rect574, _polygon211, _polygon212, _polygon213, _polygon214, _polygon215, _rect575, _rect576, _rect577, _rect578, _polygon216, _polygon217, _rect579, _rect580, _rect581, _polygon218, _polygon219, _polygon220, _polygon221, _polygon222, _rect582, _polygon223, _polygon224, _polygon225, _rect583, _rect584, _polygon226, _rect585, _polygon227, _polygon228, _polygon229, _rect586, _rect587, _polygon230, _rect588, _polygon231, _polygon232, _rect589, _rect590, _rect591, _rect592, _polygon233, _polygon234, _polygon235, _rect593, _rect594, _rect595, _polygon236, _polygon237, _polygon238, _polygon239, _polygon240, _rect596, _polygon241, _rect597, _defs5, _rect598, _rect599, _rect600, _rect601, _rect602, _rect603, _rect604, _rect605, _rect606, _rect607, _polygon242, _rect608, _rect609, _rect610, _rect611, _rect612, _rect613, _rect614, _rect615, _rect616, _rect617, _rect618, _rect619, _rect620, _rect621, _rect622, _rect623, _rect624, _rect625, _rect626, _rect627, _rect628, _rect629, _rect630, _rect631, _rect632, _rect633, _rect634, _rect635, _rect636, _rect637, _rect638, _rect639, _rect640, _polygon243, _rect641, _rect642, _rect643, _rect644, _rect645, _rect646, _rect647, _rect648, _rect649, _rect650, _rect651, _rect652, _rect653, _rect654, _rect655, _rect656, _rect657, _rect658, _rect659, _rect660, _rect661, _rect662, _rect663, _rect664, _rect665, _rect666, _rect667, _rect668, _rect669, _rect670, _rect671, _rect672, _rect673, _polygon244, _rect674, _rect675, _rect676, _rect677, _rect678, _rect679, _rect680, _rect681, _rect682, _rect683, _rect684, _rect685, _rect686, _rect687, _rect688, _rect689, _rect690, _rect691, _rect692, _rect693, _rect694, _rect695, _rect696, _rect697, _rect698, _rect699, _rect700, _rect701, _rect702, _rect703, _rect704, _rect705, _rect706, _polygon245, _rect707, _rect708, _rect709, _rect710, _rect711, _rect712, _rect713, _rect714, _rect715, _rect716, _rect717, _rect718, _rect719, _rect720, _rect721, _rect722, _rect723, _rect724, _rect725, _rect726, _rect727, _rect728, _rect729, _rect730, _rect731, _rect732, _rect733, _rect734, _rect735, _rect736, _rect737, _rect738, _rect739, _rect740, _rect741, _rect742, _rect743, _rect744, _rect745, _rect746, _rect747, _rect748, _rect749, _rect750, _rect751, _rect752, _rect753, _rect754, _rect755, _rect756, _rect757, _rect758, _rect759, _rect760, _rect761, _rect762, _rect763, _rect764, _rect765, _rect766, _rect767, _rect768, _rect769, _rect770, _rect771, _rect772, _rect773, _rect774, _rect775, _rect776, _rect777, _rect778, _rect779, _rect780, _rect781, _rect782, _rect783, _rect784, _rect785, _rect786, _rect787, _rect788, _rect789, _rect790, _rect791, _rect792, _rect793, _rect794, _rect795, _rect796, _rect797, _rect798, _rect799, _rect800, _rect801, _rect802, _rect803, _rect804, _rect805, _rect806, _rect807, _rect808, _rect809, _rect810, _rect811, _rect812, _rect813, _rect814, _rect815, _rect816, _rect817, _rect818, _rect819, _rect820, _rect821, _rect822, _rect823, _rect824, _rect825, _rect826, _rect827, _rect828, _rect829, _rect830, _rect831, _rect832, _defs6, _rect833, _polygon246, _rect834, _rect835, _polygon247, _rect836, _polygon248, _rect837, _rect838, _rect839, _polygon249, _rect840, _rect841, _rect842, _rect843, _rect844, _rect845, _rect846, _rect847, _polygon250, _rect848, _polygon251, _rect849, _rect850, _rect851, _rect852, _polygon252, _polygon253, _rect853, _polygon254, _rect854, _rect855, _rect856, _polygon255, _rect857, _rect858, _rect859, _rect860, _rect861, _rect862, _polygon256, _polygon257, _polygon258, _rect863, _rect864, _rect865, _rect866, _rect867, _rect868, _rect869, _rect870, _rect871, _rect872, _rect873, _rect874, _rect875, _polygon259, _rect876, _rect877, _polygon260, _rect878, _polygon261, _rect879, _polygon262, _rect880, _rect881, _rect882, _polygon263, _polygon264, _rect883, _polygon265, _rect884, _rect885, _rect886, _rect887, _rect888, _polygon266, _rect889, _polygon267, _rect890, _rect891, _rect892, _polygon268, _rect893, _rect894, _rect895, _rect896, _polygon269, _rect897, _polygon270, _rect898, _polygon271, _rect899, _polygon272, _rect900, _rect901, _path0, _defs7, _rect902, _rect903, _rect904, _rect905, _rect906, _rect907, _rect908, _rect909, _rect910, _rect911, _rect912, _rect913, _polygon273, _rect914, _polygon274, _rect915, _rect916, _rect917, _rect918, _rect919, _rect920, _rect921, _polygon275, _rect922, _rect923, _rect924, _rect925, _rect926, _rect927, _rect928, _rect929, _rect930, _rect931, _rect932, _rect933, _rect934, _rect935, _rect936, _polygon276, _rect937, _rect938, _rect939, _polygon277, _rect940, _polygon278, _rect941, _rect942, _rect943, _rect944, _rect945, _polygon279, _rect946, _polygon280, _rect947, _rect948, _rect949, _rect950, _rect951, _polygon281, _rect952, _polygon282, _rect953, _rect954, _rect955, _rect956, _rect957, _rect958, _polygon283, _polygon284, _path1, _path10, _defs8, _rect959, _rect960, _rect961, _rect962, _rect963, _rect964, _rect965, _rect966, _rect967, _rect968, _rect969, _rect970, _rect971, _rect972, _rect973, _rect974, _rect975, _rect976, _rect977, _rect978, _rect979, _rect980, _rect981, _rect982, _rect983, _rect984, _rect985, _rect986, _rect987, _rect988, _rect989, _rect990, _rect991, _rect992, _rect993, _rect994, _rect995, _rect996, _rect997, _rect998, _rect999, _rect1000, _rect1001, _rect1002, _rect1003, _rect1004, _rect1005, _rect1006, _polygon285, _rect1007, _rect1008, _rect1009, _rect1010, _rect1011, _rect1012, _rect1013, _rect1014, _rect1015, _rect1016, _rect1017, _rect1018, _rect1019, _rect1020, _rect1021, _rect1022, _rect1023, _rect1024, _rect1025, _rect1026, _rect1027, _rect1028, _rect1029, _rect1030, _rect1031, _rect1032, _rect1033, _rect1034, _rect1035, _rect1036, _rect1037, _rect1038, _rect1039, _rect1040, _rect1041, _rect1042, _rect1043, _rect1044, _rect1045, _rect1046, _rect1047, _rect1048, _rect1049, _rect1050, _rect1051, _rect1052, _rect1053, _rect1054, _rect1055, _rect1056, _rect1057, _rect1058, _rect1059, _rect1060, _polygon286, _rect1061, _rect1062, _rect1063, _rect1064, _rect1065, _rect1066, _rect1067, _rect1068, _rect1069, _rect1070, _rect1071, _rect1072, _rect1073, _rect1074, _rect1075, _rect1076, _rect1077, _rect1078, _rect1079, _rect1080, _rect1081, _rect1082, _rect1083, _rect1084, _rect1085, _rect1086, _rect1087, _rect1088, _rect1089, _rect1090, _rect1091, _rect1092, _rect1093, _rect1094, _rect1095, _rect1096, _rect1097, _rect1098, _rect1099, _rect1100, _rect1101, _rect1102, _rect1103, _rect1104, _rect1105, _rect1106, _rect1107, _rect1108, _rect1109, _rect1110, _rect1111, _rect1112, _rect1113, _rect1114, _rect1115, _rect1116, _rect1117, _rect1118, _rect1119, _rect1120, _rect1121, _rect1122, _rect1123, _rect1124, _rect1125, _rect1126, _rect1127, _rect1128, _rect1129, _rect1130, _rect1131, _rect1132, _rect1133, _rect1134, _rect1135, _rect1136, _rect1137, _rect1138, _rect1139, _rect1140, _rect1141, _rect1142, _rect1143, _rect1144, _rect1145, _rect1146, _rect1147, _rect1148, _rect1149, _rect1150, _rect1151, _rect1152, _rect1153, _rect1154, _rect1155, _rect1156, _rect1157, _rect1158, _polygon287, _rect1159, _rect1160, _polygon288, _rect1161, _rect1162, _rect1163, _rect1164, _rect1165, _rect1166, _rect1167, _rect1168, _rect1169, _rect1170, _rect1171, _rect1172, _rect1173, _rect1174, _rect1175, _rect1176, _rect1177, _rect1178, _rect1179, _rect1180, _rect1181, _rect1182, _defs9, _polygon289, _rect1183, _rect1184, _rect1185, _rect1186, _rect1187, _rect1188, _rect1189, _polygon290, _rect1190, _polygon291, _rect1191, _rect1192, _rect1193, _rect1194, _rect1195, _rect1196, _rect1197, _rect1198, _rect1199, _rect1200, _rect1201, _rect1202, _rect1203, _rect1204, _rect1205, _rect1206, _rect1207, _rect1208, _rect1209, _rect1210, _rect1211, _rect1212, _rect1213, _rect1214, _rect1215, _rect1216, _rect1217, _rect1218, _rect1219, _rect1220, _rect1221, _rect1222, _rect1223, _rect1224, _rect1225, _rect1226, _rect1227, _rect1228, _rect1229, _rect1230, _rect1231, _rect1232, _rect1233, _rect1234, _rect1235, _rect1236, _rect1237, _rect1238, _rect1239, _rect1240, _rect1241, _rect1242, _polygon292, _rect1243, _rect1244, _rect1245, _polygon293, _rect1246, _rect1247, _rect1248, _rect1249, _rect1250, _rect1251, _rect1252, _rect1253, _rect1254, _polygon294, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWpd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1D1D72;}\n\t.st1{fill:#407BFF;}\n\t.st2{opacity:0.8;fill:#3C3C99;}\n\t.st3{fill:#3C3C99;}\n\t.st4{fill:url(#SVGID_1_);}\n\t.st5{fill:url(#SVGID_00000054946997930009613680000011812985618576365697_);}\n\t.st6{fill:url(#SVGID_00000168104785192537120970000017743061863739971986_);}\n\t.st7{opacity:0.3;fill:url(#SVGID_00000029732721879361304710000001208418425575563935_);}\n\t.st8{fill:url(#SVGID_00000048466478196509346100000002237281576296418970_);}\n\t.st9{opacity:0.5;fill:url(#SVGID_00000029018102007294475290000006745446855132829609_);}\n\t.st10{fill:url(#SVGID_00000016784411178700406710000014749843236398008463_);}\n\t.st11{opacity:0.2;fill:url(#SVGID_00000142871226516483713510000015956103047086316956_);}\n\t.st12{fill:url(#SVGID_00000003104809321679098810000002150940726963488183_);}\n\t.st13{opacity:0.5;fill:url(#SVGID_00000101825188799554426530000005331671800329914790_);}\n\t.st14{fill:url(#SVGID_00000160170575097146129420000010915678735255526566_);}\n\t.st15{fill:url(#SVGID_00000172407959270885002150000000810087192568563078_);}\n\t.st16{fill:url(#SVGID_00000079459843824915342390000015599303681989700249_);}\n\t.st17{fill:#D8ACFC;}\n\t.st18{opacity:0.7;fill:#40B8F4;}\n\t.st19{fill:#60B9EF;}\n\t.st20{opacity:0.3;fill:#60B9EF;}\n\t.st21{opacity:0.7;fill:#60B9EF;}\n\t.st22{opacity:0.3;fill:#FFFFFF;}\n\t.st23{fill:#4444D8;}\n\t.st24{fill:#5252D8;}\n\t.st25{fill:url(#SVGID_00000080917021261263135560000006550472771689330617_);}\n\t.st26{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st27{clip-path:url(#SVGID_00000153690869009064428060000017647658197096211106_);}\n\t.st28{clip-path:url(#SVGID_00000158736427256065723510000004342325227236971183_);}\n\t.st29{clip-path:url(#SVGID_00000023972175870969512990000017034208350024243073_);}\n\t.st30{clip-path:url(#SVGID_00000135689948195384832590000005261342584625128845_);}\n\t.st31{clip-path:url(#SVGID_00000180363459012327290880000000001411924400713631_);}\n\t.st32{clip-path:url(#SVGID_00000080201592947164547820000001253278428792214405_);}\n\t.st33{clip-path:url(#SVGID_00000028324388042793082690000011413326204770270624_);}\n\t.st34{clip-path:url(#SVGID_00000083083028562812738090000007896410027159796136_);}\n\t.st35{clip-path:url(#SVGID_00000008860282660026332500000016055842801427115942_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "World"
  })), /*#__PURE__*/React.createElement("g", {
    id: "People"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "107.8,174.4 55.3,132.2 55.9,131.4 108.5,173.7  "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 300.3,
    y: 162.5,
    transform: "matrix(0.9175 -0.3978 0.3978 0.9175 -36.0357 152.2228)",
    className: "st1",
    width: 97.2,
    height: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 199.6,
    y: 86.8,
    transform: "matrix(0.8503 -0.5263 0.5263 0.8503 -34.8178 123.751)",
    className: "st1",
    width: 1,
    height: 72.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 93.5,
    y: 266.4,
    transform: "matrix(0.9788 -0.2051 0.2051 0.9788 -51.6664 35.2004)",
    className: "st1",
    width: 101.1,
    height: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 343.7,
    y: 232.3,
    transform: "matrix(0.8474 -0.5309 0.5309 0.8474 -99.2734 226.3646)",
    className: "st1",
    width: 1,
    height: 107.2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "393.9,146.3 285.1,109.5 285,109.5 227.5,50.5 181.4,92.6 180.7,91.9 227.5,49.1 285.6,108.7  393.6,145.1 448.9,100.4 449.7,101  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 285.8,
    y1: 109.3,
    x2: 284.9,
    y2: 108.9
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "458.2,332 371.8,327.5 373.2,327.1 443.3,259.6 393.3,145.9 394.2,145.5 444.5,259.9 444.2,260.1  374,327.7 458.7,331.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "23.7,302.9 22.9,302.3 96,279.9 44.1,226.1 44.5,225.7 108.1,173.4 108.4,173.6 373.7,327.1  373.2,328 108.3,174.7 45.6,226 97.3,279.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.3,
    y: 162.5,
    transform: "matrix(0.9175 -0.3978 0.3978 0.9175 -36.0357 152.2228)",
    className: "st2",
    width: 97.2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.7,
    y: 232.3,
    transform: "matrix(0.8474 -0.5309 0.5309 0.8474 -99.2734 226.3646)",
    className: "st2",
    width: 1,
    height: 107.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.6,
    y: 86.8,
    transform: "matrix(0.8503 -0.5263 0.5263 0.8503 -34.8178 123.751)",
    className: "st2",
    width: 1,
    height: 72.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.5,
    y: 266.4,
    transform: "matrix(0.9788 -0.2051 0.2051 0.9788 -51.6664 35.2004)",
    className: "st2",
    width: 101.1,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "313.3,73.5 181,91.8 180.8,91.8 107.8,173.7 107.7,173.8 94,277.4 95.1,277 108.7,174.3  181.3,92.7 312.9,74.5 393,143.8 372.2,330.9 372.8,331.8 373.1,331.8 394,143.7 394,143.4  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.3982,
    y1: 145.7108,
    x2: 427.0796,
    y2: 145.7108
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D0D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5569FF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M427.1,145.7c0,7.5-2.5,14.4-6.6,20c-1.5,2-3.2,3.8-5.1,5.4c-1.7,1.5-3.5,2.7-5.5,3.8 c-4.8,2.6-10.3,4.1-16.1,4.1c-4.9,0-9.6-1.1-13.8-3c-0.4-0.2-0.8-0.4-1.2-0.6l0,0c-2.4-1.2-4.6-2.6-6.5-4.3 c-3-2.5-5.5-5.5-7.5-8.9c-2.8-4.9-4.4-10.5-4.4-16.5c0-18.4,14.9-33.3,33.3-33.3C412.2,112.4,427.1,127.3,427.1,145.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136402777500427688140000004283734775689510016_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.3389,
    y1: 107.8288,
    x2: 478.6873,
    y2: 216.5992
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D0D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5569FF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000136402777500427688140000004283734775689510016_)"
    },
    cx: 393.7,
    cy: 145.7,
    r: 32.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108279096325140313150000002194739324464388516_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.3519,
    y1: 99.6113,
    x2: 318.5629,
    y2: 53.3728
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D0D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5569FF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000108279096325140313150000002194739324464388516_)"
    },
    cx: 312.1,
    cy: 76,
    r: 18.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107579817108119527700000003059530818187331217_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.3512,
    y1: 99.6111,
    x2: 318.5622,
    y2: 53.3726
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D0D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5569FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000107579817108119527700000003059530818187331217_)"
    },
    d: "M329.3,76 c0,4.5-1.7,8.6-4.6,11.7c-3.1,3.4-7.6,5.5-12.6,5.5c-5.3,0-10.1-2.4-13.2-6.2c-2.5-3-3.9-6.8-3.9-10.9c0-9.5,7.7-17.2,17.2-17.2 C321.6,58.9,329.3,66.5,329.3,76z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051353795990305350720000008799843394545157821_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.8416,
    y1: 100.3226,
    x2: 321.0526,
    y2: 54.0842
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D0D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5569FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051353795990305350720000008799843394545157821_)"
    },
    d: "M324.7,87.7c-3.1,3.4-7.6,5.5-12.6,5.5 c-5.3,0-10.1-2.4-13.2-6.2c0.1,0,0.2-0.1,0.3-0.1c0.2-0.3,0.5-0.6,0.8-0.9c0,0,0-0.1,0-0.1l0.3-0.1c0.5-0.3,1.1-0.5,1.9-0.5 c0.2,0,0.4,0,0.6,0l1.1-0.2c0,0,0,0.1,0,0.3c1.4,0.1,3.4,0.2,5.8,0.4c0.5-0.4,0.9-0.9,1.1-1.5c0.2-0.6,0.2-1.3,0.2-2 c-0.8,0-1.7-0.3-2.4-0.6c-1.3-0.7-2.4-1.9-3-3.4c-0.1-0.2-0.1-0.4-0.2-0.6c-0.4-1.8-0.6-4.3-0.1-6.5c0,0,0,0,0,0 c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2-0.1-0.2-0.2c0,0,0,0,0,0c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0.1,0c-0.1-1.4,0.1-2.9,0.3-3.9 c-0.6-1-0.6-3.1,0-3.9c0.6-0.9,0.1-0.4,1.8-0.6c1.7-0.1,0.7-1.6,1.7-1.7c1.1,0,0.9,0.7,2.2,1.2c1.3,0.5,0.8-1,2.3-1.1 c1.5-0.1,1.7,1,2.8,1.3c1.1,0.3,1.3,0,2.1,0s0.9,2.3,1.2,2.7c0.3,0.4,0.9-0.2,1.6,1c0.1,0.2,0.1,0.3,0.1,0.6 c0,1.5-1.9,4.4-1.9,4.4c-0.1,0.7-0.2,1.4-0.4,2.1c0.6,0.5,0.7,1.4,0.3,2.3c-0.4,0.7-1,1.4-1.7,1.8c-0.4,0.8-0.7,1.4-1.1,1.9 c-0.5,2.6-0.7,5.7,0.2,7.7C319.7,86.7,322.6,87.1,324.7,87.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032635092276278172600000003383493178909680013_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.3519,
    y1: 99.6113,
    x2: 318.5629,
    y2: 53.3728
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D0D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5569FF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000032635092276278172600000003383493178909680013_)"
    },
    cx: 312.1,
    cy: 76,
    r: 18.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127028178231344890770000006022307403726885794_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.5111,
    y1: 168.1412,
    x2: 123.3276,
    y2: 193.2421
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5252D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2221A2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000127028178231344890770000006022307403726885794_)"
    },
    cx: 108.2,
    cy: 174.1,
    r: 18.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067957749945460454140000005826357818316951445_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.5115,
    y1: 168.1409,
    x2: 123.3279,
    y2: 193.2418
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5252D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2221A2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000067957749945460454140000005826357818316951445_)"
    },
    d: "M125.3,174.1 c0,4.4-1.7,8.4-4.4,11.4c-3.1,3.5-7.7,5.7-12.8,5.7c-3.8,0-7.3-1.2-10.1-3.3c-4.3-3.1-7.1-8.2-7.1-13.9 c0-9.5,7.7-17.2,17.2-17.2S125.3,164.6,125.3,174.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130629740463769013700000014891262266683690908_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.0798,
    y1: 169.2712,
    x2: 121.8963,
    y2: 194.372
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5252D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2221A2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130629740463769013700000014891262266683690908_)"
    },
    d: "M121,185.5c-3.1,3.5-7.7,5.7-12.8,5.7 c-3.8,0-7.3-1.2-10.1-3.3l6.8-2.1c0.1,0.1,0.2,0.3,0.4,0.5c0.3-0.1,0.6-0.1,0.9-0.2c0.5-0.1,1.1-0.2,1.6-0.3 c0.4-0.7,0.6-1.4,0.7-2.1c-0.6,0-0.9,0-0.9,0c0.2-0.7-0.8-2.1-0.8-2.1l-0.3,1.9c0,0-0.7-0.1-1.1-0.4c-0.5-0.3-1-2.3-1-2.3 s-1.2,2-1.4,2.4c-0.3,0.5-0.9,0-0.9,0s-0.5-1.7,0.1-3.5c0.6-1.8-1.2-1.7-1.2-1.7s0,0.7-0.5,1.9c-0.5,1.2-0.5,1.8-0.5,2.5 c0,0.7,0.1,1.2-0.5,1.2c-0.5,0-0.6-0.5-0.5-1.2c0.1-0.8-0.7-1.5-0.3-2.1c0.5-0.6,0.1-2.3,0.1-2.3c-0.3,1.2-1.6,1.1-1.8,2 c-0.2,0.9,0.6,2.1,0.2,2.5c-0.4,0.4-1.1,0-1.1,0s0.6-0.9,0.2-1.5c-0.4-0.5-1-0.8-0.7-1.9c0.3-1.1,0.8-1.1,0.6-2.3 c-0.2-1.2-0.7-1.2,0-1.6c0.7-0.5,1.7-2.6,1.7-3.6c0-0.9-0.4-3.1,1.2-3.9c1.6-0.8,2-1.4,1.7-3.4c-0.3-2,1.3-1.9,3.2-1.5 c0,0,1-1.5,1.9-1.3c0.9,0.3,1.6,0.1,1.8-0.4c0.2-0.5,2.7-0.5,3.1,0c0.4,0.5,1.7,0.8,2.6,0.5c0.8-0.3,3,1,2.9,1.9 c-0.1,0.9-0.1,1.4,1.1,2c1.2,0.5,1.4,0.8,1.9,2.8c0.5,2-0.3,2.9,0.7,3.7c1,0.8,0.9,3.9,1,4.9c0.1,1,0,2.1,0,2.1s0,0-0.3,0.1 c-0.3,0.1-0.5-1.1-0.5-1.9c0.1-0.8-1.7-2-1.9-2.1c0,0.1,0.4,0.8,0.6,1.3c0.2,0.6,0.3,2.1,0.2,3.1c-0.1,1,1.1,1.5,1.1,1.5 l-1.3,0.6c0,0-1-2.1-0.6-3.2c0.3-1.1-0.6-2-0.6-2v2c0,0-0.3,0.7-0.9,1.7c-0.5,1,0.4,1.3,0.5,1.8c0.1,0.5-1.1,0.5-1.1,0.5 l-0.2-1.2l-0.4,1.2c-0.5,0.3-1.4,0.6-2.5,0.8c0.1,0.9,0.3,1.6,0.5,2c0.4,0,0.8,0,1.2-0.1c0.8,0,1.6,0,2.5,0h0 C118.6,185.3,120,185.4,121,185.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064339830677454385160000012104679094568621717_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.5111,
    y1: 168.1412,
    x2: 123.3276,
    y2: 193.2421
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5252D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2221A2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000064339830677454385160000012104679094568621717_)"
    },
    cx: 108.2,
    cy: 174.1,
    r: 18.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055667497880245691500000013846337672179605891_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.2546,
    y1: 314.9836,
    x2: 125.4105,
    y2: 196.0847
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D0D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5569FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000055667497880245691500000013846337672179605891_)"
    },
    d: "M123.3,278.7c0,6.7-2.3,12.8-6.3,17.6 c-1.2,1.5-2.5,2.8-3.9,4c-0.5,0.4-0.9,0.8-1.4,1.1c-1.3,1-2.8,1.8-4.3,2.5c-3.6,1.7-7.6,2.7-11.9,2.7c-5.1,0-9.9-1.4-14-3.8 c-1.1-0.6-2.1-1.3-3-2h0c0,0-0.1-0.1-0.1-0.1c-1.1-0.9-2.2-1.9-3.1-2.9c-4.7-5-7.5-11.6-7.5-19c0-15.4,12.5-27.9,27.8-27.9 C110.8,250.8,123.3,263.3,123.3,278.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025419026854078345920000003111894982955338429_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.9357,
    y1: 356.9497,
    x2: 393.5303,
    y2: 279.0429
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D0D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2221A2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000025419026854078345920000003111894982955338429_)"
    },
    cx: 373.9,
    cy: 319.8,
    r: 24.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013891826993537576130000001456736605942269591_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.0986,
    y1: 224.8428,
    x2: 335.1859,
    y2: 224.8428
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D1E82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2221A2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013891826993537576130000001456736605942269591_)"
    },
    d: "M239.9,312.6c2.9,0.2,5.8,0.3,8.7,0.3 c24.5-0.4,46.9-10.9,62.8-27.7c13.2-14,21.9-32.4,23.6-53c0-0.5,0.1-1.1,0.1-1.6c0.7-11-0.6-21.8-3.7-31.7l0,0 c-9.5-30.5-35.3-54.4-67.9-60.5c-2.9-0.5-5.9-0.9-8.9-1.2c-7.3-0.6-14.5-0.3-21.4,0.8c-20.5,3.3-38.9,13.8-52.2,29 c-11.9,13.7-19.8,31.1-21.4,50.6c-0.9,10.4,0.1,20.6,2.7,30.2C171.5,282.6,201.9,309.4,239.9,312.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M454.6,100.7c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4S454.6,97.7,454.6,100.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M463.8,331.6c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4 C461.4,326.2,463.8,328.6,463.8,331.6z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M43.7,131.5c-0.1,4.5,2.3,8.5,6,10.6c1.7,1,3.8,1.6,5.9,1.6c2.8,0,5.3-0.9,7.3-2.5 c2.8-2.2,4.6-5.6,4.6-9.4c0-6.7-5.6-12.1-12.4-11.9C49,120.1,43.9,125.3,43.7,131.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M44.5,129.9c-1.3,7.7,5.3,14.2,13,13c4.7-0.8,8.4-4.5,9.2-9.2c1.3-7.7-5.3-14.2-13-13 C49.1,121.5,45.3,125.2,44.5,129.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M48.9,131.6c0.1,1.4,1.4,1.7,1.4,1.7s-0.3,0.8,0,1.7c0.3,0.9,2.2,0.9,2.2,0.9s0.2,0.5,0.8,0.6 c0,0.1,0.1,0.1,0.1,0.1c0.1,0.1,0.2,0.2,0.3,0.4c0.2,1.8,0.2,3.7-0.7,4.7c0,0,0,0,0,0c-0.8,0.1-1.5,0.2-2.3,0.3 c-0.4,0.1-0.7,0.1-1.1,0.2c1.7,1,3.8,1.6,5.9,1.6c2.8,0,5.3-0.9,7.3-2.5c-0.3,0-0.7,0-1.1,0c-0.6,0-1.3,0-2.1,0c0,0,0,0,0,0 c-1.3-0.2-1.9-0.8-2.2-1.6c-0.1-0.4-0.2-0.8-0.1-1.2c0.3-0.1,0.7-0.2,1-0.3c0.9-0.4,1.6-1.2,2-2.2c0.1-0.1,0.1-0.3,0.1-0.4 c0.3-1,0.4-2.3,0.3-3.5c0.3-0.2,0.7-0.5,0.8-1.1c0.2-1.2-0.8-1.5-0.8-1.5s1.2-0.2,1.2-1.7c0-1.5-1.2-1.5-1.2-1.5 s0.4-0.6-0.4-1.8c-0.8-1.2-2-0.4-2-0.4s-0.9-1.4-2.3-1.1c-1.5,0.3-1.8,1.2-1.8,1.2s0-0.9-1.6-0.4c-1.6,0.5-1.4,2.4-1.4,2.4 s-1.1-0.6-1.7,0.6c-0.6,1.2,0.7,3.3,0.7,3.3S48.8,130.2,48.9,131.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M43.7,131.5c-0.1,4.5,2.3,8.5,6,10.6c1.7,1,3.8,1.6,5.9,1.6c2.8,0,5.3-0.9,7.3-2.5 c2.8-2.2,4.6-5.6,4.6-9.4c0-6.7-5.6-12.1-12.4-11.9C49,120.1,43.9,125.3,43.7,131.5z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 23.3,
    cy: 302.6,
    r: 10.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M33.3,302.6c0,2.3-0.8,4.4-2.1,6.1c-1.8,2.3-4.7,3.9-7.9,3.9c-2.1,0-4-0.6-5.6-1.7 c-2.6-1.8-4.4-4.8-4.4-8.2c0-5.5,4.5-10,10-10S33.3,297.1,33.3,302.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.2,308.7c-1.8,2.3-4.7,3.9-7.9,3.9c-2.1,0-4-0.6-5.6-1.7c0.3-0.8,0.5-1.2,0.5-1.2 c1.2-0.4,2.5-0.7,3.8-0.9c0.3-0.3,0.8-0.5,1.3-0.6c0.3-0.8,0.1-1.7-0.1-2.3c-0.4-0.3-0.7-0.6-1-1c-0.2-0.1-0.4-0.3-0.5-0.5 c-0.3-0.1-2.4-1.1-2.5-4.6c0-0.1,0-0.3,0-0.4c-0.7-0.1-1.3,0.1-0.9,1.5c0.8,2.3,0,3.5,0,3.5c0-0.7-0.1-1.5-0.1-1.5 c0,2.4-1.3,2.5-1.3,2.5s0.8-0.9-0.4-3.5c-1.2-2.7-0.9-6.3,1.4-6.4c1.2-0.1,2.1,0.5,2.6,1.1c1.3-1.2,3.3-1.4,4.5-0.5 c0,0,2.1-0.5,2.7,0c0.1,0.1,0,0.4-0.2,0.8c0.5,0.4,1,0.9,1.2,1.7c0.3,1.4-0.1,2.5-0.6,3.2c0.3,2.6-0.2,4.6-2.3,4.8 c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0.5,0.1,0.9,0.1,1.1c0.3,0.1,0.6,0.1,0.9,0.2c1.9,0,4,0.2,4,0.2s0,0,0,0 C30.9,308.4,31.1,308.6,31.2,308.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st23",
    cx: 23.3,
    cy: 302.6,
    r: 10.6
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -53.6691 389.9604)",
    className: "st1",
    cx: 443.9,
    cy: 259.8,
    rx: 11.7,
    ry: 11.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M454.9,259.8c0,2.3-0.7,4.4-1.8,6.1c-2,3-5.3,4.9-9.2,4.9c-2.5,0-4.9-0.9-6.7-2.3c-2.6-2-4.3-5.2-4.3-8.7 c0-6.1,4.9-11,11-11C450,248.7,454.9,253.7,454.9,259.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M453.1,265.9c-2,3-5.3,4.9-9.2,4.9c-2.5,0-4.9-0.9-6.7-2.3c-0.1-0.7,0-1.3,0.1-1.8c0.1-1.3,1.7-2.4,1.7-3.4 c0-0.9-1.6-2.2-0.6-2.7s1.2-2.6,0.4-3.8c-0.7-0.8-1.2-2,0.1-3.6c0.8-1,1.9-1.4,3-1.6c0.8-0.4,1.8-0.6,3.3-0.5 c1.4,0.1,2.4,0.5,3.2,1.1c0.8,0.6,1.4,1.3,1.7,2.1c0,0,1.2,2.3,0.3,4.8c-0.6,1.6,1.9,1.5,2,2.9c0.1,1.4-1.1,1.5-0.9,2.5 C451.4,264.9,452.3,265.3,453.1,265.9z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -53.6691 389.9604)",
    className: "st24",
    cx: 443.9,
    cy: 259.8,
    rx: 11.7,
    ry: 11.7
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M290.7,109.1c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4 C288.3,103.7,290.7,106.1,290.7,109.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M50.2,226c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4C47.8,220.6,50.2,223.1,50.2,226z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M232.9,49.8c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4S232.9,46.9,232.9,49.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002371054825553479360000002890162382890321849_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.2746,
    y1: 119.2825,
    x2: 155.4873,
    y2: 45.2339
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D0D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5569FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002371054825553479360000002890162382890321849_)"
    },
    d: "M205.3,92c0,5.7-1.9,10.9-5.1,15 c-0.9,1.1-1.9,2.2-2.9,3.2c-1,0.9-2,1.7-3.2,2.4c0,0-0.1,0.1-0.1,0.1c-0.9,0.6-1.8,1.1-2.7,1.5c-3.2,1.5-6.8,2.4-10.6,2.4 c-7.5,0-14.3-3.4-18.8-8.7l0,0c-3.7-4.3-5.9-9.9-5.9-16c0-13.6,11.1-24.7,24.7-24.7C194.2,67.3,205.3,78.4,205.3,92z"
  })), /*#__PURE__*/React.createElement("g", null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M293.8,196.1c5,3.4,8.4,9.1,8.4,15.7c0,10.4-8.4,18.9-18.8,18.9c-0.2,0-0.5,0-0.7,0l10.8-33.3L293.8,196.1z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000091730436634202056210000001214149239709694086_",
    d: "M264.3,257.4L264.3,257.4L264.3,257.4l2.3-6.7 l18.1-55.8h-11.6h-5.6h0c-0.6,0-1.1,0.4-1.3,1.1c-4.9,14.2-16.1,47.8-21,62c0.2,0.2,0.5,0.3,0.9,0.3h0H263h0 C263.6,258.4,264.1,258,264.3,257.4z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000091730436634202056210000001214149239709694086_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105402430489132799050000003611007942099549351_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000091730436634202056210000001214149239709694086_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 267.3,
    y: 189.3,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -41.3708 335.517)",
    className: "st26",
    width: 22.9,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 272.6,
    y: 199.1,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -52.6361 334.9945)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "285.8,222.5 285.6,222.8 259.4,206.8 259.6,206.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 272.4,
    y: 199.5,
    transform: "matrix(0.5236 -0.852 0.852 0.5236 -53.2109 334.5185)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 272.3,
    y: 199.7,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -53.192 335.1122)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 272.1,
    y: 199.8,
    transform: "matrix(0.5239 -0.8518 0.8518 0.5239 -53.6576 334.3873)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 200,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -53.6232 335.0258)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 271.9,
    y: 200.2,
    transform: "matrix(0.5232 -0.8522 0.8522 0.5232 -53.9591 334.6541)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 200.4,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -54.0027 335.0807)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 271.7,
    y: 200.5,
    transform: "matrix(0.5229 -0.8524 0.8524 0.5229 -54.3219 334.7532)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 271.6,
    y: 200.7,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -54.4079 335.0652)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 271.5,
    y: 200.9,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -54.6621 334.9159)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 271.4,
    y: 201.1,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -54.8388 334.9787)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 271.3,
    y: 201.3,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -55.016 335.0416)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 271.2,
    y: 201.4,
    transform: "matrix(0.5213 -0.8534 0.8534 0.5213 -55.1163 335.3161)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 271.1,
    y: 201.6,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -55.4214 335.0259)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 201.8,
    transform: "matrix(0.5213 -0.8534 0.8534 0.5213 -55.5219 335.3005)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 270.8,
    y: 202,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -55.8266 335.0102)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 270.7,
    y: 202.1,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -56.0294 335.0024)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 270.6,
    y: 202.3,
    transform: "matrix(0.5215 -0.8533 0.8533 0.5215 -56.1559 335.2067)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 270.5,
    y: 202.5,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -56.4346 334.9867)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "283.7,225.9 283.6,226.2 257.4,210.1 257.6,209.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 270.3,
    y: 202.8,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -56.8401 334.971)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "283.5,226.3 283.4,226.5 257.2,210.5 257.3,210.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 270.1,
    y: 203.2,
    transform: "matrix(0.5233 -0.8522 0.8522 0.5233 -57.4136 334.4808)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 203.4,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -57.4481 334.9477)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 269.9,
    y: 203.6,
    transform: "matrix(0.5228 -0.8524 0.8524 0.5228 -57.7592 334.6331)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 269.8,
    y: 203.7,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -57.8534 334.9319)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 269.7,
    y: 203.9,
    transform: "matrix(0.5228 -0.8524 0.8524 0.5228 -58.1642 334.6172)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 269.5,
    y: 204.1,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -58.2587 334.9162)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 269.4,
    y: 204.3,
    transform: "matrix(0.5236 -0.852 0.852 0.5236 -58.6687 334.3171)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 269.3,
    y: 204.4,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -58.664 334.9005)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 269.2,
    y: 204.6,
    transform: "matrix(0.5223 -0.8527 0.8527 0.5223 -58.9073 334.7766)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 269.1,
    y: 204.8,
    transform: "matrix(0.5213 -0.8534 0.8534 0.5213 -58.9702 335.1688)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 269,
    y: 205,
    transform: "matrix(0.5223 -0.8527 0.8527 0.5223 -59.3126 334.7609)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 268.9,
    y: 205.1,
    transform: "matrix(0.5213 -0.8534 0.8534 0.5213 -59.3758 335.1533)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 268.8,
    y: 205.3,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -59.6774 334.8613)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 268.7,
    y: 205.5,
    transform: "matrix(0.5225 -0.8526 0.8526 0.5225 -59.9452 334.6661)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 268.6,
    y: 205.7,
    transform: "matrix(0.5217 -0.8531 0.8531 0.5217 -60.0337 334.988)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 268.5,
    y: 205.9,
    transform: "matrix(0.5228 -0.8524 0.8524 0.5228 -60.3903 334.534)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 268.4,
    y: 206,
    transform: "matrix(0.5217 -0.8531 0.8531 0.5217 -60.439 334.9724)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 268.2,
    y: 206.2,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -60.7154 334.7509)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 268.1,
    y: 206.4,
    transform: "matrix(0.5217 -0.8531 0.8531 0.5217 -60.8445 334.9568)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "281.4,229.8 281.2,230.1 255,214 255.2,213.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 267.9,
    y: 206.7,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -61.2988 334.7986)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 267.8,
    y: 206.9,
    transform: "matrix(0.5227 -0.8525 0.8525 0.5227 -61.5875 334.5392)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 267.7,
    y: 207.1,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -61.7528 334.6402)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 267.6,
    y: 207.3,
    transform: "matrix(0.5227 -0.8525 0.8525 0.5227 -61.9925 334.5234)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 267.5,
    y: 207.4,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -62.158 334.6246)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 267.4,
    y: 207.6,
    transform: "matrix(0.5234 -0.8521 0.8521 0.5234 -62.4941 334.2216)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 267.3,
    y: 207.8,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -62.5631 334.6087)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 267.2,
    y: 208,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -62.7377 334.6841)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 267.1,
    y: 208.2,
    transform: "matrix(0.5217 -0.8531 0.8531 0.5217 -62.8721 334.8789)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 266.9,
    y: 208.3,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -63.143 334.6684)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 266.8,
    y: 208.5,
    transform: "matrix(0.5217 -0.8531 0.8531 0.5217 -63.2775 334.8633)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 266.7,
    y: 208.7,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -63.5482 334.6526)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 266.6,
    y: 208.9,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -63.7787 334.5616)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 266.5,
    y: 209,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -63.9534 334.6369)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 266.4,
    y: 209.2,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -64.1839 334.5457)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "279.6,232.6 279.5,232.9 253.3,216.9 253.4,216.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 266.2,
    y: 209.6,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -64.5416 334.6734)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "279.4,233 279.2,233.3 253.1,217.2 253.2,216.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 209.9,
    transform: "matrix(0.5235 -0.852 0.852 0.5235 -65.1396 334.0728)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 265.9,
    y: 210.1,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -65.1693 334.5899)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 265.8,
    y: 210.3,
    transform: "matrix(0.5232 -0.8522 0.8522 0.5232 -65.4973 334.2005)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 265.6,
    y: 210.5,
    transform: "matrix(0.5219 -0.853 0.853 0.5219 -65.5361 334.6913)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 265.5,
    y: 210.6,
    transform: "matrix(0.5228 -0.8525 0.8525 0.5228 -65.8553 334.328)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 265.4,
    y: 210.8,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -65.9837 334.5468)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 265.3,
    y: 211,
    transform: "matrix(0.5225 -0.8526 0.8526 0.5225 -66.226 334.4174)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 265.2,
    y: 211.2,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -66.3889 334.531)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 265.1,
    y: 211.3,
    transform: "matrix(0.5223 -0.8528 0.8528 0.5223 -66.5955 334.5115)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 211.5,
    transform: "matrix(0.5213 -0.8534 0.8534 0.5213 -66.6778 334.8742)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 264.9,
    y: 211.7,
    transform: "matrix(0.5221 -0.8529 0.8529 0.5221 -66.9775 334.5677)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 264.8,
    y: 211.9,
    transform: "matrix(0.5213 -0.8534 0.8534 0.5213 -67.0834 334.8586)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 264.7,
    y: 212,
    transform: "matrix(0.5221 -0.8529 0.8529 0.5221 -67.3827 334.552)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 264.6,
    y: 212.2,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -67.5817 334.5559)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 264.5,
    y: 212.4,
    transform: "matrix(0.5223 -0.8527 0.8527 0.5223 -67.822 334.4304)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 264.3,
    y: 212.6,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -67.987 334.5402)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "277.6,236 277.4,236.3 251.2,220.2 251.4,220  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 264.1,
    y: 212.9,
    transform: "matrix(0.5228 -0.8524 0.8524 0.5228 -68.4903 334.2171)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "277.4,236.3 277.2,236.6 251,220.6 251.2,220.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 263.9,
    y: 213.3,
    transform: "matrix(0.5233 -0.8522 0.8522 0.5233 -68.9506 334.0265)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 263.8,
    y: 213.5,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -69.0005 334.501)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 263.7,
    y: 213.6,
    transform: "matrix(0.5227 -0.8525 0.8525 0.5227 -69.2873 334.2271)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 263.6,
    y: 213.8,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -69.4057 334.4853)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 263.5,
    y: 214,
    transform: "matrix(0.5227 -0.8525 0.8525 0.5227 -69.6923 334.2112)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 263.4,
    y: 214.2,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -69.8111 334.4698)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 263.3,
    y: 214.3,
    transform: "matrix(0.5227 -0.8525 0.8525 0.5227 -70.0973 334.1954)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 263.2,
    y: 214.5,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -70.2163 334.454)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 214.7,
    transform: "matrix(0.5221 -0.8529 0.8529 0.5221 -70.4227 334.4345)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 262.9,
    y: 214.9,
    transform: "matrix(0.5213 -0.8534 0.8534 0.5213 -70.5316 334.7269)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 262.8,
    y: 215.1,
    transform: "matrix(0.5223 -0.8528 0.8528 0.5223 -70.8506 334.3466)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 262.7,
    y: 215.2,
    transform: "matrix(0.5213 -0.8534 0.8534 0.5213 -70.9372 334.7114)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 262.6,
    y: 215.4,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -71.2782 334.2585)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 262.5,
    y: 215.6,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -71.4549 334.3347)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 262.4,
    y: 215.8,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -71.6834 334.2427)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 215.9,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -71.8601 334.3189)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 262.2,
    y: 216.1,
    transform: "matrix(0.5217 -0.8531 0.8531 0.5217 -71.9995 334.5166)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 262.1,
    y: 216.3,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -72.2432 334.3756)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 216.5,
    transform: "matrix(0.522 -0.853 0.853 0.522 -72.4376 334.3944)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "275.2,239.9 275,240.2 248.8,224.1 249,223.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 261.7,
    y: 216.8,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -72.8918 334.2189)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "275,240.2 274.8,240.5 248.6,224.5 248.8,224.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 261.5,
    y: 217.2,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -73.2969 334.2031)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 261.4,
    y: 217.4,
    transform: "matrix(0.5225 -0.8526 0.8526 0.5225 -73.5148 334.1452)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 261.3,
    y: 217.5,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -73.6802 334.2601)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 261.2,
    y: 217.7,
    transform: "matrix(0.5225 -0.8526 0.8526 0.5225 -73.9198 334.1294)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 261.1,
    y: 217.9,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -74.0854 334.2443)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 218.1,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -74.2916 334.2248)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 260.9,
    y: 218.2,
    transform: "matrix(0.5216 -0.8532 0.8532 0.5216 -74.4255 334.4464)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 260.8,
    y: 218.4,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -74.6968 334.209)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 260.7,
    y: 218.6,
    transform: "matrix(0.5216 -0.8532 0.8532 0.5216 -74.8309 334.4308)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 260.6,
    y: 218.8,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -75.1021 334.1933)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 260.4,
    y: 218.9,
    transform: "matrix(0.5215 -0.8533 0.8533 0.5215 -75.2148 334.4878)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 260.3,
    y: 219.1,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -75.5074 334.1775)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 260.2,
    y: 219.3,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -75.7067 334.1815)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 260.1,
    y: 219.5,
    transform: "matrix(0.5215 -0.8533 0.8533 0.5215 -75.8267 334.4529)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 219.7,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -76.112 334.1657)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 259.9,
    y: 219.8,
    transform: "matrix(0.5221 -0.8529 0.8529 0.5221 -76.2988 334.2113)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 259.8,
    y: 220,
    transform: "matrix(0.5231 -0.8523 0.8523 0.5231 -76.6252 333.7814)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 259.7,
    y: 220.2,
    transform: "matrix(0.5228 -0.8525 0.8525 0.5228 -76.7895 333.9041)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 259.6,
    y: 220.4,
    transform: "matrix(0.5234 -0.8521 0.8521 0.5234 -77.0646 333.6465)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 259.5,
    y: 220.5,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -77.1251 334.1264)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 259.4,
    y: 220.7,
    transform: "matrix(0.5225 -0.8526 0.8526 0.5225 -77.3637 333.9954)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 259.3,
    y: 220.9,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -77.5303 334.1108)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 259.1,
    y: 221.1,
    transform: "matrix(0.5225 -0.8526 0.8526 0.5225 -77.7688 333.9796)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 221.2,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -77.9355 334.095)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 258.9,
    y: 221.4,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -78.1207 334.1486)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: 221.6,
    transform: "matrix(0.5213 -0.8534 0.8534 0.5213 -78.2358 334.444)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 258.7,
    y: 221.8,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -78.5259 334.1328)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 258.6,
    y: 222,
    transform: "matrix(0.5215 -0.8533 0.8533 0.5215 -78.6624 334.3557)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 258.5,
    y: 222.1,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -78.9313 334.1172)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 258.4,
    y: 222.3,
    transform: "matrix(0.5217 -0.8531 0.8531 0.5217 -79.0922 334.2553)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 258.3,
    y: 222.5,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -79.3366 334.1015)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 258.2,
    y: 222.7,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -79.5601 334.0204)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "271.4,246.1 271.2,246.3 245,230.3 245.2,230  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 223,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -79.9861 333.9315)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "271.2,246.4 271,246.7 244.8,230.7 245,230.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "271.1,246.6 270.9,246.9 244.7,230.8 244.9,230.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 257.6,
    y: 223.5,
    transform: "matrix(0.5221 -0.8529 0.8529 0.5221 -80.556 334.0428)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 257.5,
    y: 223.7,
    transform: "matrix(0.5236 -0.852 0.852 0.5236 -80.9301 333.4213)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 257.4,
    y: 223.9,
    transform: "matrix(0.5221 -0.8529 0.8529 0.5221 -80.9613 334.0271)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 257.3,
    y: 224.1,
    transform: "matrix(0.5229 -0.8524 0.8524 0.5229 -81.2533 333.699)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 257.2,
    y: 224.3,
    transform: "matrix(0.5223 -0.8528 0.8528 0.5223 -81.387 333.9382)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 257.1,
    y: 224.4,
    transform: "matrix(0.5227 -0.8525 0.8525 0.5227 -81.6379 333.7565)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 224.6,
    transform: "matrix(0.5221 -0.8529 0.8529 0.5221 -81.7719 333.9958)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 256.9,
    y: 224.8,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -82.012 333.8529)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 256.8,
    y: 225,
    transform: "matrix(0.5213 -0.8534 0.8534 0.5213 -82.0961 334.2733)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 256.7,
    y: 225.1,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -82.4171 333.8371)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 256.5,
    y: 225.3,
    transform: "matrix(0.5213 -0.8534 0.8534 0.5213 -82.5018 334.2578)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 256.4,
    y: 225.5,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -82.7821 333.9684)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 256.3,
    y: 225.7,
    transform: "matrix(0.5213 -0.8534 0.8534 0.5213 -82.9074 334.2422)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 256.2,
    y: 225.8,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -83.1873 333.9526)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 256.1,
    y: 226,
    transform: "matrix(0.5221 -0.8529 0.8529 0.5221 -83.3933 333.933)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 226.2,
    transform: "matrix(0.5215 -0.8533 0.8533 0.5215 -83.5327 334.1575)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 255.9,
    y: 226.4,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -83.7922 333.9407)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 255.8,
    y: 226.6,
    transform: "matrix(0.5215 -0.8533 0.8533 0.5215 -83.9383 334.1419)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "269,250 268.8,250.2 242.7,234.2 242.8,233.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "268.9,250.1 268.7,250.4 242.5,234.4 242.7,234.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 255.5,
    y: 227.1,
    transform: "matrix(0.5229 -0.8524 0.8524 0.5229 -84.6996 333.5487)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 255.4,
    y: 227.3,
    transform: "matrix(0.5225 -0.8526 0.8526 0.5225 -84.8608 333.6959)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 255.2,
    y: 227.4,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -85.0261 333.8276)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 255.1,
    y: 227.6,
    transform: "matrix(0.5225 -0.8526 0.8526 0.5225 -85.2659 333.6802)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 227.8,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -85.4313 333.8118)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 254.9,
    y: 228,
    transform: "matrix(0.5221 -0.8529 0.8529 0.5221 -85.6225 333.8469)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 254.8,
    y: 228.1,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -85.8417 333.7771)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 254.7,
    y: 228.3,
    transform: "matrix(0.5223 -0.8528 0.8528 0.5223 -86.0473 333.7574)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 254.6,
    y: 228.5,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -86.2469 333.7613)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 254.5,
    y: 228.7,
    transform: "matrix(0.5218 -0.8531 0.8531 0.5218 -86.4037 333.9281)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 254.4,
    y: 228.9,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -86.6328 333.8195)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 254.3,
    y: 229,
    transform: "matrix(0.5215 -0.8533 0.8533 0.5215 -86.7743 334.0447)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 254.2,
    y: 229.2,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -87.0381 333.8036)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 254.1,
    y: 229.4,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -87.2571 333.7338)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "267.3,252.8 267.1,253.1 240.9,237 241.1,236.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 253.8,
    y: 229.7,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -87.6623 333.718)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 253.7,
    y: 229.9,
    transform: "matrix(0.5217 -0.8531 0.8531 0.5217 -87.8105 333.9203)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "267,253.3 266.8,253.6 240.6,237.6 240.8,237.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 253.5,
    y: 230.3,
    transform: "matrix(0.5217 -0.8531 0.8531 0.5217 -88.216 333.9047)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "266.7,253.7 266.6,254 240.4,237.9 240.5,237.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 253.3,
    y: 230.6,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -88.6785 333.667)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 253.2,
    y: 230.8,
    transform: "matrix(0.5225 -0.8527 0.8527 0.5225 -88.9072 333.5577)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 253.1,
    y: 231,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -89.0837 333.6514)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 231.2,
    transform: "matrix(0.5227 -0.8525 0.8525 0.5227 -89.3311 333.4678)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 252.9,
    y: 231.3,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -89.5078 333.5615)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 252.8,
    y: 231.5,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -89.6917 333.6279)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 252.6,
    y: 231.7,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -89.9129 333.5457)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 252.5,
    y: 231.9,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -90.0969 333.6122)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 252.4,
    y: 232,
    transform: "matrix(0.5217 -0.8531 0.8531 0.5217 -90.2435 333.8269)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 252.3,
    y: 232.2,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -90.5022 333.5965)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 252.2,
    y: 232.4,
    transform: "matrix(0.5217 -0.8531 0.8531 0.5217 -90.652 333.7994)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 252.1,
    y: 232.6,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -90.9074 333.5807)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 232.7,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -91.1316 333.4865)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 251.9,
    y: 232.9,
    transform: "matrix(0.521 -0.8536 0.8536 0.521 -91.19 334.0575)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 251.8,
    y: 233.1,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -91.5367 333.4708)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "265,256.5 264.8,256.8 238.6,240.7 238.8,240.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 251.6,
    y: 233.5,
    transform: "matrix(0.5236 -0.852 0.852 0.5236 -92.0583 332.9809)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "264.8,256.9 264.6,257.1 238.4,241.1 238.6,240.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 251.3,
    y: 233.8,
    transform: "matrix(0.5232 -0.8522 0.8522 0.5232 -92.4266 333.1141)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 251.2,
    y: 234,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -92.5103 333.5923)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 251.1,
    y: 234.2,
    transform: "matrix(0.5227 -0.8525 0.8525 0.5227 -92.7772 333.3217)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 234.3,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -92.9155 333.5767)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 250.9,
    y: 234.5,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -93.1527 333.4273)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 250.8,
    y: 234.7,
    transform: "matrix(0.5223 -0.8527 0.8527 0.5223 -93.3504 333.4393)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 250.7,
    y: 234.9,
    transform: "matrix(0.5213 -0.8534 0.8534 0.5213 -93.4514 333.8509)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 250.6,
    y: 235,
    transform: "matrix(0.5226 -0.8526 0.8526 0.5226 -93.7849 333.3017)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 250.5,
    y: 235.2,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -93.929 333.5375)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 250.4,
    y: 235.4,
    transform: "matrix(0.5213 -0.8534 0.8534 0.5213 -94.0629 333.8158)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 250.3,
    y: 235.6,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -94.3344 333.5217)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 250.2,
    y: 235.8,
    transform: "matrix(0.5213 -0.8534 0.8534 0.5213 -94.4684 333.8003)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 235.9,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -94.7397 333.506)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 249.9,
    y: 236.1,
    transform: "matrix(0.5221 -0.8529 0.8529 0.5221 -94.9452 333.4864)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 249.8,
    y: 236.3,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -95.1449 333.4904)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 249.7,
    y: 236.5,
    transform: "matrix(0.5221 -0.8529 0.8529 0.5221 -95.3505 333.4707)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "262.9,259.9 262.8,260.1 236.6,244.1 236.8,243.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "262.8,260.1 262.7,260.3 236.5,244.3 236.6,244  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "262.7,260.2 262.6,260.5 236.4,244.5 236.5,244.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "262.6,260.4 262.5,260.7 236.3,244.6 236.4,244.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 249.2,
    y: 237.3,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -96.3786 333.3686)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 249.1,
    y: 237.5,
    transform: "matrix(0.5225 -0.8526 0.8526 0.5225 -96.6079 333.2463)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 237.7,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -96.7837 333.353)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 248.9,
    y: 237.9,
    transform: "matrix(0.5229 -0.8524 0.8524 0.5229 -97.0475 333.0808)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 248.7,
    y: 238.1,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -97.1717 333.4122)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 248.6,
    y: 238.2,
    transform: "matrix(0.5217 -0.8531 0.8531 0.5217 -97.3398 333.5541)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 248.5,
    y: 238.4,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -97.577 333.3965)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 248.4,
    y: 238.6,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -97.7797 333.3887)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 248.3,
    y: 238.8,
    transform: "matrix(0.5213 -0.8534 0.8534 0.5213 -97.9138 333.6804)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 248.2,
    y: 238.9,
    transform: "matrix(0.522 -0.8529 0.8529 0.522 -98.1851 333.373)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 248.1,
    y: 239.1,
    transform: "matrix(0.5213 -0.8534 0.8534 0.5213 -98.3194 333.6648)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 239.3,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -98.6245 333.2071)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 247.9,
    y: 239.5,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -98.8102 333.2744)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 247.8,
    y: 239.6,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -99.0296 333.1913)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 247.7,
    y: 239.8,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -99.2154 333.2586)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 247.6,
    y: 240,
    transform: "matrix(0.5217 -0.8531 0.8531 0.5217 -99.3674 333.4762)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 247.4,
    y: 240.2,
    transform: "matrix(0.5234 -0.8521 0.8521 0.5234 -99.7302 332.752)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 247.3,
    y: 240.4,
    transform: "matrix(0.5217 -0.8531 0.8531 0.5217 -99.7728 333.4605)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "260.6,263.8 260.4,264 234.2,248 234.4,247.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 247.1,
    y: 240.7,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -100.2453 333.1441)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 240.9,
    transform: "matrix(0.5225 -0.8526 0.8526 0.5225 -100.4566 333.0964)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 246.9,
    y: 241.1,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -100.6504 333.1284)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 246.8,
    y: 241.2,
    transform: "matrix(0.5227 -0.8525 0.8525 0.5227 -100.8784 333.0055)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 246.7,
    y: 241.4,
    transform: "matrix(0.5224 -0.8527 0.8527 0.5224 -101.0556 333.1127)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 246.6,
    y: 241.6,
    transform: "matrix(0.5218 -0.8531 0.8531 0.5218 -101.2026 333.3582)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 246.5,
    y: 241.8,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -101.4442 333.1723)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 246.4,
    y: 241.9,
    transform: "matrix(0.5228 -0.8524 0.8524 0.5228 -101.7005 332.9182)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 246.3,
    y: 242.1,
    transform: "matrix(0.5223 -0.8528 0.8528 0.5223 -101.854 333.1365)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 246.1,
    y: 242.3,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -102.0522 333.1486)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 242.5,
    transform: "matrix(0.5223 -0.8528 0.8528 0.5223 -102.2592 333.1208)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 245.9,
    y: 242.7,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -102.4575 333.1328)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 245.8,
    y: 242.8,
    transform: "matrix(0.5217 -0.8531 0.8531 0.5217 -102.6114 333.3513)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 245.7,
    y: 243,
    transform: "matrix(0.5222 -0.8528 0.8528 0.5222 -102.8626 333.1172)",
    className: "st26",
    width: 0.3,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105402430489132799050000003611007942099549351_)"
    }
  }, _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "258.9,266.4 258.9,266.5 232.7,250.4 232.7,250.4  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000085954445174727551070000010133096921220186755_",
    d: "M264.3,257.4L264.3,257.4L264.3,257.4l2.3-6.7 l18.1-55.8L245.2,258l1.8,0.3h16h0C263.6,258.4,264.1,258,264.3,257.4z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085954445174727551070000010133096921220186755_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000146476583679508081940000006441534996368659588_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085954445174727551070000010133096921220186755_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 240.7,
    y: 233.7,
    transform: "matrix(0.3107 -0.9505 0.9505 0.3107 -51.6803 414.1913)",
    className: "st26",
    width: 38.1,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 265.5,
    y: 215.5,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 -30.2634 407.4073)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 265.6,
    y: 215.4,
    transform: "matrix(0.3109 -0.9505 0.9505 0.3109 -30.1624 407.1946)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 265.6,
    y: 215.2,
    transform: "matrix(0.3097 -0.9508 0.9508 0.3097 -29.7416 407.4991)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 265.7,
    y: 215,
    transform: "matrix(0.3105 -0.9506 0.9506 0.3105 -29.7106 407.1743)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 265.7,
    y: 214.9,
    transform: "matrix(0.3112 -0.9504 0.9504 0.3112 -29.641 406.9114)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "257.3,221.1 257.4,220.8 274.6,226.4 274.5,226.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 265.9,
    y: 214.5,
    transform: "matrix(0.31 -0.9507 0.9507 0.31 -29.0225 407.1587)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 265.9,
    y: 214.4,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 -28.8872 407.0025)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 214.2,
    transform: "matrix(0.3102 -0.9507 0.9507 0.3102 -28.6851 406.9532)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 214.1,
    transform: "matrix(0.3106 -0.9506 0.9506 0.3106 -28.5564 406.7868)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 266.1,
    y: 213.9,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 -28.3143 406.8017)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 266.1,
    y: 213.7,
    transform: "matrix(0.3126 -0.9499 0.9499 0.3126 -28.5648 406.0267)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "257.7,219.9 257.8,219.7 274.9,225.3 274.8,225.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 266.2,
    y: 213.4,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 -27.7248 406.628)",
    className: "st26",
    width: 0.3,
    height: 18.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 266.3,
    y: 213.2,
    transform: "matrix(0.3101 -0.9507 0.9507 0.3101 -27.4989 406.6166)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 266.3,
    y: 213.1,
    transform: "matrix(0.3101 -0.9507 0.9507 0.3101 -27.3071 406.5511)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 266.4,
    y: 212.9,
    transform: "matrix(0.3108 -0.9505 0.9505 0.3108 -27.2488 406.2727)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 266.4,
    y: 212.7,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 -26.9499 406.3781)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    x: 266.5,
    y: 212.6,
    transform: "matrix(0.3112 -0.9503 0.9503 0.3112 -26.9352 406.0306)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "258.1,218.8 258.1,218.5 275.3,224.1 275.2,224.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 266.6,
    y: 212.2,
    transform: "matrix(0.3106 -0.9506 0.9506 0.3106 -26.4236 406.1033)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    x: 266.7,
    y: 212.1,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 -26.2032 406.0833)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 266.7,
    y: 211.9,
    transform: "matrix(0.31 -0.9507 0.9507 0.31 -25.9202 406.162)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    x: 266.8,
    y: 211.7,
    transform: "matrix(0.3098 -0.9508 0.9508 0.3098 -25.7 406.1414)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    x: 266.8,
    y: 211.6,
    transform: "matrix(0.3099 -0.9508 0.9508 0.3099 -25.5265 406.0471)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    x: 266.9,
    y: 211.4,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 -25.3998 405.8784)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    x: 266.9,
    y: 211.3,
    transform: "matrix(0.3121 -0.9501 0.9501 0.3121 -25.5552 405.2654)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "258.5,217.4 258.6,217.2 275.7,222.8 275.7,223  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 210.9,
    transform: "matrix(0.3098 -0.9508 0.9508 0.3098 -24.7309 405.8291)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    x: 267.1,
    y: 210.8,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 -24.6247 405.6289)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    x: 267.1,
    y: 210.6,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 -24.4597 405.5215)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    x: 267.2,
    y: 210.4,
    transform: "matrix(0.31 -0.9507 0.9507 0.31 -24.1783 405.5964)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    x: 267.3,
    y: 210.3,
    transform: "matrix(0.3098 -0.9508 0.9508 0.3098 -23.9475 405.5919)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    x: 267.3,
    y: 210.1,
    transform: "matrix(0.3112 -0.9504 0.9504 0.3112 -24.0222 405.1093)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "258.9,216.3 259,216 276.1,221.6 276,221.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    x: 267.4,
    y: 209.8,
    transform: "matrix(0.3109 -0.9505 0.9505 0.3109 -23.5771 405.075)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    x: 267.5,
    y: 209.6,
    transform: "matrix(0.31 -0.9507 0.9507 0.31 -23.2093 405.2844)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    x: 267.5,
    y: 209.4,
    transform: "matrix(0.311 -0.9504 0.9504 0.311 -23.2186 404.9052)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    x: 267.6,
    y: 209.3,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 -22.8812 405.067)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    x: 267.6,
    y: 209.1,
    transform: "matrix(0.3112 -0.9504 0.9504 0.3112 -22.8602 404.7354)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    x: 267.7,
    y: 208.9,
    transform: "matrix(0.3098 -0.9508 0.9508 0.3098 -22.3972 405.0918)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    x: 267.7,
    y: 208.8,
    transform: "matrix(0.3122 -0.95 0.95 0.3122 -22.6793 404.2896)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    x: 267.8,
    y: 208.6,
    transform: "matrix(0.3113 -0.9503 0.9503 0.3113 -22.3112 404.499)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    x: 267.9,
    y: 208.5,
    transform: "matrix(0.311 -0.9504 0.9504 0.311 -22.0565 404.5314)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    x: 267.9,
    y: 208.3,
    transform: "matrix(0.3098 -0.9508 0.9508 0.3098 -21.6302 404.8289)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 208.1,
    transform: "matrix(0.3106 -0.9506 0.9506 0.3106 -21.5827 404.5408)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 208,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 -21.36 404.5228)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    x: 268.1,
    y: 207.8,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 -21.1376 404.5049)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    x: 268.1,
    y: 207.6,
    transform: "matrix(0.3099 -0.9508 0.9508 0.3099 -20.8756 404.5472)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    x: 268.2,
    y: 207.5,
    transform: "matrix(0.3116 -0.9502 0.9502 0.3116 -21.0151 403.9716)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    x: 268.2,
    y: 207.3,
    transform: "matrix(0.3098 -0.9508 0.9508 0.3098 -20.4674 404.4538)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    x: 268.3,
    y: 207.1,
    transform: "matrix(0.3097 -0.9508 0.9508 0.3097 -20.2428 404.4389)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    x: 268.3,
    y: 207,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 -20.1975 404.1484)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    x: 268.4,
    y: 206.8,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 -19.975 404.1304)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    x: 268.4,
    y: 206.6,
    transform: "matrix(0.311 -0.9504 0.9504 0.311 -19.9263 403.8456)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    x: 268.5,
    y: 206.5,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 -19.6167 403.9611)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    x: 268.5,
    y: 206.3,
    transform: "matrix(0.3127 -0.9499 0.9499 0.3127 -19.865 403.2213)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "260.1,212.5 260.2,212.2 277.4,217.9 277.3,218.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    x: 268.7,
    y: 206,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 -19.0333 403.7768)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "260.2,212.2 260.3,211.9 277.5,217.5 277.4,217.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    x: 268.8,
    y: 205.7,
    transform: "matrix(0.3101 -0.9507 0.9507 0.3101 -18.5857 403.7433)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    x: 268.8,
    y: 205.5,
    transform: "matrix(0.31 -0.9507 0.9507 0.31 -18.365 403.7221)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    x: 268.9,
    y: 205.3,
    transform: "matrix(0.311 -0.9504 0.9504 0.311 -18.3769 403.3468)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    x: 268.9,
    y: 205.2,
    transform: "matrix(0.3106 -0.9506 0.9506 0.3106 -18.0959 403.4174)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "260.5,211.3 260.6,211.1 277.7,216.7 277.6,216.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    x: 269,
    y: 204.8,
    transform: "matrix(0.3102 -0.9507 0.9507 0.3102 -17.6414 403.3942)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    x: 269.1,
    y: 204.7,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 -17.4855 403.2748)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    x: 269.1,
    y: 204.5,
    transform: "matrix(0.3095 -0.9509 0.9509 0.3095 -17.1127 403.4824)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    x: 269.2,
    y: 204.3,
    transform: "matrix(0.3094 -0.9509 0.9509 0.3094 -16.8898 403.4638)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    x: 269.2,
    y: 204.2,
    transform: "matrix(0.3106 -0.9506 0.9506 0.3106 -16.9335 403.0431)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    x: 269.3,
    y: 204,
    transform: "matrix(0.3106 -0.9506 0.9506 0.3106 -16.7399 402.9808)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    x: 269.4,
    y: 203.8,
    transform: "matrix(0.3121 -0.9501 0.9501 0.3121 -16.8451 402.4674)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "260.9,210 261,209.8 278.2,215.4 278.1,215.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    x: 269.5,
    y: 203.5,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 -16.1205 402.8507)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    x: 269.5,
    y: 203.3,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 -15.9064 402.8194)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    x: 269.6,
    y: 203.2,
    transform: "matrix(0.3112 -0.9504 0.9504 0.3112 -15.8888 402.4925)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    x: 269.6,
    y: 203,
    transform: "matrix(0.3097 -0.9508 0.9508 0.3097 -15.3977 402.8757)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    x: 269.7,
    y: 202.9,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 -15.3526 402.5906)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "261.2,209 261.3,208.8 278.5,214.4 278.4,214.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    x: 269.8,
    y: 202.5,
    transform: "matrix(0.3127 -0.9499 0.9499 0.3127 -15.4146 401.7934)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    x: 269.8,
    y: 202.4,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 -14.7438 402.4447)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    x: 269.9,
    y: 202.2,
    transform: "matrix(0.3111 -0.9504 0.9504 0.3111 -14.718 402.1317)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    x: 269.9,
    y: 202,
    transform: "matrix(0.3106 -0.9506 0.9506 0.3106 -14.4152 402.2322)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 201.9,
    transform: "matrix(0.3109 -0.9505 0.9505 0.3109 -14.2805 402.082)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    x: 270.1,
    y: 201.7,
    transform: "matrix(0.3097 -0.9508 0.9508 0.3097 -13.8471 402.3753)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    x: 270.1,
    y: 201.5,
    transform: "matrix(0.3106 -0.9506 0.9506 0.3106 -13.8324 402.0475)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    x: 270.2,
    y: 201.4,
    transform: "matrix(0.3116 -0.9502 0.9502 0.3116 -13.8519 401.6686)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    x: 270.2,
    y: 201.2,
    transform: "matrix(0.3101 -0.9507 0.9507 0.3101 -13.3563 402.0542)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    x: 270.3,
    y: 201,
    transform: "matrix(0.3106 -0.9506 0.9506 0.3106 -13.2528 401.8579)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    x: 270.3,
    y: 200.9,
    transform: "matrix(0.3102 -0.9507 0.9507 0.3102 -12.9914 401.8957)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    x: 270.4,
    y: 200.7,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 -12.8359 401.7766)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    x: 270.4,
    y: 200.5,
    transform: "matrix(0.31 -0.9507 0.9507 0.31 -12.5517 401.8477)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    x: 270.5,
    y: 200.4,
    transform: "matrix(0.3102 -0.9507 0.9507 0.3102 -12.4102 401.708)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    x: 270.5,
    y: 200.2,
    transform: "matrix(0.3113 -0.9503 0.9503 0.3113 -12.4359 401.3226)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "262.1,206.4 262.2,206.1 279.3,211.8 279.3,212  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    x: 270.6,
    y: 199.9,
    transform: "matrix(0.3098 -0.9508 0.9508 0.3098 -11.7469 401.6414)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    x: 270.7,
    y: 199.7,
    transform: "matrix(0.3107 -0.9505 0.9505 0.3107 -11.731 401.3177)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    x: 270.8,
    y: 199.6,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 -11.4711 401.3528)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    x: 270.8,
    y: 199.4,
    transform: "matrix(0.3109 -0.9505 0.9505 0.3109 -11.3752 401.1468)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    x: 270.9,
    y: 199.2,
    transform: "matrix(0.3101 -0.9507 0.9507 0.3101 -11.0312 401.3045)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    x: 270.9,
    y: 199.1,
    transform: "matrix(0.3111 -0.9504 0.9504 0.3111 -11.0388 400.9476)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 198.9,
    transform: "matrix(0.3121 -0.9501 0.9501 0.3121 -11.0387 400.6022)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 198.7,
    transform: "matrix(0.3109 -0.9505 0.9505 0.3109 -10.6004 400.8974)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    x: 271.1,
    y: 198.6,
    transform: "matrix(0.31 -0.9507 0.9507 0.31 -10.2262 401.0981)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    x: 271.1,
    y: 198.4,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 -10.1218 400.9056)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    x: 271.2,
    y: 198.2,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 -9.9211 400.8532)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    x: 271.2,
    y: 198.1,
    transform: "matrix(0.3106 -0.9506 0.9506 0.3106 -9.7662 400.7348)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    x: 271.3,
    y: 197.9,
    transform: "matrix(0.3098 -0.9508 0.9508 0.3098 -9.4214 400.8911)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    x: 271.3,
    y: 197.7,
    transform: "matrix(0.3126 -0.9499 0.9499 0.3126 -9.796 400.0041)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "262.9,203.9 263,203.7 280.2,209.3 280.1,209.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    x: 271.5,
    y: 197.4,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 -8.9315 400.5716)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    x: 271.5,
    y: 197.3,
    transform: "matrix(0.3106 -0.9506 0.9506 0.3106 -8.7974 400.4228)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    x: 271.6,
    y: 197.1,
    transform: "matrix(0.3101 -0.9507 0.9507 0.3101 -8.5122 400.4926)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "263.1,203.3 263.2,203 280.4,208.6 280.3,208.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    x: 271.7,
    y: 196.8,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 -8.1865 400.2787)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    x: 271.7,
    y: 196.6,
    transform: "matrix(0.3106 -0.9506 0.9506 0.3106 -8.0209 400.1757)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "263.3,202.8 263.4,202.5 280.5,208.1 280.4,208.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 196.3,
    transform: "matrix(0.311 -0.9504 0.9504 0.311 -7.7253 399.919)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    x: 271.9,
    y: 196.1,
    transform: "matrix(0.3106 -0.9506 0.9506 0.3106 -7.4415 399.9862)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    x: 271.9,
    y: 195.9,
    transform: "matrix(0.3109 -0.9505 0.9505 0.3109 -7.3078 399.8375)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 195.8,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 -7.0241 399.9042)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 195.6,
    transform: "matrix(0.3101 -0.9507 0.9507 0.3101 -6.7574 399.9459)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "263.6,201.8 263.7,201.5 280.9,207.1 280.8,207.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    x: 272.2,
    y: 195.3,
    transform: "matrix(0.3118 -0.9502 0.9502 0.3118 -6.7174 399.3247)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "263.7,201.5 263.8,201.2 281,206.8 280.9,207.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    x: 272.3,
    y: 194.9,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 -6.0533 399.595)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    x: 272.3,
    y: 194.8,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 -5.8315 399.5727)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    x: 272.4,
    y: 194.6,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 -5.668 399.4674)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    x: 272.4,
    y: 194.5,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 -5.4441 399.4476)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 194.3,
    transform: "matrix(0.3101 -0.9507 0.9507 0.3101 -5.2094 399.4434)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 194.1,
    transform: "matrix(0.3097 -0.9508 0.9508 0.3097 -4.9319 399.4991)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    x: 272.6,
    y: 194,
    transform: "matrix(0.3112 -0.9504 0.9504 0.3112 -5.0476 398.9988)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    x: 272.6,
    y: 193.8,
    transform: "matrix(0.3094 -0.9509 0.9509 0.3094 -4.4837 399.4594)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    x: 272.7,
    y: 193.6,
    transform: "matrix(0.31 -0.9507 0.9507 0.31 -4.4128 399.2237)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    x: 272.7,
    y: 193.5,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 -4.2814 399.0731)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    x: 272.8,
    y: 193.3,
    transform: "matrix(0.3106 -0.9506 0.9506 0.3106 -4.1483 398.9253)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    x: 272.9,
    y: 193.1,
    transform: "matrix(0.3112 -0.9504 0.9504 0.3112 -4.0761 398.6918)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    x: 272.9,
    y: 193,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 -3.7006 398.8857)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 192.8,
    transform: "matrix(0.3122 -0.95 0.95 0.3122 -3.9063 398.2609)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect352 || (_rect352 = /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 192.6,
    transform: "matrix(0.3113 -0.9503 0.9503 0.3113 -3.5289 398.4577)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect353 || (_rect353 = /*#__PURE__*/React.createElement("rect", {
    x: 273.1,
    y: 192.5,
    transform: "matrix(0.31 -0.9507 0.9507 0.31 -3.0543 398.7892)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect354 || (_rect354 = /*#__PURE__*/React.createElement("rect", {
    x: 273.1,
    y: 192.3,
    transform: "matrix(0.3098 -0.9508 0.9508 0.3098 -2.8324 398.7664)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect355 || (_rect355 = /*#__PURE__*/React.createElement("rect", {
    x: 273.2,
    y: 192.1,
    transform: "matrix(0.3112 -0.9504 0.9504 0.3112 -2.914 398.3181)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect356 || (_rect356 = /*#__PURE__*/React.createElement("rect", {
    x: 273.2,
    y: 192,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 -2.5379 398.5112)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect357 || (_rect357 = /*#__PURE__*/React.createElement("rect", {
    x: 273.3,
    y: 191.8,
    transform: "matrix(0.3109 -0.9505 0.9505 0.3109 -2.4659 398.2785)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect358 || (_rect358 = /*#__PURE__*/React.createElement("rect", {
    x: 273.3,
    y: 191.7,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 -2.181 398.3437)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "264.9,197.8 265,197.6 282.1,203.2 282.1,203.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect359 || (_rect359 = /*#__PURE__*/React.createElement("rect", {
    x: 273.4,
    y: 191.3,
    transform: "matrix(0.3098 -0.9508 0.9508 0.3098 -1.6696 398.3911)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect360 || (_rect360 = /*#__PURE__*/React.createElement("rect", {
    x: 273.5,
    y: 191.2,
    transform: "matrix(0.3095 -0.9509 0.9509 0.3095 -1.4129 398.4163)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect361 || (_rect361 = /*#__PURE__*/React.createElement("rect", {
    x: 273.6,
    y: 191,
    transform: "matrix(0.3094 -0.9509 0.9509 0.3094 -1.1884 398.3958)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect362 || (_rect362 = /*#__PURE__*/React.createElement("rect", {
    x: 273.6,
    y: 190.8,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 -1.2122 398.0318)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect363 || (_rect363 = /*#__PURE__*/React.createElement("rect", {
    x: 273.7,
    y: 190.7,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 -1.0184 397.9693)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect364 || (_rect364 = /*#__PURE__*/React.createElement("rect", {
    x: 273.7,
    y: 190.5,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 -0.7943 397.9491)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect365 || (_rect365 = /*#__PURE__*/React.createElement("rect", {
    x: 273.8,
    y: 190.3,
    transform: "matrix(0.3121 -0.9501 0.9501 0.3121 -0.9739 397.3693)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "265.3,196.5 265.4,196.3 282.6,201.9 282.5,202.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect366 || (_rect366 = /*#__PURE__*/React.createElement("rect", {
    x: 273.9,
    y: 190,
    transform: "matrix(0.3098 -0.9508 0.9508 0.3098 -0.119 397.8911)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect367 || (_rect367 = /*#__PURE__*/React.createElement("rect", {
    x: 273.9,
    y: 189.8,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 -1.917872e-02 397.6995)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect368 || (_rect368 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 189.7,
    transform: "matrix(0.3103 -0.9507 0.9507 0.3103 0.1785 397.6425)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect369 || (_rect369 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 189.5,
    transform: "matrix(0.3098 -0.9508 0.9508 0.3098 0.4619 397.7036)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect370 || (_rect370 = /*#__PURE__*/React.createElement("rect", {
    x: 274.1,
    y: 189.3,
    transform: "matrix(0.3109 -0.9505 0.9505 0.3109 0.4393 397.3434)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect371 || (_rect371 = /*#__PURE__*/React.createElement("rect", {
    x: 274.1,
    y: 189.2,
    transform: "matrix(0.3106 -0.9506 0.9506 0.3106 0.6943 397.3654)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "265.7,195.4 265.8,195.1 283,200.7 282.9,201  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect372 || (_rect372 = /*#__PURE__*/React.createElement("rect", {
    x: 274.3,
    y: 188.8,
    transform: "matrix(0.3102 -0.9507 0.9507 0.3102 1.1524 397.3375)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect373 || (_rect373 = /*#__PURE__*/React.createElement("rect", {
    x: 274.3,
    y: 188.7,
    transform: "matrix(0.3106 -0.9506 0.9506 0.3106 1.2776 397.1809)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect374 || (_rect374 = /*#__PURE__*/React.createElement("rect", {
    x: 274.4,
    y: 188.5,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 1.5307 397.2)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect375 || (_rect375 = /*#__PURE__*/React.createElement("rect", {
    x: 274.4,
    y: 188.4,
    transform: "matrix(0.31 -0.9507 0.9507 0.31 1.7901 397.2269)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect376 || (_rect376 = /*#__PURE__*/React.createElement("rect", {
    x: 274.5,
    y: 188.2,
    transform: "matrix(0.3101 -0.9507 0.9507 0.3101 1.9509 397.1197)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect377 || (_rect377 = /*#__PURE__*/React.createElement("rect", {
    x: 274.5,
    y: 188,
    transform: "matrix(0.3105 -0.9506 0.9506 0.3105 2.0739 396.9607)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect378 || (_rect378 = /*#__PURE__*/React.createElement("rect", {
    x: 274.6,
    y: 187.9,
    transform: "matrix(0.3116 -0.9502 0.9502 0.3116 2.0233 396.5651)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "266.1,194 266.2,193.8 283.4,199.4 283.3,199.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect379 || (_rect379 = /*#__PURE__*/React.createElement("rect", {
    x: 274.7,
    y: 187.5,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 2.6717 396.7961)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect380 || (_rect380 = /*#__PURE__*/React.createElement("rect", {
    x: 274.7,
    y: 187.4,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 2.887 396.7631)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect381 || (_rect381 = /*#__PURE__*/React.createElement("rect", {
    x: 274.8,
    y: 187.2,
    transform: "matrix(0.3106 -0.9506 0.9506 0.3106 3.0191 396.6167)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect382 || (_rect382 = /*#__PURE__*/React.createElement("rect", {
    x: 274.8,
    y: 187,
    transform: "matrix(0.3101 -0.9507 0.9507 0.3101 3.3144 396.6922)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect383 || (_rect383 = /*#__PURE__*/React.createElement("rect", {
    x: 274.9,
    y: 186.9,
    transform: "matrix(0.3098 -0.9508 0.9508 0.3098 3.5628 396.7034)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect384 || (_rect384 = /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 186.7,
    transform: "matrix(0.31 -0.9507 0.9507 0.31 3.7164 396.5868)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect385 || (_rect385 = /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 186.5,
    transform: "matrix(0.3118 -0.9502 0.9502 0.3118 3.5413 396.0253)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect386 || (_rect386 = /*#__PURE__*/React.createElement("rect", {
    x: 275.1,
    y: 186.4,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 4.0495 396.3884)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect387 || (_rect387 = /*#__PURE__*/React.createElement("rect", {
    x: 275.1,
    y: 186.2,
    transform: "matrix(0.3111 -0.9504 0.9504 0.3111 4.0666 396.0876)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect388 || (_rect388 = /*#__PURE__*/React.createElement("rect", {
    x: 275.2,
    y: 186,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 4.4369 396.2636)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect389 || (_rect389 = /*#__PURE__*/React.createElement("rect", {
    x: 275.2,
    y: 185.9,
    transform: "matrix(0.3109 -0.9505 0.9505 0.3109 4.5067 396.0341)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect390 || (_rect390 = /*#__PURE__*/React.createElement("rect", {
    x: 275.3,
    y: 185.7,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 4.8026 396.1093)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect391 || (_rect391 = /*#__PURE__*/React.createElement("rect", {
    x: 275.3,
    y: 185.6,
    transform: "matrix(0.3109 -0.9505 0.9505 0.3109 4.894 395.9092)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect392 || (_rect392 = /*#__PURE__*/React.createElement("rect", {
    x: 275.4,
    y: 185.4,
    transform: "matrix(0.3116 -0.9502 0.9502 0.3116 4.9272 395.6315)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect393 || (_rect393 = /*#__PURE__*/React.createElement("rect", {
    x: 275.4,
    y: 185.2,
    transform: "matrix(0.3125 -0.9499 0.9499 0.3125 4.9342 395.318)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect394 || (_rect394 = /*#__PURE__*/React.createElement("rect", {
    x: 275.5,
    y: 185.1,
    transform: "matrix(0.3101 -0.9507 0.9507 0.3101 5.6325 395.9333)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect395 || (_rect395 = /*#__PURE__*/React.createElement("rect", {
    x: 275.5,
    y: 184.9,
    transform: "matrix(0.311 -0.9504 0.9504 0.311 5.6469 395.6309)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect396 || (_rect396 = /*#__PURE__*/React.createElement("rect", {
    x: 275.6,
    y: 184.7,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 5.9559 395.7225)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect397 || (_rect397 = /*#__PURE__*/React.createElement("rect", {
    x: 275.7,
    y: 184.6,
    transform: "matrix(0.3109 -0.9505 0.9505 0.3109 6.0561 395.5353)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect398 || (_rect398 = /*#__PURE__*/React.createElement("rect", {
    x: 275.7,
    y: 184.4,
    transform: "matrix(0.3102 -0.9507 0.9507 0.3102 6.3836 395.6513)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect399 || (_rect399 = /*#__PURE__*/React.createElement("rect", {
    x: 275.8,
    y: 184.2,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 6.5367 395.5351)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "267.3,190.4 267.4,190.2 284.6,195.8 284.5,196  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect400 || (_rect400 = /*#__PURE__*/React.createElement("rect", {
    x: 275.9,
    y: 183.9,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 6.9556 395.4519)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect401 || (_rect401 = /*#__PURE__*/React.createElement("rect", {
    x: 275.9,
    y: 183.7,
    transform: "matrix(0.31 -0.9507 0.9507 0.31 7.2139 395.4748)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect402 || (_rect402 = /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 183.6,
    transform: "matrix(0.3095 -0.9509 0.9509 0.3095 7.5125 395.5514)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect403 || (_rect403 = /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 183.4,
    transform: "matrix(0.3103 -0.9506 0.9506 0.3103 7.5369 395.2644)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _rect404 || (_rect404 = /*#__PURE__*/React.createElement("rect", {
    x: 276.1,
    y: 183.2,
    transform: "matrix(0.3104 -0.9506 0.9506 0.3104 7.6993 395.1607)",
    className: "st26",
    width: 0.3,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146476583679508081940000006441534996368659588_)"
    }
  }, _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "267.7,189.4 267.7,189.3 284.8,195 284.8,195  "
  }))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M229.5,256.3l7.6-22.3l0,0l0,0l9.3-27.2h-16.8h0h0h-0.2c-0.5,0-1.7,0.2-2.4,1.6l-6,17.6l0,0l-11,32.3l0,0 l0,0l0,0l0,0l0,0.1h16.8h0h0h0.2C227.4,258.4,228.8,258.1,229.5,256.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000117667365316397724790000013501540620041119135_",
    d: "M246.4,206.7L246.4,206.7l-16.8,0h0h0h-0.2 c-0.5,0-1.7,0.2-2.4,1.6l-6,17.6l0,0l-5.4,15.9l0,0L246.4,206.7z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000117667365316397724790000013501540620041119135_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139269988866744433580000014751601386568424338_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000117667365316397724790000013501540620041119135_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect405 || (_rect405 = /*#__PURE__*/React.createElement("rect", {
    x: 203.7,
    y: 208.8,
    transform: "matrix(0.8777 -0.4792 0.4792 0.8777 -75.2637 134.3996)",
    className: "st26",
    width: 43.9,
    height: 11.6
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "247.7,209.2 247.8,209.3 209.2,230.3 209.1,230.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "247.8,209.2 247.8,209.4 209.2,230.4 209.2,230.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect406 || (_rect406 = /*#__PURE__*/React.createElement("rect", {
    x: 206.6,
    y: 219.8,
    transform: "matrix(0.8779 -0.4789 0.4789 0.8779 -77.4062 136.313)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect407 || (_rect407 = /*#__PURE__*/React.createElement("rect", {
    x: 206.6,
    y: 219.9,
    transform: "matrix(0.8787 -0.4775 0.4775 0.8787 -77.2985 135.835)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect408 || (_rect408 = /*#__PURE__*/React.createElement("rect", {
    x: 206.6,
    y: 220,
    transform: "matrix(0.8775 -0.4795 0.4795 0.8775 -77.5289 136.591)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect409 || (_rect409 = /*#__PURE__*/React.createElement("rect", {
    x: 206.7,
    y: 220.1,
    transform: "matrix(0.8791 -0.4766 0.4766 0.8791 -77.2807 135.6019)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "248,209.6 248,209.7 209.5,230.8 209.4,230.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect410 || (_rect410 = /*#__PURE__*/React.createElement("rect", {
    x: 206.8,
    y: 220.2,
    transform: "matrix(0.8777 -0.4791 0.4791 0.8777 -77.5832 136.5326)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect411 || (_rect411 = /*#__PURE__*/React.createElement("rect", {
    x: 206.8,
    y: 220.3,
    transform: "matrix(0.8789 -0.477 0.477 0.8789 -77.4151 135.8356)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "248.1,209.9 248.1,210 209.6,231 209.5,230.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect412 || (_rect412 = /*#__PURE__*/React.createElement("rect", {
    x: 206.9,
    y: 220.5,
    transform: "matrix(0.8778 -0.4791 0.4791 0.8778 -77.6705 136.5954)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "248.2,210 248.2,210.1 209.7,231.2 209.6,231.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect413 || (_rect413 = /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 220.6,
    transform: "matrix(0.8777 -0.4791 0.4791 0.8777 -77.7401 136.6787)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect414 || (_rect414 = /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 220.7,
    transform: "matrix(0.8775 -0.4795 0.4795 0.8775 -77.8115 136.8542)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "248.3,210.2 248.4,210.4 209.8,231.4 209.7,231.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect415 || (_rect415 = /*#__PURE__*/React.createElement("rect", {
    x: 207.1,
    y: 220.8,
    transform: "matrix(0.8777 -0.4791 0.4791 0.8777 -77.8342 136.7665)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "248.4,210.4 248.4,210.5 209.9,231.6 209.8,231.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "248.4,210.5 248.5,210.6 209.9,231.6 209.8,231.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect416 || (_rect416 = /*#__PURE__*/React.createElement("rect", {
    x: 207.2,
    y: 221.1,
    transform: "matrix(0.8777 -0.4791 0.4791 0.8777 -77.9285 136.854)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "248.5,210.6 248.6,210.7 210,231.8 209.9,231.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "248.5,210.7 248.6,210.8 210,231.9 210,231.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect417 || (_rect417 = /*#__PURE__*/React.createElement("rect", {
    x: 207.4,
    y: 221.3,
    transform: "matrix(0.8773 -0.4799 0.4799 0.8773 -78.096 137.2098)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect418 || (_rect418 = /*#__PURE__*/React.createElement("rect", {
    x: 207.4,
    y: 221.4,
    transform: "matrix(0.8761 -0.4821 0.4821 0.8761 -78.3385 138.0135)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect419 || (_rect419 = /*#__PURE__*/React.createElement("rect", {
    x: 207.4,
    y: 221.4,
    transform: "matrix(0.8787 -0.4774 0.4774 0.8787 -77.9179 136.3932)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect420 || (_rect420 = /*#__PURE__*/React.createElement("rect", {
    x: 207.5,
    y: 221.5,
    transform: "matrix(0.8776 -0.4795 0.4795 0.8776 -78.1502 137.151)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "248.8,211.1 248.8,211.2 210.2,232.3 210.2,232.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect421 || (_rect421 = /*#__PURE__*/React.createElement("rect", {
    x: 207.6,
    y: 221.7,
    transform: "matrix(0.8782 -0.4782 0.4782 0.8782 -78.0922 136.7713)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "248.8,211.2 248.9,211.3 210.3,232.4 210.3,232.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect422 || (_rect422 = /*#__PURE__*/React.createElement("rect", {
    x: 207.6,
    y: 221.8,
    transform: "matrix(0.8778 -0.4791 0.4791 0.8778 -78.2356 137.1221)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect423 || (_rect423 = /*#__PURE__*/React.createElement("rect", {
    x: 207.7,
    y: 221.9,
    transform: "matrix(0.8776 -0.4794 0.4794 0.8776 -78.3003 137.2724)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect424 || (_rect424 = /*#__PURE__*/React.createElement("rect", {
    x: 207.7,
    y: 222,
    transform: "matrix(0.8776 -0.4795 0.4795 0.8776 -78.3385 137.3265)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "249,211.5 249.1,211.6 210.5,232.7 210.4,232.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "249,211.6 249.1,211.7 210.5,232.8 210.5,232.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect425 || (_rect425 = /*#__PURE__*/React.createElement("rect", {
    x: 207.9,
    y: 222.2,
    transform: "matrix(0.8773 -0.48 0.48 0.8773 -78.4801 137.5862)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect426 || (_rect426 = /*#__PURE__*/React.createElement("rect", {
    x: 207.9,
    y: 222.3,
    transform: "matrix(0.8783 -0.4782 0.4782 0.8783 -78.336 136.9792)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect427 || (_rect427 = /*#__PURE__*/React.createElement("rect", {
    x: 207.9,
    y: 222.4,
    transform: "matrix(0.8775 -0.4795 0.4795 0.8775 -78.5024 137.4976)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect428 || (_rect428 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 222.4,
    transform: "matrix(0.8777 -0.4791 0.4791 0.8777 -78.4932 137.3799)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect429 || (_rect429 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 222.5,
    transform: "matrix(0.8791 -0.4766 0.4766 0.8791 -78.2806 136.5299)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "249.3,212.1 249.4,212.2 210.8,233.2 210.7,233.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect430 || (_rect430 = /*#__PURE__*/React.createElement("rect", {
    x: 208.1,
    y: 222.7,
    transform: "matrix(0.878 -0.4787 0.4787 0.878 -78.5468 137.3205)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "249.4,212.2 249.4,212.3 210.9,233.4 210.8,233.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect431 || (_rect431 = /*#__PURE__*/React.createElement("rect", {
    x: 208.2,
    y: 222.8,
    transform: "matrix(0.8775 -0.4795 0.4795 0.8775 -78.6908 137.6731)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect432 || (_rect432 = /*#__PURE__*/React.createElement("rect", {
    x: 208.2,
    y: 222.9,
    transform: "matrix(0.8778 -0.4791 0.4791 0.8778 -78.6745 137.5299)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "249.5,212.4 249.6,212.6 211,233.6 210.9,233.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect433 || (_rect433 = /*#__PURE__*/React.createElement("rect", {
    x: 208.3,
    y: 223,
    transform: "matrix(0.8775 -0.4795 0.4795 0.8775 -78.7851 137.7608)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "249.6,212.6 249.6,212.7 211.1,233.8 211,233.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "249.6,212.7 249.7,212.8 211.1,233.8 211.1,233.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect434 || (_rect434 = /*#__PURE__*/React.createElement("rect", {
    x: 208.4,
    y: 223.3,
    transform: "matrix(0.878 -0.4787 0.4787 0.878 -78.7977 137.5541)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "249.7,212.8 249.8,212.9 211.2,234 211.1,233.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect435 || (_rect435 = /*#__PURE__*/React.createElement("rect", {
    x: 208.5,
    y: 223.4,
    transform: "matrix(0.8787 -0.4775 0.4775 0.8787 -78.7379 137.1723)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect436 || (_rect436 = /*#__PURE__*/React.createElement("rect", {
    x: 208.6,
    y: 223.5,
    transform: "matrix(0.8777 -0.4791 0.4791 0.8777 -78.9327 137.7888)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "249.8,213.1 249.9,213.2 211.3,234.2 211.3,234.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "249.9,213.1 249.9,213.2 211.4,234.3 211.3,234.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect437 || (_rect437 = /*#__PURE__*/React.createElement("rect", {
    x: 208.7,
    y: 223.7,
    transform: "matrix(0.8773 -0.4799 0.4799 0.8773 -79.1016 138.1466)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "250,213.3 250,213.4 211.4,234.5 211.4,234.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect438 || (_rect438 = /*#__PURE__*/React.createElement("rect", {
    x: 208.8,
    y: 223.9,
    transform: "matrix(0.8778 -0.479 0.479 0.8778 -79.0758 137.8854)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect439 || (_rect439 = /*#__PURE__*/React.createElement("rect", {
    x: 208.8,
    y: 224,
    transform: "matrix(0.8773 -0.4799 0.4799 0.8773 -79.1959 138.2344)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "250.1,213.5 250.1,213.6 211.6,234.7 211.5,234.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect440 || (_rect440 = /*#__PURE__*/React.createElement("rect", {
    x: 208.9,
    y: 224.1,
    transform: "matrix(0.8782 -0.4782 0.4782 0.8782 -79.0948 137.7037)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "250.2,213.7 250.2,213.8 211.7,234.8 211.6,234.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "250.2,213.7 250.3,213.9 211.7,234.9 211.6,234.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect441 || (_rect441 = /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 224.3,
    transform: "matrix(0.8771 -0.4802 0.4802 0.8771 -79.3869 138.5031)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "250.3,213.9 250.4,214 211.8,235.1 211.7,235  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect442 || (_rect442 = /*#__PURE__*/React.createElement("rect", {
    x: 209.1,
    y: 224.5,
    transform: "matrix(0.8778 -0.479 0.479 0.8778 -79.3268 138.1192)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "250.4,214 250.4,214.2 211.9,235.2 211.8,235.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect443 || (_rect443 = /*#__PURE__*/React.createElement("rect", {
    x: 209.2,
    y: 224.6,
    transform: "matrix(0.8773 -0.48 0.48 0.8773 -79.4857 138.5232)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect444 || (_rect444 = /*#__PURE__*/React.createElement("rect", {
    x: 209.2,
    y: 224.7,
    transform: "matrix(0.8787 -0.4774 0.4774 0.8787 -79.2628 137.6411)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect445 || (_rect445 = /*#__PURE__*/React.createElement("rect", {
    x: 209.3,
    y: 224.8,
    transform: "matrix(0.8775 -0.4795 0.4795 0.8775 -79.5073 138.4335)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect446 || (_rect446 = /*#__PURE__*/React.createElement("rect", {
    x: 209.3,
    y: 224.9,
    transform: "matrix(0.878 -0.4787 0.4787 0.878 -79.4562 138.1668)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect447 || (_rect447 = /*#__PURE__*/React.createElement("rect", {
    x: 209.4,
    y: 224.9,
    transform: "matrix(0.8774 -0.4797 0.4797 0.8774 -79.5832 138.539)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "250.6,214.5 250.7,214.6 212.1,235.7 212,235.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect448 || (_rect448 = /*#__PURE__*/React.createElement("rect", {
    x: 209.4,
    y: 225.1,
    transform: "matrix(0.8777 -0.4791 0.4791 0.8777 -79.5916 138.4022)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "250.7,214.7 250.8,214.8 212.2,235.8 212.1,235.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect449 || (_rect449 = /*#__PURE__*/React.createElement("rect", {
    x: 209.5,
    y: 225.3,
    transform: "matrix(0.8777 -0.4791 0.4791 0.8777 -79.6544 138.4607)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "250.8,214.8 250.9,214.9 212.3,236 212.2,235.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "250.8,214.9 250.9,215 212.3,236.1 212.3,235.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect450 || (_rect450 = /*#__PURE__*/React.createElement("rect", {
    x: 209.6,
    y: 225.5,
    transform: "matrix(0.878 -0.4787 0.4787 0.878 -79.7072 138.4001)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "250.9,215 251,215.1 212.4,236.2 212.3,236.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "251,215.1 251,215.2 212.4,236.3 212.4,236.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect451 || (_rect451 = /*#__PURE__*/React.createElement("rect", {
    x: 209.8,
    y: 225.7,
    transform: "matrix(0.8775 -0.4795 0.4795 0.8775 -79.8842 138.7845)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "251,215.3 251.1,215.4 212.5,236.4 212.5,236.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect452 || (_rect452 = /*#__PURE__*/React.createElement("rect", {
    x: 209.8,
    y: 225.9,
    transform: "matrix(0.8787 -0.4775 0.4775 0.8787 -79.7393 138.1026)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect453 || (_rect453 = /*#__PURE__*/React.createElement("rect", {
    x: 209.9,
    y: 225.9,
    transform: "matrix(0.8773 -0.4799 0.4799 0.8773 -80.0128 138.9955)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "251.2,215.5 251.2,215.6 212.7,236.7 212.6,236.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect454 || (_rect454 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 226.1,
    transform: "matrix(0.8785 -0.4778 0.4778 0.8785 -79.868 138.3137)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "251.2,215.6 251.3,215.8 212.7,236.8 212.7,236.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "251.3,215.7 251.3,215.8 212.8,236.9 212.7,236.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect455 || (_rect455 = /*#__PURE__*/React.createElement("rect", {
    x: 210.1,
    y: 226.3,
    transform: "matrix(0.8778 -0.479 0.479 0.8778 -80.0798 138.8198)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "251.4,215.9 251.4,216 212.9,237 212.8,236.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect456 || (_rect456 = /*#__PURE__*/React.createElement("rect", {
    x: 210.2,
    y: 226.5,
    transform: "matrix(0.8778 -0.479 0.479 0.8778 -80.1426 138.8783)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect457 || (_rect457 = /*#__PURE__*/React.createElement("rect", {
    x: 210.2,
    y: 226.5,
    transform: "matrix(0.8771 -0.4803 0.4803 0.8771 -80.3058 139.3789)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "251.5,216.1 251.6,216.2 213,237.3 212.9,237.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect458 || (_rect458 = /*#__PURE__*/React.createElement("rect", {
    x: 210.3,
    y: 226.7,
    transform: "matrix(0.8782 -0.4782 0.4782 0.8782 -80.1607 138.6956)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect459 || (_rect459 = /*#__PURE__*/React.createElement("rect", {
    x: 210.3,
    y: 226.8,
    transform: "matrix(0.8776 -0.4795 0.4795 0.8776 -80.3167 139.1686)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "251.6,216.3 251.7,216.4 213.1,237.5 213,237.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect460 || (_rect460 = /*#__PURE__*/React.createElement("rect", {
    x: 210.4,
    y: 226.9,
    transform: "matrix(0.8787 -0.4775 0.4775 0.8787 -80.1774 138.5098)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "251.7,216.5 251.8,216.6 213.2,237.7 213.1,237.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect461 || (_rect461 = /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 227.1,
    transform: "matrix(0.8773 -0.48 0.48 0.8773 -80.4913 139.4603)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect462 || (_rect462 = /*#__PURE__*/React.createElement("rect", {
    x: 210.6,
    y: 227.2,
    transform: "matrix(0.8787 -0.4774 0.4774 0.8787 -80.264 138.5712)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect463 || (_rect463 = /*#__PURE__*/React.createElement("rect", {
    x: 210.6,
    y: 227.2,
    transform: "matrix(0.878 -0.4787 0.4787 0.878 -80.4284 139.0712)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect464 || (_rect464 = /*#__PURE__*/React.createElement("rect", {
    x: 210.6,
    y: 227.3,
    transform: "matrix(0.878 -0.4787 0.4787 0.878 -80.4597 139.1004)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "251.9,216.9 252,217 213.4,238 213.3,237.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect465 || (_rect465 = /*#__PURE__*/React.createElement("rect", {
    x: 210.7,
    y: 227.5,
    transform: "matrix(0.8775 -0.4796 0.4796 0.8775 -80.6138 139.4829)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "252,217 252.1,217.1 213.5,238.2 213.4,238.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect466 || (_rect466 = /*#__PURE__*/React.createElement("rect", {
    x: 210.8,
    y: 227.6,
    transform: "matrix(0.8787 -0.4775 0.4775 0.8787 -80.459 138.7713)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect467 || (_rect467 = /*#__PURE__*/React.createElement("rect", {
    x: 210.8,
    y: 227.7,
    transform: "matrix(0.8777 -0.4791 0.4791 0.8777 -80.6586 139.3955)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect468 || (_rect468 = /*#__PURE__*/React.createElement("rect", {
    x: 210.9,
    y: 227.8,
    transform: "matrix(0.8787 -0.4774 0.4774 0.8787 -80.5143 138.8039)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect469 || (_rect469 = /*#__PURE__*/React.createElement("rect", {
    x: 210.9,
    y: 227.8,
    transform: "matrix(0.8772 -0.4801 0.4801 0.8772 -80.8186 139.7995)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect470 || (_rect470 = /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 227.9,
    transform: "matrix(0.878 -0.4787 0.4787 0.878 -80.7107 139.3337)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "252.2,217.5 252.3,217.6 213.7,238.6 213.7,238.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect471 || (_rect471 = /*#__PURE__*/React.createElement("rect", {
    x: 211.1,
    y: 228.1,
    transform: "matrix(0.8786 -0.4775 0.4775 0.8786 -80.6541 138.9716)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "252.3,217.6 252.4,217.7 213.8,238.8 213.8,238.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "252.4,217.7 252.4,217.8 213.9,238.9 213.8,238.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect472 || (_rect472 = /*#__PURE__*/React.createElement("rect", {
    x: 211.2,
    y: 228.3,
    transform: "matrix(0.8787 -0.4775 0.4775 0.8787 -80.7406 139.0329)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect473 || (_rect473 = /*#__PURE__*/React.createElement("rect", {
    x: 211.2,
    y: 228.4,
    transform: "matrix(0.8776 -0.4795 0.4795 0.8776 -80.9762 139.7826)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "252.5,217.9 252.6,218 214,239.1 213.9,239  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect474 || (_rect474 = /*#__PURE__*/React.createElement("rect", {
    x: 211.3,
    y: 228.5,
    transform: "matrix(0.8771 -0.4803 0.4803 0.8771 -81.1235 140.1409)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "252.6,218.1 252.6,218.2 214.1,239.3 214,239.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect475 || (_rect475 = /*#__PURE__*/React.createElement("rect", {
    x: 211.4,
    y: 228.7,
    transform: "matrix(0.878 -0.4786 0.4786 0.878 -81.0172 139.6007)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect476 || (_rect476 = /*#__PURE__*/React.createElement("rect", {
    x: 211.4,
    y: 228.8,
    transform: "matrix(0.8773 -0.4799 0.4799 0.8773 -81.1755 140.0786)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "252.7,218.3 252.8,218.4 214.2,239.5 214.1,239.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect477 || (_rect477 = /*#__PURE__*/React.createElement("rect", {
    x: 211.5,
    y: 228.9,
    transform: "matrix(0.8778 -0.479 0.479 0.8778 -81.1465 139.8127)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect478 || (_rect478 = /*#__PURE__*/React.createElement("rect", {
    x: 211.6,
    y: 229,
    transform: "matrix(0.8771 -0.4802 0.4802 0.8771 -81.3047 140.2908)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "252.8,218.5 252.9,218.6 214.3,239.7 214.2,239.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect479 || (_rect479 = /*#__PURE__*/React.createElement("rect", {
    x: 211.6,
    y: 229.1,
    transform: "matrix(0.8782 -0.4782 0.4782 0.8782 -81.163 139.6266)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect480 || (_rect480 = /*#__PURE__*/React.createElement("rect", {
    x: 211.7,
    y: 229.2,
    transform: "matrix(0.8771 -0.4803 0.4803 0.8771 -81.4064 140.4047)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect481 || (_rect481 = /*#__PURE__*/React.createElement("rect", {
    x: 211.7,
    y: 229.3,
    transform: "matrix(0.8773 -0.4799 0.4799 0.8773 -81.3954 140.2836)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect482 || (_rect482 = /*#__PURE__*/React.createElement("rect", {
    x: 211.8,
    y: 229.4,
    transform: "matrix(0.8784 -0.4779 0.4779 0.8784 -81.2213 139.5892)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "253,218.9 253.1,219 214.5,240.1 214.5,240  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "253.1,219 253.1,219.1 214.6,240.2 214.5,240.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect483 || (_rect483 = /*#__PURE__*/React.createElement("rect", {
    x: 211.9,
    y: 229.6,
    transform: "matrix(0.8789 -0.477 0.477 0.8789 -81.2226 139.3524)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect484 || (_rect484 = /*#__PURE__*/React.createElement("rect", {
    x: 211.9,
    y: 229.7,
    transform: "matrix(0.8777 -0.4791 0.4791 0.8777 -81.4746 140.155)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect485 || (_rect485 = /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 229.7,
    transform: "matrix(0.8787 -0.4775 0.4775 0.8787 -81.3352 139.5855)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "253.2,219.3 253.3,219.4 214.7,240.5 214.7,240.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect486 || (_rect486 = /*#__PURE__*/React.createElement("rect", {
    x: 212.1,
    y: 229.9,
    transform: "matrix(0.8777 -0.4792 0.4792 0.8777 -81.5761 140.2685)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "253.3,219.4 253.4,219.6 214.8,240.6 214.7,240.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect487 || (_rect487 = /*#__PURE__*/React.createElement("rect", {
    x: 212.1,
    y: 230,
    transform: "matrix(0.8784 -0.4779 0.4779 0.8784 -81.5031 139.8511)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect488 || (_rect488 = /*#__PURE__*/React.createElement("rect", {
    x: 212.2,
    y: 230.1,
    transform: "matrix(0.878 -0.4787 0.4787 0.878 -81.62 140.1799)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "253.4,219.7 253.5,219.8 214.9,240.8 214.9,240.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "253.5,219.8 253.6,219.9 215,240.9 214.9,240.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect489 || (_rect489 = /*#__PURE__*/React.createElement("rect", {
    x: 212.3,
    y: 230.3,
    transform: "matrix(0.8777 -0.4791 0.4791 0.8777 -81.757 140.4178)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "253.6,219.9 253.6,220 215.1,241.1 215,241  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect490 || (_rect490 = /*#__PURE__*/React.createElement("rect", {
    x: 212.4,
    y: 230.5,
    transform: "matrix(0.8786 -0.4775 0.4775 0.8786 -81.6555 139.9022)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "253.7,220.1 253.7,220.2 215.1,241.2 215.1,241.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "253.7,220.1 253.8,220.2 215.2,241.3 215.1,241.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect491 || (_rect491 = /*#__PURE__*/React.createElement("rect", {
    x: 212.5,
    y: 230.7,
    transform: "matrix(0.878 -0.4787 0.4787 0.878 -81.8709 140.4133)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "253.8,220.3 253.8,220.4 215.3,241.5 215.2,241.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect492 || (_rect492 = /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 230.9,
    transform: "matrix(0.8778 -0.479 0.479 0.8778 -81.9623 140.5719)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect493 || (_rect493 = /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 231,
    transform: "matrix(0.8767 -0.481 0.481 0.8767 -82.2005 141.3289)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "253.9,220.5 254,220.6 215.4,241.7 215.3,241.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect494 || (_rect494 = /*#__PURE__*/React.createElement("rect", {
    x: 212.7,
    y: 231.1,
    transform: "matrix(0.878 -0.4786 0.4786 0.878 -82.0206 140.5341)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect495 || (_rect495 = /*#__PURE__*/React.createElement("rect", {
    x: 212.8,
    y: 231.2,
    transform: "matrix(0.8773 -0.4799 0.4799 0.8773 -82.181 141.0154)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _rect496 || (_rect496 = /*#__PURE__*/React.createElement("rect", {
    x: 212.8,
    y: 231.3,
    transform: "matrix(0.8776 -0.4795 0.4795 0.8776 -82.1694 140.8937)",
    className: "st26",
    width: 43.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139269988866744433580000014751601386568424338_)"
    }
  }, _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "254.1,220.8 254.1,220.8 215.5,241.9 215.5,241.9  "
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M244.8,257.4L244.8,257.4L244.8,257.4l-8-23.4l0,0l0,0l-9.1-26.6c0.6-0.5,1.3-0.6,1.7-0.6h0.2h0h0h16.8 l6.8,19.9l0,0l0,0l10.7,31.3c-0.2,0.2-0.5,0.3-0.9,0.3h0h-16.9h0C245.5,258.4,245,258,244.8,257.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000080205809730794597380000016136119688705089173_",
    d: "M246.4,206.7l6.8,19.9l0,0l0,0l10.7,31.3 c-0.2,0.2-0.5,0.3-0.9,0.3h0h-16.9h0c-0.2,0-0.3,0-0.4-0.1l-0.2-0.1L246.4,206.7z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080205809730794597380000016136119688705089173_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000051343609331057180520000003313875117586415755_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080205809730794597380000016136119688705089173_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect497 || (_rect497 = /*#__PURE__*/React.createElement("rect", {
    x: 239.8,
    y: 232.5,
    transform: "matrix(0.5076 -0.8616 0.8616 0.5076 -79.4549 345.1053)",
    className: "st26",
    width: 44.8,
    height: 19.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "242.6,256.6 242.5,256.5 265.3,217.9 265.4,217.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "242.6,256.5 242.4,256.4 265.2,217.8 265.3,217.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect498 || (_rect498 = /*#__PURE__*/React.createElement("rect", {
    x: 231.4,
    y: 237,
    transform: "matrix(0.5072 -0.8618 0.8618 0.5072 -79.2811 335.5749)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "242.4,256.4 242.3,256.3 265,217.7 265.2,217.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect499 || (_rect499 = /*#__PURE__*/React.createElement("rect", {
    x: 231.2,
    y: 236.9,
    transform: "matrix(0.5092 -0.8606 0.8606 0.5092 -79.5054 334.6132)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "242.2,256.3 242.1,256.2 264.9,217.6 265,217.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "242.2,256.3 242,256.2 264.8,217.6 264.9,217.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "242.1,256.2 241.9,256.1 264.7,217.5 264.8,217.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "242,256.2 241.9,256.1 264.6,217.5 264.7,217.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect500 || (_rect500 = /*#__PURE__*/React.createElement("rect", {
    x: 230.8,
    y: 236.7,
    transform: "matrix(0.5073 -0.8618 0.8618 0.5073 -79.2763 334.8942)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "241.8,256.1 241.7,256 264.5,217.4 264.6,217.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect501 || (_rect501 = /*#__PURE__*/React.createElement("rect", {
    x: 230.6,
    y: 236.6,
    transform: "matrix(0.5072 -0.8618 0.8618 0.5072 -79.2696 334.7183)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect502 || (_rect502 = /*#__PURE__*/React.createElement("rect", {
    x: 230.6,
    y: 236.6,
    transform: "matrix(0.5084 -0.8611 0.8611 0.5084 -79.406 334.1557)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "241.6,255.9 241.5,255.9 264.2,217.2 264.3,217.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect503 || (_rect503 = /*#__PURE__*/React.createElement("rect", {
    x: 230.4,
    y: 236.5,
    transform: "matrix(0.5084 -0.8611 0.8611 0.5084 -79.4032 333.9651)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect504 || (_rect504 = /*#__PURE__*/React.createElement("rect", {
    x: 230.3,
    y: 236.4,
    transform: "matrix(0.5073 -0.8618 0.8618 0.5073 -79.2692 334.3224)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect505 || (_rect505 = /*#__PURE__*/React.createElement("rect", {
    x: 230.2,
    y: 236.4,
    transform: "matrix(0.5092 -0.8606 0.8606 0.5092 -79.4891 333.4723)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "241.2,255.7 241.1,255.7 263.9,217 264,217.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect506 || (_rect506 = /*#__PURE__*/React.createElement("rect", {
    x: 230.1,
    y: 236.3,
    transform: "matrix(0.5075 -0.8617 0.8617 0.5075 -79.292 333.9459)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "241.1,255.6 241,255.6 263.7,216.9 263.8,217  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "241,255.6 240.9,255.5 263.6,216.9 263.8,217  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect507 || (_rect507 = /*#__PURE__*/React.createElement("rect", {
    x: 229.8,
    y: 236.1,
    transform: "matrix(0.5073 -0.8618 0.8618 0.5073 -79.2614 333.7508)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect508 || (_rect508 = /*#__PURE__*/React.createElement("rect", {
    x: 229.7,
    y: 236.1,
    transform: "matrix(0.5073 -0.8618 0.8618 0.5073 -79.2605 333.6557)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect509 || (_rect509 = /*#__PURE__*/React.createElement("rect", {
    x: 229.6,
    y: 236,
    transform: "matrix(0.5065 -0.8622 0.8622 0.5065 -79.1791 333.8315)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect510 || (_rect510 = /*#__PURE__*/React.createElement("rect", {
    x: 229.6,
    y: 236,
    transform: "matrix(0.5095 -0.8605 0.8605 0.5095 -79.5088 332.6075)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect511 || (_rect511 = /*#__PURE__*/React.createElement("rect", {
    x: 229.5,
    y: 235.9,
    transform: "matrix(0.5075 -0.8616 0.8616 0.5075 -79.2873 333.2653)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect512 || (_rect512 = /*#__PURE__*/React.createElement("rect", {
    x: 229.4,
    y: 235.9,
    transform: "matrix(0.5092 -0.8606 0.8606 0.5092 -79.4758 332.5215)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect513 || (_rect513 = /*#__PURE__*/React.createElement("rect", {
    x: 229.3,
    y: 235.8,
    transform: "matrix(0.5073 -0.8618 0.8618 0.5073 -79.2541 333.1793)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "240.3,255.2 240.2,255.1 263,216.5 263.1,216.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect514 || (_rect514 = /*#__PURE__*/React.createElement("rect", {
    x: 229.2,
    y: 235.7,
    transform: "matrix(0.5088 -0.8609 0.8609 0.5088 -79.4278 332.3874)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "240.2,255.1 240,255 262.8,216.4 262.9,216.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "240.1,255 240,255 262.7,216.4 262.8,216.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect515 || (_rect515 = /*#__PURE__*/React.createElement("rect", {
    x: 228.9,
    y: 235.6,
    transform: "matrix(0.5099 -0.8602 0.8602 0.5099 -79.5419 331.6959)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon126 || (_polygon126 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "239.9,255 239.8,254.9 262.6,216.3 262.7,216.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect516 || (_rect516 = /*#__PURE__*/React.createElement("rect", {
    x: 228.7,
    y: 235.5,
    transform: "matrix(0.5073 -0.8618 0.8618 0.5073 -79.2456 332.5124)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon127 || (_polygon127 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "239.8,254.9 239.6,254.8 262.4,216.2 262.5,216.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect517 || (_rect517 = /*#__PURE__*/React.createElement("rect", {
    x: 228.6,
    y: 235.4,
    transform: "matrix(0.5088 -0.8609 0.8609 0.5088 -79.4184 331.7216)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon128 || (_polygon128 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "239.6,254.8 239.5,254.7 262.2,216.1 262.3,216.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon129 || (_polygon129 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "239.5,254.7 239.4,254.6 262.1,216 262.3,216.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon130 || (_polygon130 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "239.4,254.7 239.3,254.6 262.1,216 262.2,216  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon131 || (_polygon131 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "239.3,254.6 239.2,254.5 262,215.9 262.1,216  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect518 || (_rect518 = /*#__PURE__*/React.createElement("rect", {
    x: 228.2,
    y: 235.1,
    transform: "matrix(0.5073 -0.8618 0.8618 0.5073 -79.2368 331.8456)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon132 || (_polygon132 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "239.2,254.5 239.1,254.4 261.8,215.8 261.9,215.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect519 || (_rect519 = /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 235,
    transform: "matrix(0.5084 -0.8611 0.8611 0.5084 -79.3654 331.206)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect520 || (_rect520 = /*#__PURE__*/React.createElement("rect", {
    x: 227.9,
    y: 235,
    transform: "matrix(0.5084 -0.8611 0.8611 0.5084 -79.3643 331.1109)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon133 || (_polygon133 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "238.9,254.4 238.8,254.3 261.6,215.7 261.7,215.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon134 || (_polygon134 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "238.8,254.3 238.7,254.2 261.5,215.6 261.6,215.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon135 || (_polygon135 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "238.8,254.3 238.6,254.2 261.4,215.6 261.5,215.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect521 || (_rect521 = /*#__PURE__*/React.createElement("rect", {
    x: 227.6,
    y: 234.8,
    transform: "matrix(0.5088 -0.8609 0.8609 0.5088 -79.4025 330.5802)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect522 || (_rect522 = /*#__PURE__*/React.createElement("rect", {
    x: 227.5,
    y: 234.8,
    transform: "matrix(0.5092 -0.8606 0.8606 0.5092 -79.4449 330.3349)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect523 || (_rect523 = /*#__PURE__*/React.createElement("rect", {
    x: 227.4,
    y: 234.7,
    transform: "matrix(0.5072 -0.8618 0.8618 0.5072 -79.2213 331.0027)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon136 || (_polygon136 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "238.4,254.1 238.3,254 261.1,215.4 261.2,215.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon137 || (_polygon137 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "238.3,254 238.2,254 261,215.3 261.1,215.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect524 || (_rect524 = /*#__PURE__*/React.createElement("rect", {
    x: 227.2,
    y: 234.6,
    transform: "matrix(0.5076 -0.8616 0.8616 0.5076 -79.2613 330.567)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect525 || (_rect525 = /*#__PURE__*/React.createElement("rect", {
    x: 227.1,
    y: 234.5,
    transform: "matrix(0.5073 -0.8618 0.8618 0.5073 -79.2207 330.6073)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect526 || (_rect526 = /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 234.5,
    transform: "matrix(0.5062 -0.8624 0.8624 0.5062 -79.0969 330.9301)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect527 || (_rect527 = /*#__PURE__*/React.createElement("rect", {
    x: 226.9,
    y: 234.4,
    transform: "matrix(0.5092 -0.8606 0.8606 0.5092 -79.4354 329.6695)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect528 || (_rect528 = /*#__PURE__*/React.createElement("rect", {
    x: 226.8,
    y: 234.4,
    transform: "matrix(0.5079 -0.8614 0.8614 0.5079 -79.2867 330.0818)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect529 || (_rect529 = /*#__PURE__*/React.createElement("rect", {
    x: 226.8,
    y: 234.3,
    transform: "matrix(0.5085 -0.8611 0.8611 0.5085 -79.3499 329.7649)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect530 || (_rect530 = /*#__PURE__*/React.createElement("rect", {
    x: 226.7,
    y: 234.3,
    transform: "matrix(0.5084 -0.8611 0.8611 0.5084 -79.3407 329.6971)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon138 || (_polygon138 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "237.7,253.6 237.6,253.6 260.3,214.9 260.4,215  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect531 || (_rect531 = /*#__PURE__*/React.createElement("rect", {
    x: 226.5,
    y: 234.2,
    transform: "matrix(0.5092 -0.8606 0.8606 0.5092 -79.4288 329.194)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon139 || (_polygon139 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "237.5,253.5 237.4,253.5 260.2,214.8 260.3,214.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon140 || (_polygon140 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "237.4,253.5 237.3,253.4 260.1,214.8 260.2,214.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect532 || (_rect532 = /*#__PURE__*/React.createElement("rect", {
    x: 226.3,
    y: 234,
    transform: "matrix(0.5095 -0.8605 0.8605 0.5095 -79.4545 328.8055)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon141 || (_polygon141 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "237.3,253.4 237.2,253.3 259.9,214.7 260,214.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect533 || (_rect533 = /*#__PURE__*/React.createElement("rect", {
    x: 226.1,
    y: 233.9,
    transform: "matrix(0.5073 -0.8618 0.8618 0.5073 -79.2098 329.4504)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon142 || (_polygon142 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "237.1,253.3 237,253.2 259.7,214.6 259.9,214.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect534 || (_rect534 = /*#__PURE__*/React.createElement("rect", {
    x: 225.9,
    y: 233.8,
    transform: "matrix(0.5092 -0.8606 0.8606 0.5092 -79.4193 328.5285)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon143 || (_polygon143 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "236.9,253.2 236.8,253.1 259.6,214.5 259.7,214.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon144 || (_polygon144 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "236.9,253.1 236.7,253.1 259.5,214.5 259.6,214.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon145 || (_polygon145 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "236.8,253.1 236.7,253 259.4,214.4 259.5,214.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon146 || (_polygon146 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "236.7,253.1 236.6,253 259.3,214.4 259.5,214.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect535 || (_rect535 = /*#__PURE__*/React.createElement("rect", {
    x: 225.5,
    y: 233.6,
    transform: "matrix(0.5073 -0.8618 0.8618 0.5073 -79.1971 328.7971)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon147 || (_polygon147 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "236.5,253 236.4,252.9 259.2,214.3 259.3,214.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon148 || (_polygon148 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "236.4,252.9 236.3,252.8 259.1,214.2 259.2,214.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon149 || (_polygon149 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "236.4,252.9 236.2,252.8 259,214.2 259.1,214.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon150 || (_polygon150 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "236.3,252.8 236.2,252.7 258.9,214.1 259,214.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon151 || (_polygon151 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "236.2,252.8 236.1,252.7 258.8,214.1 259,214.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon152 || (_polygon152 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "236.1,252.7 236,252.6 258.7,214 258.9,214.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect536 || (_rect536 = /*#__PURE__*/React.createElement("rect", {
    x: 224.9,
    y: 233.2,
    transform: "matrix(0.5076 -0.8616 0.8616 0.5076 -79.2313 327.9821)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon153 || (_polygon153 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "236,252.6 235.8,252.5 258.6,213.9 258.7,214  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect537 || (_rect537 = /*#__PURE__*/React.createElement("rect", {
    x: 224.8,
    y: 233.1,
    transform: "matrix(0.5068 -0.862 0.862 0.5068 -79.1385 328.1027)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon154 || (_polygon154 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "235.8,252.5 235.7,252.4 258.4,213.8 258.5,213.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon155 || (_polygon155 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "235.7,252.5 235.6,252.4 258.3,213.8 258.5,213.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect538 || (_rect538 = /*#__PURE__*/React.createElement("rect", {
    x: 224.5,
    y: 233,
    transform: "matrix(0.5073 -0.8618 0.8618 0.5073 -79.1821 327.6539)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect539 || (_rect539 = /*#__PURE__*/React.createElement("rect", {
    x: 224.4,
    y: 232.9,
    transform: "matrix(0.5073 -0.8618 0.8618 0.5073 -79.1811 327.5586)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect540 || (_rect540 = /*#__PURE__*/React.createElement("rect", {
    x: 224.4,
    y: 232.9,
    transform: "matrix(0.5065 -0.8622 0.8622 0.5065 -79.1022 327.7301)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect541 || (_rect541 = /*#__PURE__*/React.createElement("rect", {
    x: 224.3,
    y: 232.9,
    transform: "matrix(0.5078 -0.8615 0.8615 0.5078 -79.2342 327.1756)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect542 || (_rect542 = /*#__PURE__*/React.createElement("rect", {
    x: 224.2,
    y: 232.8,
    transform: "matrix(0.5064 -0.8623 0.8623 0.5064 -79.0871 327.5834)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect543 || (_rect543 = /*#__PURE__*/React.createElement("rect", {
    x: 224.1,
    y: 232.8,
    transform: "matrix(0.5084 -0.8611 0.8611 0.5084 -79.3043 326.7338)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon156 || (_polygon156 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "235.1,252.1 235,252.1 257.8,213.4 257.9,213.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon157 || (_polygon157 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "235,252.1 234.9,252 257.7,213.4 257.8,213.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect544 || (_rect544 = /*#__PURE__*/React.createElement("rect", {
    x: 223.9,
    y: 232.6,
    transform: "matrix(0.5088 -0.8609 0.8609 0.5088 -79.3431 326.3003)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon158 || (_polygon158 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "234.9,252 234.8,251.9 257.5,213.3 257.6,213.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon159 || (_polygon159 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "234.8,251.9 234.7,251.9 257.4,213.2 257.5,213.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect545 || (_rect545 = /*#__PURE__*/React.createElement("rect", {
    x: 223.6,
    y: 232.5,
    transform: "matrix(0.5092 -0.8606 0.8606 0.5092 -79.3816 325.8663)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon160 || (_polygon160 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "234.6,251.8 234.5,251.8 257.3,213.1 257.4,213.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect546 || (_rect546 = /*#__PURE__*/React.createElement("rect", {
    x: 223.4,
    y: 232.4,
    transform: "matrix(0.5073 -0.8618 0.8618 0.5073 -79.1662 326.4155)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon161 || (_polygon161 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "234.5,251.7 234.3,251.7 257.1,213 257.2,213.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect547 || (_rect547 = /*#__PURE__*/React.createElement("rect", {
    x: 223.3,
    y: 232.3,
    transform: "matrix(0.5088 -0.8609 0.8609 0.5088 -79.3337 325.6345)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon162 || (_polygon162 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "234.3,251.6 234.2,251.6 256.9,212.9 257.1,213  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect548 || (_rect548 = /*#__PURE__*/React.createElement("rect", {
    x: 223.1,
    y: 232.2,
    transform: "matrix(0.5092 -0.8606 0.8606 0.5092 -79.3734 325.2959)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect549 || (_rect549 = /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 232.1,
    transform: "matrix(0.5099 -0.8602 0.8602 0.5099 -79.4439 324.9503)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon163 || (_polygon163 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "234.1,251.5 233.9,251.4 256.7,212.8 256.8,212.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect550 || (_rect550 = /*#__PURE__*/React.createElement("rect", {
    x: 222.9,
    y: 232,
    transform: "matrix(0.5073 -0.8618 0.8618 0.5073 -79.1575 325.7485)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon164 || (_polygon164 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "233.9,251.4 233.8,251.3 256.5,212.7 256.6,212.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect551 || (_rect551 = /*#__PURE__*/React.createElement("rect", {
    x: 222.7,
    y: 231.9,
    transform: "matrix(0.5092 -0.8606 0.8606 0.5092 -79.3668 324.8205)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon165 || (_polygon165 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "233.7,251.3 233.6,251.2 256.4,212.6 256.5,212.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon166 || (_polygon166 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "233.6,251.2 233.5,251.2 256.3,212.6 256.4,212.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon167 || (_polygon167 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "233.6,251.2 233.4,251.1 256.2,212.5 256.3,212.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon168 || (_polygon168 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "233.5,251.2 233.3,251.1 256.1,212.5 256.2,212.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect552 || (_rect552 = /*#__PURE__*/React.createElement("rect", {
    x: 222.3,
    y: 231.7,
    transform: "matrix(0.5072 -0.8618 0.8618 0.5072 -79.1448 325.095)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon169 || (_polygon169 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "233.3,251.1 233.2,251 255.9,212.4 256.1,212.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect553 || (_rect553 = /*#__PURE__*/React.createElement("rect", {
    x: 222.1,
    y: 231.6,
    transform: "matrix(0.5072 -0.8618 0.8618 0.5072 -79.1421 324.9056)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon170 || (_polygon170 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "233.1,251 233,250.9 255.8,212.3 255.9,212.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon171 || (_polygon171 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "233.1,250.9 232.9,250.8 255.7,212.2 255.8,212.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon172 || (_polygon172 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "233,250.9 232.9,250.8 255.6,212.2 255.7,212.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect554 || (_rect554 = /*#__PURE__*/React.createElement("rect", {
    x: 221.8,
    y: 231.4,
    transform: "matrix(0.5073 -0.8618 0.8618 0.5073 -79.1414 324.5101)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect555 || (_rect555 = /*#__PURE__*/React.createElement("rect", {
    x: 221.7,
    y: 231.3,
    transform: "matrix(0.5058 -0.8627 0.8627 0.5058 -78.9828 324.9597)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon173 || (_polygon173 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "232.7,250.7 232.6,250.6 255.4,212 255.5,212.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect556 || (_rect556 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 231.2,
    transform: "matrix(0.5058 -0.8627 0.8627 0.5058 -78.9767 324.7821)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon174 || (_polygon174 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "232.6,250.6 232.4,250.5 255.2,211.9 255.3,212  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon175 || (_polygon175 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "232.5,250.6 232.4,250.5 255.1,211.9 255.2,211.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon176 || (_polygon176 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "232.4,250.5 232.3,250.4 255,211.8 255.2,211.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon177 || (_polygon177 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "232.3,250.5 232.2,250.4 254.9,211.8 255.1,211.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon178 || (_polygon178 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "232.2,250.4 232.1,250.3 254.9,211.7 255,211.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon179 || (_polygon179 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "232.1,250.4 232,250.3 254.8,211.7 254.9,211.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon180 || (_polygon180 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "232.1,250.3 231.9,250.3 254.7,211.6 254.8,211.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon181 || (_polygon181 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "232,250.3 231.9,250.2 254.6,211.6 254.7,211.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect557 || (_rect557 = /*#__PURE__*/React.createElement("rect", {
    x: 220.8,
    y: 230.8,
    transform: "matrix(0.5079 -0.8614 0.8614 0.5079 -79.1938 323.1322)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon182 || (_polygon182 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "231.8,250.2 231.7,250.1 254.4,211.5 254.6,211.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon183 || (_polygon183 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "231.7,250.1 231.6,250.1 254.4,211.4 254.5,211.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon184 || (_polygon184 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "231.7,250.1 231.5,250 254.3,211.4 254.4,211.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon185 || (_polygon185 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "231.6,250 231.4,250 254.2,211.3 254.3,211.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect558 || (_rect558 = /*#__PURE__*/React.createElement("rect", {
    x: 220.4,
    y: 230.6,
    transform: "matrix(0.5084 -0.8611 0.8611 0.5084 -79.2455 322.4519)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon186 || (_polygon186 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "231.4,249.9 231.3,249.9 254,211.2 254.2,211.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect559 || (_rect559 = /*#__PURE__*/React.createElement("rect", {
    x: 220.2,
    y: 230.5,
    transform: "matrix(0.5076 -0.8616 0.8616 0.5076 -79.1558 322.5674)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon187 || (_polygon187 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "231.2,249.8 231.1,249.8 253.9,211.1 254,211.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect560 || (_rect560 = /*#__PURE__*/React.createElement("rect", {
    x: 220.1,
    y: 230.4,
    transform: "matrix(0.5088 -0.8609 0.8609 0.5088 -79.2819 321.9248)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon188 || (_polygon188 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "231.1,249.7 230.9,249.7 253.7,211 253.8,211.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon189 || (_polygon189 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "231,249.7 230.9,249.6 253.6,211 253.7,211.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon190 || (_polygon190 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "230.9,249.6 230.8,249.6 253.5,210.9 253.7,211  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect561 || (_rect561 = /*#__PURE__*/React.createElement("rect", {
    x: 219.7,
    y: 230.2,
    transform: "matrix(0.5053 -0.863 0.863 0.5053 -78.897 322.8709)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect562 || (_rect562 = /*#__PURE__*/React.createElement("rect", {
    x: 219.6,
    y: 230.1,
    transform: "matrix(0.5076 -0.8616 0.8616 0.5076 -79.1506 321.8877)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon191 || (_polygon191 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "230.7,249.5 230.5,249.4 253.3,210.8 253.4,210.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon192 || (_polygon192 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "230.6,249.4 230.5,249.4 253.2,210.8 253.3,210.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon193 || (_polygon193 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "230.5,249.4 230.4,249.3 253.1,210.7 253.3,210.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon194 || (_polygon194 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "230.4,249.3 230.3,249.3 253,210.7 253.2,210.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect563 || (_rect563 = /*#__PURE__*/React.createElement("rect", {
    x: 219.2,
    y: 229.9,
    transform: "matrix(0.5095 -0.8605 0.8605 0.5095 -79.3388 320.7263)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect564 || (_rect564 = /*#__PURE__*/React.createElement("rect", {
    x: 219.1,
    y: 229.8,
    transform: "matrix(0.5073 -0.8618 0.8618 0.5073 -79.1016 321.4616)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect565 || (_rect565 = /*#__PURE__*/React.createElement("rect", {
    x: 219.1,
    y: 229.8,
    transform: "matrix(0.5062 -0.8624 0.8624 0.5062 -78.9837 321.7744)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect566 || (_rect566 = /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 229.7,
    transform: "matrix(0.5092 -0.8606 0.8606 0.5092 -79.3063 320.5421)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon195 || (_polygon195 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "230,249.1 229.9,249 252.6,210.4 252.8,210.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon196 || (_polygon196 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "229.9,249.1 229.8,249 252.5,210.4 252.7,210.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon197 || (_polygon197 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "229.8,249 229.7,248.9 252.5,210.3 252.6,210.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect567 || (_rect567 = /*#__PURE__*/React.createElement("rect", {
    x: 218.7,
    y: 229.5,
    transform: "matrix(0.5083 -0.8612 0.8612 0.5083 -79.2055 320.4983)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect568 || (_rect568 = /*#__PURE__*/React.createElement("rect", {
    x: 218.6,
    y: 229.5,
    transform: "matrix(0.5073 -0.8618 0.8618 0.5073 -79.0929 320.7948)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon198 || (_polygon198 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "229.6,248.9 229.5,248.8 252.2,210.2 252.3,210.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon199 || (_polygon199 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "229.5,248.8 229.4,248.7 252.1,210.1 252.3,210.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon200 || (_polygon200 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "229.4,248.8 229.3,248.7 252.1,210.1 252.2,210.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon201 || (_polygon201 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "229.3,248.7 229.2,248.6 252,210 252.1,210.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon202 || (_polygon202 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "229.3,248.7 229.1,248.6 251.9,210 252,210  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon203 || (_polygon203 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "229.2,248.6 229,248.5 251.8,209.9 251.9,210  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect569 || (_rect569 = /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 229.1,
    transform: "matrix(0.5088 -0.8609 0.8609 0.5088 -79.2488 319.5471)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon204 || (_polygon204 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "229,248.5 228.9,248.4 251.6,209.8 251.8,209.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon205 || (_polygon205 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "228.9,248.5 228.8,248.4 251.6,209.8 251.7,209.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon206 || (_polygon206 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "228.8,248.4 228.7,248.4 251.5,209.7 251.6,209.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect570 || (_rect570 = /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 229,
    transform: "matrix(0.5072 -0.8618 0.8618 0.5072 -79.0754 319.7608)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect571 || (_rect571 = /*#__PURE__*/React.createElement("rect", {
    x: 217.6,
    y: 228.9,
    transform: "matrix(0.5079 -0.8614 0.8614 0.5079 -79.1478 319.4061)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon207 || (_polygon207 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "228.6,248.3 228.5,248.2 251.2,209.6 251.3,209.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect572 || (_rect572 = /*#__PURE__*/React.createElement("rect", {
    x: 217.4,
    y: 228.8,
    transform: "matrix(0.5092 -0.8606 0.8606 0.5092 -79.2806 318.7357)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon208 || (_polygon208 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "228.4,248.2 228.3,248.1 251.1,209.5 251.2,209.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon209 || (_polygon209 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "228.3,248.1 228.2,248.1 251,209.4 251.1,209.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon210 || (_polygon210 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "228.3,248.1 228.1,248 250.9,209.4 251,209.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect573 || (_rect573 = /*#__PURE__*/React.createElement("rect", {
    x: 217.1,
    y: 228.6,
    transform: "matrix(0.5053 -0.863 0.863 0.5053 -78.8608 319.8163)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect574 || (_rect574 = /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 228.6,
    transform: "matrix(0.508 -0.8614 0.8614 0.508 -79.1424 318.7267)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon211 || (_polygon211 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "228,247.9 227.9,247.9 250.6,209.2 250.8,209.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon212 || (_polygon212 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "227.9,247.9 227.8,247.8 250.6,209.2 250.7,209.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon213 || (_polygon213 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "227.8,247.8 227.7,247.8 250.5,209.1 250.6,209.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon214 || (_polygon214 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "227.8,247.8 227.6,247.7 250.4,209.1 250.5,209.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon215 || (_polygon215 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "227.7,247.7 227.6,247.7 250.3,209 250.4,209.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect575 || (_rect575 = /*#__PURE__*/React.createElement("rect", {
    x: 216.5,
    y: 228.3,
    transform: "matrix(0.5073 -0.8618 0.8618 0.5073 -79.0621 318.413)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect576 || (_rect576 = /*#__PURE__*/React.createElement("rect", {
    x: 216.4,
    y: 228.2,
    transform: "matrix(0.5076 -0.8616 0.8616 0.5076 -79.1015 318.1737)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect577 || (_rect577 = /*#__PURE__*/React.createElement("rect", {
    x: 216.3,
    y: 228.2,
    transform: "matrix(0.5088 -0.8609 0.8609 0.5088 -79.2225 317.6448)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect578 || (_rect578 = /*#__PURE__*/React.createElement("rect", {
    x: 216.3,
    y: 228.1,
    transform: "matrix(0.5055 -0.8628 0.8628 0.5055 -78.8734 318.7776)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon216 || (_polygon216 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "227.3,247.5 227.1,247.4 249.9,208.8 250,208.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon217 || (_polygon217 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "227.2,247.4 227.1,247.4 249.8,208.8 249.9,208.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect579 || (_rect579 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 228,
    transform: "matrix(0.5079 -0.8614 0.8614 0.5079 -79.1234 317.5972)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect580 || (_rect580 = /*#__PURE__*/React.createElement("rect", {
    x: 215.9,
    y: 227.9,
    transform: "matrix(0.5073 -0.8618 0.8618 0.5073 -79.0534 317.7462)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect581 || (_rect581 = /*#__PURE__*/React.createElement("rect", {
    x: 215.8,
    y: 227.9,
    transform: "matrix(0.5065 -0.8622 0.8622 0.5065 -78.9785 317.9107)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon218 || (_polygon218 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "226.9,247.3 226.7,247.2 249.5,208.6 249.6,208.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon219 || (_polygon219 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "226.8,247.2 226.6,247.1 249.4,208.5 249.5,208.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon220 || (_polygon220 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "226.7,247.2 226.6,247.1 249.3,208.5 249.4,208.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon221 || (_polygon221 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "226.6,247.1 226.5,247 249.2,208.4 249.4,208.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon222 || (_polygon222 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "226.5,247.1 226.4,247 249.2,208.4 249.3,208.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect582 || (_rect582 = /*#__PURE__*/React.createElement("rect", {
    x: 215.3,
    y: 227.6,
    transform: "matrix(0.5084 -0.8611 0.8611 0.5084 -79.166 316.6478)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon223 || (_polygon223 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "226.4,247 226.2,246.9 249,208.3 249.1,208.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon224 || (_polygon224 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "226.3,246.9 226.2,246.8 248.9,208.2 249,208.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon225 || (_polygon225 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "226.2,246.9 226.1,246.8 248.8,208.2 249,208.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect583 || (_rect583 = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 227.4,
    transform: "matrix(0.5075 -0.8617 0.8617 0.5075 -79.0641 316.6116)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect584 || (_rect584 = /*#__PURE__*/React.createElement("rect", {
    x: 214.9,
    y: 227.3,
    transform: "matrix(0.5076 -0.8616 0.8616 0.5076 -79.0789 316.4596)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon226 || (_polygon226 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "225.9,246.7 225.8,246.6 248.6,208 248.7,208.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect585 || (_rect585 = /*#__PURE__*/React.createElement("rect", {
    x: 214.8,
    y: 227.2,
    transform: "matrix(0.5088 -0.8609 0.8609 0.5088 -79.1972 315.8376)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon227 || (_polygon227 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "225.8,246.6 225.7,246.5 248.4,207.9 248.5,208  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon228 || (_polygon228 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "225.7,246.6 225.6,246.5 248.3,207.9 248.5,207.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon229 || (_polygon229 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "225.6,246.5 225.5,246.5 248.2,207.8 248.4,207.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect586 || (_rect586 = /*#__PURE__*/React.createElement("rect", {
    x: 214.4,
    y: 227.1,
    transform: "matrix(0.5068 -0.862 0.862 0.5068 -78.9866 316.1891)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect587 || (_rect587 = /*#__PURE__*/React.createElement("rect", {
    x: 214.4,
    y: 227,
    transform: "matrix(0.5083 -0.8612 0.8612 0.5083 -79.1382 315.5499)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon230 || (_polygon230 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "225.4,246.4 225.2,246.3 248,207.7 248.1,207.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect588 || (_rect588 = /*#__PURE__*/React.createElement("rect", {
    x: 214.2,
    y: 226.9,
    transform: "matrix(0.5055 -0.8628 0.8628 0.5055 -78.8448 316.3916)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon231 || (_polygon231 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "225.2,246.3 225.1,246.2 247.8,207.6 248,207.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon232 || (_polygon232 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "225.1,246.2 225,246.2 247.8,207.5 247.9,207.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect589 || (_rect589 = /*#__PURE__*/React.createElement("rect", {
    x: 213.9,
    y: 226.8,
    transform: "matrix(0.5084 -0.8611 0.8611 0.5084 -79.1439 315.0301)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect590 || (_rect590 = /*#__PURE__*/React.createElement("rect", {
    x: 213.9,
    y: 226.7,
    transform: "matrix(0.5052 -0.863 0.863 0.5052 -78.8131 316.1059)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect591 || (_rect591 = /*#__PURE__*/React.createElement("rect", {
    x: 213.8,
    y: 226.7,
    transform: "matrix(0.5079 -0.8614 0.8614 0.5079 -79.089 315.0268)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect592 || (_rect592 = /*#__PURE__*/React.createElement("rect", {
    x: 213.7,
    y: 226.6,
    transform: "matrix(0.5092 -0.8606 0.8606 0.5092 -79.2203 314.4574)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon233 || (_polygon233 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "224.7,246 224.6,245.9 247.3,207.3 247.5,207.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon234 || (_polygon234 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "224.6,245.9 224.5,245.9 247.3,207.2 247.4,207.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon235 || (_polygon235 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "224.5,245.9 224.4,245.8 247.2,207.2 247.3,207.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect593 || (_rect593 = /*#__PURE__*/React.createElement("rect", {
    x: 213.4,
    y: 226.4,
    transform: "matrix(0.5076 -0.8616 0.8616 0.5076 -79.0547 314.6502)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect594 || (_rect594 = /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: 226.4,
    transform: "matrix(0.5073 -0.8618 0.8618 0.5073 -79.0136 314.6977)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect595 || (_rect595 = /*#__PURE__*/React.createElement("rect", {
    x: 213.2,
    y: 226.3,
    transform: "matrix(0.5065 -0.8622 0.8622 0.5065 -78.94 314.86)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon236 || (_polygon236 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "224.2,245.7 224.1,245.6 246.8,207 247,207.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon237 || (_polygon237 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "224.1,245.6 224,245.6 246.8,207 246.9,207  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon238 || (_polygon238 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "224,245.6 223.9,245.5 246.7,206.9 246.8,207  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon239 || (_polygon239 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "224,245.5 223.8,245.5 246.6,206.9 246.7,206.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon240 || (_polygon240 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "223.9,245.5 223.8,245.4 246.5,206.8 246.6,206.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect596 || (_rect596 = /*#__PURE__*/React.createElement("rect", {
    x: 212.7,
    y: 226,
    transform: "matrix(0.508 -0.8613 0.8613 0.508 -79.0846 313.7458)",
    className: "st26",
    width: 44.8,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _polygon241 || (_polygon241 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "223.7,245.4 223.6,245.3 246.3,206.7 246.5,206.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051343609331057180520000003313875117586415755_)"
    }
  }, _rect597 || (_rect597 = /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 226,
    transform: "matrix(0.5052 -0.863 0.863 0.5052 -78.791 314.6641)",
    className: "st26",
    width: 44.8,
    height: 0
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000151530037918755669950000017342529220069561735_",
    d: "M209.9,258.4l-0.4-1.3l0,0l0,0l0,0l0,0l-13.1-38.5 h16.8h0h0h0.2c0.5,0,2,0.3,2.6,2.1l12.6,37c-0.6,0.5-1.4,0.7-1.7,0.7h-0.2h0h0H209.9z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000151530037918755669950000017342529220069561735_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181772536708215556400000014328473469684210051_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000151530037918755669950000017342529220069561735_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect598 || (_rect598 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 218.5,
    className: "st26",
    width: 32.2,
    height: 15
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect599 || (_rect599 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 233.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect600 || (_rect600 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 233.6,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect601 || (_rect601 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 233.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect602 || (_rect602 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 233.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect603 || (_rect603 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 233.9,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect604 || (_rect604 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 234.1,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect605 || (_rect605 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 234.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect606 || (_rect606 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 234.3,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect607 || (_rect607 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 234.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _polygon242 || (_polygon242 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "228.5,234.5 228.5,234.6 196.3,234.6 196.3,234.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect608 || (_rect608 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 234.6,
    transform: "matrix(1 -3.294875e-03 3.294875e-03 1 -0.772 0.7011)",
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect609 || (_rect609 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 234.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect610 || (_rect610 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 234.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect611 || (_rect611 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 234.9,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect612 || (_rect612 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 235,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect613 || (_rect613 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 235.1,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect614 || (_rect614 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 235.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect615 || (_rect615 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 235.3,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect616 || (_rect616 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 235.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect617 || (_rect617 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 235.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect618 || (_rect618 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 235.6,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect619 || (_rect619 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 235.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect620 || (_rect620 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 235.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect621 || (_rect621 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 235.9,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect622 || (_rect622 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 236,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect623 || (_rect623 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 236.1,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect624 || (_rect624 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 236.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect625 || (_rect625 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 236.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect626 || (_rect626 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 236.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect627 || (_rect627 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 236.6,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect628 || (_rect628 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 236.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect629 || (_rect629 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 236.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect630 || (_rect630 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 236.9,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect631 || (_rect631 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 237,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect632 || (_rect632 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 237.1,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect633 || (_rect633 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 237.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect634 || (_rect634 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 237.3,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect635 || (_rect635 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 237.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect636 || (_rect636 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 237.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect637 || (_rect637 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 237.6,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect638 || (_rect638 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 237.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect639 || (_rect639 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 237.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect640 || (_rect640 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 237.9,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _polygon243 || (_polygon243 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "228.5,238 228.5,238.2 196.3,238.2 196.3,238  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect641 || (_rect641 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 238.1,
    transform: "matrix(1 -4.192532e-03 4.192532e-03 1 -0.9968 0.8926)",
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect642 || (_rect642 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 238.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect643 || (_rect643 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 238.3,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect644 || (_rect644 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 238.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect645 || (_rect645 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 238.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect646 || (_rect646 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 238.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect647 || (_rect647 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 238.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect648 || (_rect648 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 238.9,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect649 || (_rect649 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 239,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect650 || (_rect650 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 239.1,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect651 || (_rect651 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 239.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect652 || (_rect652 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 239.3,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect653 || (_rect653 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 239.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect654 || (_rect654 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 239.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect655 || (_rect655 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 239.6,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect656 || (_rect656 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 239.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect657 || (_rect657 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 239.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect658 || (_rect658 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 239.9,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect659 || (_rect659 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 240,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect660 || (_rect660 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 240.1,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect661 || (_rect661 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 240.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect662 || (_rect662 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 240.3,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect663 || (_rect663 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 240.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect664 || (_rect664 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 240.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect665 || (_rect665 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 240.6,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect666 || (_rect666 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 240.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect667 || (_rect667 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 240.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect668 || (_rect668 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 241,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect669 || (_rect669 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 241.1,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect670 || (_rect670 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 241.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect671 || (_rect671 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 241.3,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect672 || (_rect672 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 241.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect673 || (_rect673 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 241.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _polygon244 || (_polygon244 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "228.5,241.6 228.5,241.7 196.3,241.7 196.3,241.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect674 || (_rect674 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 241.7,
    transform: "matrix(1 -3.218272e-03 3.218272e-03 1 -0.7769 0.6848)",
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect675 || (_rect675 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 241.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect676 || (_rect676 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 241.9,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect677 || (_rect677 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 242,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect678 || (_rect678 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 242.1,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect679 || (_rect679 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 242.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect680 || (_rect680 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 242.3,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect681 || (_rect681 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 242.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect682 || (_rect682 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 242.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect683 || (_rect683 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 242.6,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect684 || (_rect684 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 242.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect685 || (_rect685 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 242.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect686 || (_rect686 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 242.9,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect687 || (_rect687 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 243,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect688 || (_rect688 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 243.1,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect689 || (_rect689 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 243.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect690 || (_rect690 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 243.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect691 || (_rect691 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 243.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect692 || (_rect692 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 243.6,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect693 || (_rect693 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 243.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect694 || (_rect694 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 243.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect695 || (_rect695 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 243.9,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect696 || (_rect696 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 244,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect697 || (_rect697 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 244.1,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect698 || (_rect698 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 244.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect699 || (_rect699 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 244.3,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect700 || (_rect700 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 244.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect701 || (_rect701 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 244.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect702 || (_rect702 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 244.6,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect703 || (_rect703 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 244.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect704 || (_rect704 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 244.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect705 || (_rect705 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 244.9,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect706 || (_rect706 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 245,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _polygon245 || (_polygon245 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "228.5,245.1 228.5,245.3 196.3,245.3 196.3,245.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect707 || (_rect707 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 245.2,
    transform: "matrix(1 -3.286753e-03 3.286753e-03 1 -0.8051 0.6995)",
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect708 || (_rect708 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 245.3,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect709 || (_rect709 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 245.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect710 || (_rect710 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 245.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect711 || (_rect711 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 245.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect712 || (_rect712 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 245.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect713 || (_rect713 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 245.9,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect714 || (_rect714 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 246,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect715 || (_rect715 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 246.1,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect716 || (_rect716 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 246.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect717 || (_rect717 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 246.3,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect718 || (_rect718 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 246.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect719 || (_rect719 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 246.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect720 || (_rect720 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 246.6,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect721 || (_rect721 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 246.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect722 || (_rect722 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 246.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect723 || (_rect723 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 246.9,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect724 || (_rect724 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 247,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect725 || (_rect725 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 247.1,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect726 || (_rect726 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 247.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect727 || (_rect727 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 247.3,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect728 || (_rect728 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 247.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect729 || (_rect729 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 247.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect730 || (_rect730 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 247.6,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect731 || (_rect731 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 247.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect732 || (_rect732 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 247.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect733 || (_rect733 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 248,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect734 || (_rect734 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 248.1,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect735 || (_rect735 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 248.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect736 || (_rect736 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 248.3,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect737 || (_rect737 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 248.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect738 || (_rect738 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 248.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect739 || (_rect739 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 248.6,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect740 || (_rect740 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 248.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect741 || (_rect741 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 248.8,
    transform: "matrix(1 -2.469128e-03 2.469128e-03 1 -0.6138 0.5252)",
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect742 || (_rect742 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 248.9,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect743 || (_rect743 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 249,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect744 || (_rect744 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 249.1,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect745 || (_rect745 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 249.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect746 || (_rect746 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 249.3,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect747 || (_rect747 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 249.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect748 || (_rect748 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 249.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect749 || (_rect749 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 249.6,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect750 || (_rect750 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 249.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect751 || (_rect751 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 249.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect752 || (_rect752 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 249.9,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect753 || (_rect753 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 250,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect754 || (_rect754 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 250.1,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect755 || (_rect755 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 250.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect756 || (_rect756 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 250.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect757 || (_rect757 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 250.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect758 || (_rect758 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 250.6,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect759 || (_rect759 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 250.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect760 || (_rect760 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 250.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect761 || (_rect761 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 250.9,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect762 || (_rect762 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 251,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect763 || (_rect763 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 251.1,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect764 || (_rect764 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 251.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect765 || (_rect765 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 251.3,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect766 || (_rect766 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 251.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect767 || (_rect767 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 251.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect768 || (_rect768 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 251.6,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect769 || (_rect769 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 251.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect770 || (_rect770 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 251.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect771 || (_rect771 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 251.9,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect772 || (_rect772 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 252,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect773 || (_rect773 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 252.1,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect774 || (_rect774 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 252.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect775 || (_rect775 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 252.3,
    transform: "matrix(1 -3.292163e-03 3.292163e-03 1 -0.8298 0.7007)",
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect776 || (_rect776 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 252.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect777 || (_rect777 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 252.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect778 || (_rect778 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 252.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect779 || (_rect779 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 252.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect780 || (_rect780 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 252.9,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect781 || (_rect781 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 253,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect782 || (_rect782 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 253.1,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect783 || (_rect783 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 253.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect784 || (_rect784 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 253.3,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect785 || (_rect785 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 253.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect786 || (_rect786 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 253.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect787 || (_rect787 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 253.6,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect788 || (_rect788 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 253.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect789 || (_rect789 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 253.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect790 || (_rect790 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 253.9,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect791 || (_rect791 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 254,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect792 || (_rect792 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 254.1,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect793 || (_rect793 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 254.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect794 || (_rect794 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 254.3,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect795 || (_rect795 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 254.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect796 || (_rect796 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 254.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect797 || (_rect797 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 254.6,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect798 || (_rect798 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 254.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect799 || (_rect799 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 254.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect800 || (_rect800 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 255,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect801 || (_rect801 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 255.1,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect802 || (_rect802 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 255.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect803 || (_rect803 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 255.3,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect804 || (_rect804 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 255.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect805 || (_rect805 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 255.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect806 || (_rect806 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 255.6,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect807 || (_rect807 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 255.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect808 || (_rect808 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 255.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect809 || (_rect809 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 255.9,
    transform: "matrix(1 -4.175336e-03 4.175336e-03 1 -1.0669 0.8891)",
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect810 || (_rect810 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 256,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect811 || (_rect811 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 256.1,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect812 || (_rect812 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 256.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect813 || (_rect813 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 256.3,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect814 || (_rect814 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 256.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect815 || (_rect815 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 256.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect816 || (_rect816 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 256.6,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect817 || (_rect817 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 256.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect818 || (_rect818 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 256.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect819 || (_rect819 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 256.9,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect820 || (_rect820 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 257,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect821 || (_rect821 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 257.1,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect822 || (_rect822 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 257.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect823 || (_rect823 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 257.4,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect824 || (_rect824 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 257.5,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect825 || (_rect825 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 257.6,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect826 || (_rect826 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 257.7,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect827 || (_rect827 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 257.8,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect828 || (_rect828 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 257.9,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect829 || (_rect829 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 258,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect830 || (_rect830 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 258.1,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect831 || (_rect831 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 258.2,
    className: "st26",
    width: 32.2,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181772536708215556400000014328473469684210051_)"
    }
  }, _rect832 || (_rect832 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 258.3,
    className: "st26",
    width: 32.2,
    height: 0.1
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000121241299597145594260000015563814212985291704_",
    d: "M209.9,258.4l-0.4-1.3l0,0l0,0l0,0l0,0l-13.1-38.5 l32.3,39.2c-0.6,0.5-1.4,0.7-1.7,0.7h-0.2h0h0H209.9z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121241299597145594260000015563814212985291704_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044175951895231936110000003200735394139863177_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121241299597145594260000015563814212985291704_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect833 || (_rect833 = /*#__PURE__*/React.createElement("rect", {
    x: 200.8,
    y: 221.3,
    transform: "matrix(0.7835 -0.6214 0.6214 0.7835 -109.6087 178.7172)",
    className: "st26",
    width: 1.7,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon246 || (_polygon246 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "186.5,226.3 186.7,226.1 218.2,265.9 218.1,266.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect834 || (_rect834 = /*#__PURE__*/React.createElement("rect", {
    x: 202.4,
    y: 220.6,
    transform: "matrix(0.784 -0.6207 0.6207 0.784 -108.9753 178.8205)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect835 || (_rect835 = /*#__PURE__*/React.createElement("rect", {
    x: 202.5,
    y: 220.5,
    transform: "matrix(0.7826 -0.6226 0.6226 0.7826 -109.0529 179.6021)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon247 || (_polygon247 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "186.9,226 187,225.9 218.6,265.7 218.4,265.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect836 || (_rect836 = /*#__PURE__*/React.createElement("rect", {
    x: 202.7,
    y: 220.4,
    transform: "matrix(0.784 -0.6207 0.6207 0.784 -108.7371 178.9647)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon248 || (_polygon248 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "187.1,225.8 187.2,225.7 218.8,265.5 218.6,265.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect837 || (_rect837 = /*#__PURE__*/React.createElement("rect", {
    x: 202.9,
    y: 220.2,
    transform: "matrix(0.7821 -0.6231 0.6231 0.7821 -108.785 180.0375)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect838 || (_rect838 = /*#__PURE__*/React.createElement("rect", {
    x: 203.1,
    y: 220.1,
    transform: "matrix(0.7829 -0.6222 0.6222 0.7829 -108.6252 179.7057)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect839 || (_rect839 = /*#__PURE__*/React.createElement("rect", {
    x: 203.2,
    y: 220,
    transform: "matrix(0.7847 -0.6198 0.6198 0.7847 -108.3464 178.8147)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon249 || (_polygon249 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "187.5,225.5 187.7,225.4 219.2,265.1 219.1,265.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect840 || (_rect840 = /*#__PURE__*/React.createElement("rect", {
    x: 203.4,
    y: 219.8,
    transform: "matrix(0.7833 -0.6217 0.6217 0.7833 -108.3427 179.6429)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect841 || (_rect841 = /*#__PURE__*/React.createElement("rect", {
    x: 203.5,
    y: 219.7,
    transform: "matrix(0.7829 -0.6222 0.6222 0.7829 -108.3082 179.9064)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect842 || (_rect842 = /*#__PURE__*/React.createElement("rect", {
    x: 203.6,
    y: 219.7,
    transform: "matrix(0.7838 -0.621 0.621 0.7838 -108.1297 179.4831)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect843 || (_rect843 = /*#__PURE__*/React.createElement("rect", {
    x: 203.7,
    y: 219.6,
    transform: "matrix(0.7835 -0.6214 0.6214 0.7835 -108.0817 179.681)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect844 || (_rect844 = /*#__PURE__*/React.createElement("rect", {
    x: 203.8,
    y: 219.5,
    transform: "matrix(0.7823 -0.6229 0.6229 0.7823 -108.1254 180.3219)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect845 || (_rect845 = /*#__PURE__*/React.createElement("rect", {
    x: 203.9,
    y: 219.4,
    transform: "matrix(0.7839 -0.6209 0.6209 0.7839 -107.8874 179.6084)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect846 || (_rect846 = /*#__PURE__*/React.createElement("rect", {
    x: 204.1,
    y: 219.3,
    transform: "matrix(0.7829 -0.6222 0.6222 0.7829 -107.9119 180.1574)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect847 || (_rect847 = /*#__PURE__*/React.createElement("rect", {
    x: 204.2,
    y: 219.2,
    transform: "matrix(0.7844 -0.6202 0.6202 0.7844 -107.6678 179.4133)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon250 || (_polygon250 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "188.5,224.7 188.7,224.6 220.2,264.3 220.1,264.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect848 || (_rect848 = /*#__PURE__*/React.createElement("rect", {
    x: 204.4,
    y: 219,
    transform: "matrix(0.7839 -0.6209 0.6209 0.7839 -107.5713 179.809)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon251 || (_polygon251 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "188.8,224.5 188.9,224.4 220.5,264.2 220.3,264.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect849 || (_rect849 = /*#__PURE__*/React.createElement("rect", {
    x: 204.6,
    y: 218.9,
    transform: "matrix(0.784 -0.6207 0.6207 0.784 -107.3942 179.817)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect850 || (_rect850 = /*#__PURE__*/React.createElement("rect", {
    x: 204.7,
    y: 218.8,
    transform: "matrix(0.7844 -0.6202 0.6202 0.7844 -107.2753 179.6735)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect851 || (_rect851 = /*#__PURE__*/React.createElement("rect", {
    x: 204.8,
    y: 218.7,
    transform: "matrix(0.7829 -0.6221 0.6221 0.7829 -107.3511 180.4785)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect852 || (_rect852 = /*#__PURE__*/React.createElement("rect", {
    x: 204.9,
    y: 218.6,
    transform: "matrix(0.7836 -0.6213 0.6213 0.7836 -107.2063 180.2073)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon252 || (_polygon252 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "189.3,224.1 189.5,223.9 221,263.7 220.9,263.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon253 || (_polygon253 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "189.4,224 189.6,223.8 221.1,263.6 221,263.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect853 || (_rect853 = /*#__PURE__*/React.createElement("rect", {
    x: 205.3,
    y: 218.3,
    transform: "matrix(0.7829 -0.6221 0.6221 0.7829 -107.0322 180.6695)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon254 || (_polygon254 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "189.6,223.8 189.8,223.7 221.4,263.4 221.2,263.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect854 || (_rect854 = /*#__PURE__*/React.createElement("rect", {
    x: 205.5,
    y: 218.2,
    transform: "matrix(0.7833 -0.6217 0.6217 0.7833 -106.8406 180.6057)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect855 || (_rect855 = /*#__PURE__*/React.createElement("rect", {
    x: 205.6,
    y: 218.1,
    transform: "matrix(0.7835 -0.6214 0.6214 0.7835 -106.7369 180.5337)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect856 || (_rect856 = /*#__PURE__*/React.createElement("rect", {
    x: 205.7,
    y: 218,
    transform: "matrix(0.7853 -0.6192 0.6192 0.7853 -106.4793 179.7019)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon255 || (_polygon255 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "190.1,223.5 190.3,223.3 221.8,263.1 221.6,263.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect857 || (_rect857 = /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 217.8,
    transform: "matrix(0.7835 -0.6214 0.6214 0.7835 -106.5005 180.6893)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect858 || (_rect858 = /*#__PURE__*/React.createElement("rect", {
    x: 206.1,
    y: 217.7,
    transform: "matrix(0.7834 -0.6215 0.6215 0.7834 -106.4326 180.7955)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect859 || (_rect859 = /*#__PURE__*/React.createElement("rect", {
    x: 206.2,
    y: 217.6,
    transform: "matrix(0.7841 -0.6206 0.6206 0.7841 -106.2822 180.488)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect860 || (_rect860 = /*#__PURE__*/React.createElement("rect", {
    x: 206.3,
    y: 217.5,
    transform: "matrix(0.7838 -0.621 0.621 0.7838 -106.234 180.6922)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect861 || (_rect861 = /*#__PURE__*/React.createElement("rect", {
    x: 206.4,
    y: 217.4,
    transform: "matrix(0.7826 -0.6226 0.6226 0.7826 -106.2767 181.3593)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect862 || (_rect862 = /*#__PURE__*/React.createElement("rect", {
    x: 206.5,
    y: 217.4,
    transform: "matrix(0.7838 -0.621 0.621 0.7838 -106.0758 180.7924)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon256 || (_polygon256 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "190.9,222.8 191,222.7 222.6,262.5 222.4,262.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon257 || (_polygon257 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "191,222.7 191.2,222.6 222.7,262.4 222.5,262.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon258 || (_polygon258 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "191.1,222.7 191.3,222.5 222.8,262.3 222.6,262.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect863 || (_rect863 = /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 217,
    transform: "matrix(0.7831 -0.6219 0.6219 0.7831 -105.8303 181.3546)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect864 || (_rect864 = /*#__PURE__*/React.createElement("rect", {
    x: 207.1,
    y: 216.9,
    transform: "matrix(0.784 -0.6207 0.6207 0.784 -105.6576 180.9261)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect865 || (_rect865 = /*#__PURE__*/React.createElement("rect", {
    x: 207.2,
    y: 216.8,
    transform: "matrix(0.784 -0.6208 0.6208 0.784 -105.5835 181.0009)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect866 || (_rect866 = /*#__PURE__*/React.createElement("rect", {
    x: 207.3,
    y: 216.7,
    transform: "matrix(0.7837 -0.6211 0.6211 0.7837 -105.5285 181.1741)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect867 || (_rect867 = /*#__PURE__*/React.createElement("rect", {
    x: 207.4,
    y: 216.7,
    transform: "matrix(0.7831 -0.6219 0.6219 0.7831 -105.5117 181.5456)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect868 || (_rect868 = /*#__PURE__*/React.createElement("rect", {
    x: 207.5,
    y: 216.6,
    transform: "matrix(0.7838 -0.621 0.621 0.7838 -105.3644 181.2437)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect869 || (_rect869 = /*#__PURE__*/React.createElement("rect", {
    x: 207.6,
    y: 216.5,
    transform: "matrix(0.784 -0.6208 0.6208 0.784 -105.2675 181.2013)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect870 || (_rect870 = /*#__PURE__*/React.createElement("rect", {
    x: 207.7,
    y: 216.4,
    transform: "matrix(0.784 -0.6208 0.6208 0.784 -105.1884 181.2516)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect871 || (_rect871 = /*#__PURE__*/React.createElement("rect", {
    x: 207.8,
    y: 216.3,
    transform: "matrix(0.7831 -0.6219 0.6219 0.7831 -105.1949 181.7463)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect872 || (_rect872 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 216.2,
    transform: "matrix(0.7831 -0.6219 0.6219 0.7831 -105.1138 181.7868)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect873 || (_rect873 = /*#__PURE__*/React.createElement("rect", {
    x: 208.1,
    y: 216.1,
    transform: "matrix(0.7841 -0.6206 0.6206 0.7841 -104.9408 181.3463)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect874 || (_rect874 = /*#__PURE__*/React.createElement("rect", {
    x: 208.2,
    y: 216,
    transform: "matrix(0.784 -0.6208 0.6208 0.784 -104.8725 181.4521)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect875 || (_rect875 = /*#__PURE__*/React.createElement("rect", {
    x: 208.3,
    y: 215.9,
    transform: "matrix(0.7843 -0.6203 0.6203 0.7843 -104.7604 181.3295)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon259 || (_polygon259 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "192.7,221.4 192.8,221.3 224.4,261.1 224.2,261.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect876 || (_rect876 = /*#__PURE__*/React.createElement("rect", {
    x: 208.5,
    y: 215.8,
    transform: "matrix(0.7828 -0.6223 0.6223 0.7828 -104.7476 182.1956)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect877 || (_rect877 = /*#__PURE__*/React.createElement("rect", {
    x: 208.6,
    y: 215.7,
    transform: "matrix(0.7838 -0.6211 0.6211 0.7838 -104.5787 181.7702)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon260 || (_polygon260 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "193,221.2 193.2,221 224.7,260.8 224.5,260.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect878 || (_rect878 = /*#__PURE__*/React.createElement("rect", {
    x: 208.9,
    y: 215.5,
    transform: "matrix(0.7843 -0.6204 0.6204 0.7843 -104.3676 181.5898)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon261 || (_polygon261 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "193.2,221 193.4,220.8 224.9,260.6 224.8,260.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect879 || (_rect879 = /*#__PURE__*/React.createElement("rect", {
    x: 209.1,
    y: 215.3,
    transform: "matrix(0.7838 -0.6211 0.6211 0.7838 -104.2617 181.9667)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon262 || (_polygon262 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "193.4,220.8 193.6,220.7 225.1,260.4 225,260.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect880 || (_rect880 = /*#__PURE__*/React.createElement("rect", {
    x: 209.3,
    y: 215.1,
    transform: "matrix(0.7834 -0.6215 0.6215 0.7834 -104.1378 182.2504)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect881 || (_rect881 = /*#__PURE__*/React.createElement("rect", {
    x: 209.4,
    y: 215.1,
    transform: "matrix(0.7826 -0.6226 0.6226 0.7826 -104.1352 182.7149)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect882 || (_rect882 = /*#__PURE__*/React.createElement("rect", {
    x: 209.5,
    y: 215,
    transform: "matrix(0.7829 -0.6222 0.6222 0.7829 -104.0285 182.6169)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon263 || (_polygon263 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "193.9,220.4 194.1,220.3 225.6,260.1 225.4,260.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon264 || (_polygon264 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "194,220.4 194.2,220.2 225.7,260 225.5,260.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect883 || (_rect883 = /*#__PURE__*/React.createElement("rect", {
    x: 209.9,
    y: 214.7,
    transform: "matrix(0.7833 -0.6217 0.6217 0.7833 -103.7533 182.5625)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon265 || (_polygon265 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "194.2,220.2 194.4,220 225.9,259.8 225.8,260  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect884 || (_rect884 = /*#__PURE__*/React.createElement("rect", {
    x: 210.1,
    y: 214.5,
    transform: "matrix(0.7832 -0.6218 0.6218 0.7832 -103.6052 182.7194)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect885 || (_rect885 = /*#__PURE__*/React.createElement("rect", {
    x: 210.2,
    y: 214.4,
    transform: "matrix(0.7837 -0.6211 0.6211 0.7837 -103.4737 182.4821)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect886 || (_rect886 = /*#__PURE__*/React.createElement("rect", {
    x: 210.3,
    y: 214.4,
    transform: "matrix(0.7823 -0.6229 0.6229 0.7823 -103.5219 183.2347)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect887 || (_rect887 = /*#__PURE__*/React.createElement("rect", {
    x: 210.4,
    y: 214.3,
    transform: "matrix(0.7835 -0.6213 0.6213 0.7835 -103.3323 182.6748)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect888 || (_rect888 = /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 214.2,
    transform: "matrix(0.7829 -0.6221 0.6221 0.7829 -103.3098 183.0381)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon266 || (_polygon266 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "194.9,219.6 195.1,219.5 226.6,259.3 226.4,259.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect889 || (_rect889 = /*#__PURE__*/React.createElement("rect", {
    x: 210.7,
    y: 214,
    transform: "matrix(0.7835 -0.6213 0.6213 0.7835 -103.0962 182.8311)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon267 || (_polygon267 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "195.1,219.5 195.3,219.3 226.8,259.1 226.7,259.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect890 || (_rect890 = /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 213.8,
    transform: "matrix(0.7829 -0.6221 0.6221 0.7829 -102.9911 183.229)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect891 || (_rect891 = /*#__PURE__*/React.createElement("rect", {
    x: 211.1,
    y: 213.7,
    transform: "matrix(0.7826 -0.6225 0.6225 0.7826 -102.94 183.4377)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect892 || (_rect892 = /*#__PURE__*/React.createElement("rect", {
    x: 211.2,
    y: 213.6,
    transform: "matrix(0.7844 -0.6202 0.6202 0.7844 -102.6972 182.5703)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon268 || (_polygon268 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "195.6,219.1 195.7,219 227.3,258.8 227.1,258.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect893 || (_rect893 = /*#__PURE__*/React.createElement("rect", {
    x: 211.4,
    y: 213.5,
    transform: "matrix(0.7836 -0.6213 0.6213 0.7836 -102.6188 183.1164)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect894 || (_rect894 = /*#__PURE__*/React.createElement("rect", {
    x: 211.5,
    y: 213.4,
    transform: "matrix(0.7826 -0.6225 0.6225 0.7826 -102.6245 183.6483)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect895 || (_rect895 = /*#__PURE__*/React.createElement("rect", {
    x: 211.6,
    y: 213.3,
    transform: "matrix(0.7835 -0.6214 0.6214 0.7835 -102.465 183.2424)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect896 || (_rect896 = /*#__PURE__*/React.createElement("rect", {
    x: 211.8,
    y: 213.2,
    transform: "matrix(0.7838 -0.621 0.621 0.7838 -102.3597 183.1434)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon269 || (_polygon269 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "196.1,218.7 196.3,218.5 227.8,258.3 227.7,258.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect897 || (_rect897 = /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 213,
    transform: "matrix(0.7833 -0.6217 0.6217 0.7833 -102.2492 183.5157)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon270 || (_polygon270 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "196.3,218.5 196.5,218.4 228,258.1 227.9,258.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect898 || (_rect898 = /*#__PURE__*/React.createElement("rect", {
    x: 212.2,
    y: 212.8,
    transform: "matrix(0.7847 -0.6198 0.6198 0.7847 -101.9609 182.8723)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon271 || (_polygon271 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "196.6,218.3 196.7,218.2 228.3,258 228.1,258.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect899 || (_rect899 = /*#__PURE__*/React.createElement("rect", {
    x: 212.4,
    y: 212.7,
    transform: "matrix(0.7833 -0.6217 0.6217 0.7833 -101.9326 183.7164)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _polygon272 || (_polygon272 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "196.8,218.1 197,218 228.5,257.8 228.3,257.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect900 || (_rect900 = /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 212.5,
    transform: "matrix(0.7841 -0.6207 0.6207 0.7841 -101.7032 183.4052)",
    className: "st26",
    width: 0.2,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044175951895231936110000003200735394139863177_)"
    }
  }, _rect901 || (_rect901 = /*#__PURE__*/React.createElement("rect", {
    x: 212.8,
    y: 212.5,
    transform: "matrix(0.8321 -0.5547 0.5547 0.8321 -96.2015 157.9773)",
    className: "st26",
    width: 0,
    height: 50.8
  }))))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M236.9,234.4l0.1-0.4l0,0l0,0l9.3-27.2h-16.8h0h0h-0.2l0,0l0,0l0,0l0,0h0l0,0l0,0l0,0l0,0h0l0,0l0,0l0,0 l0,0l-0.1,0l0,0l0,0v0l0,0l0,0l-0.1,0l0,0l-0.1,0l0,0l-0.1,0l0,0l0,0l-0.1,0l0,0l0,0c0,0-0.1,0-0.1,0l0,0l0,0l0,0l-0.1,0l0,0l0,0 l0,0l0,0l0,0l0,0l-0.1,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l-0.1,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 c0,0-0.1,0.1-0.1,0.1l9.1,26.6l0,0l0,0L236.9,234.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000024722825065885257470000004539142996938295205_",
    d: "M246.4,206.7L246.4,206.7l-16.8,0h0h0h-0.2l0,0h0 l0,0l0,0h0l0,0h0l0,0l0,0h0l0,0l0,0l0,0l0,0l-0.1,0l0,0l0,0l0,0l0,0l0,0l-0.1,0h0l-0.1,0l0,0l-0.1,0l0,0l0,0l-0.1,0l0,0l0,0 c0,0-0.1,0-0.1,0l0,0l0,0l0,0l-0.1,0l0,0l0,0l0,0l0,0l0,0l0,0l-0.1,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l-0.1,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0c0,0-0.1,0.1-0.1,0.1l5.1,14.9L246.4,206.7z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000024722825065885257470000004539142996938295205_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122702809934372598090000004389788044797210264_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000024722825065885257470000004539142996938295205_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect902 || (_rect902 = /*#__PURE__*/React.createElement("rect", {
    x: 225.4,
    y: 203.2,
    transform: "matrix(0.8295 -0.5585 0.5585 0.8295 -76.1562 166.9394)",
    className: "st26",
    width: 19.9,
    height: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect903 || (_rect903 = /*#__PURE__*/React.createElement("rect", {
    x: 228.2,
    y: 212.3,
    transform: "matrix(0.8293 -0.5588 0.5588 0.8293 -78.0123 169.3165)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect904 || (_rect904 = /*#__PURE__*/React.createElement("rect", {
    x: 228.2,
    y: 212.4,
    transform: "matrix(0.83 -0.5578 0.5578 0.83 -77.9908 168.9845)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect905 || (_rect905 = /*#__PURE__*/React.createElement("rect", {
    x: 228.3,
    y: 212.4,
    transform: "matrix(0.8295 -0.5585 0.5585 0.8295 -78.0561 169.2868)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect906 || (_rect906 = /*#__PURE__*/React.createElement("rect", {
    x: 228.3,
    y: 212.5,
    transform: "matrix(0.8295 -0.5585 0.5585 0.8295 -78.0847 169.3223)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect907 || (_rect907 = /*#__PURE__*/React.createElement("rect", {
    x: 228.4,
    y: 212.6,
    transform: "matrix(0.8283 -0.5603 0.5603 0.8283 -78.2057 170.0369)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect908 || (_rect908 = /*#__PURE__*/React.createElement("rect", {
    x: 228.4,
    y: 212.6,
    transform: "matrix(0.8292 -0.559 0.559 0.8292 -78.1689 169.5879)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect909 || (_rect909 = /*#__PURE__*/React.createElement("rect", {
    x: 228.4,
    y: 212.7,
    transform: "matrix(0.831 -0.5562 0.5562 0.831 -78.0505 168.5568)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect910 || (_rect910 = /*#__PURE__*/React.createElement("rect", {
    x: 228.5,
    y: 212.8,
    transform: "matrix(0.8289 -0.5595 0.5595 0.8289 -78.2493 169.8269)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect911 || (_rect911 = /*#__PURE__*/React.createElement("rect", {
    x: 228.5,
    y: 212.8,
    transform: "matrix(0.8301 -0.5577 0.5577 0.8301 -78.1849 169.1824)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect912 || (_rect912 = /*#__PURE__*/React.createElement("rect", {
    x: 228.6,
    y: 212.9,
    transform: "matrix(0.83 -0.5577 0.5577 0.83 -78.2173 169.2449)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect913 || (_rect913 = /*#__PURE__*/React.createElement("rect", {
    x: 228.6,
    y: 212.9,
    transform: "matrix(0.8292 -0.559 0.559 0.8292 -78.3126 169.7649)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _polygon273 || (_polygon273 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "246.9,207.5 246.9,207.6 230.4,218.7 230.3,218.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect914 || (_rect914 = /*#__PURE__*/React.createElement("rect", {
    x: 228.7,
    y: 213.1,
    transform: "matrix(0.83 -0.5577 0.5577 0.83 -78.3034 169.3508)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _polygon274 || (_polygon274 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "247,207.6 247,207.7 230.5,218.8 230.4,218.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect915 || (_rect915 = /*#__PURE__*/React.createElement("rect", {
    x: 228.8,
    y: 213.2,
    transform: "matrix(0.8293 -0.5588 0.5588 0.8293 -78.4146 169.8121)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect916 || (_rect916 = /*#__PURE__*/React.createElement("rect", {
    x: 228.8,
    y: 213.3,
    transform: "matrix(0.8304 -0.5572 0.5572 0.8304 -78.3625 169.262)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect917 || (_rect917 = /*#__PURE__*/React.createElement("rect", {
    x: 228.9,
    y: 213.3,
    transform: "matrix(0.8297 -0.5582 0.5582 0.8297 -78.4445 169.6817)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect918 || (_rect918 = /*#__PURE__*/React.createElement("rect", {
    x: 228.9,
    y: 213.4,
    transform: "matrix(0.8293 -0.5588 0.5588 0.8293 -78.5008 169.9183)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect919 || (_rect919 = /*#__PURE__*/React.createElement("rect", {
    x: 229,
    y: 213.5,
    transform: "matrix(0.83 -0.5577 0.5577 0.83 -78.4756 169.5627)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect920 || (_rect920 = /*#__PURE__*/React.createElement("rect", {
    x: 229,
    y: 213.5,
    transform: "matrix(0.829 -0.5593 0.5593 0.829 -78.5842 170.1781)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect921 || (_rect921 = /*#__PURE__*/React.createElement("rect", {
    x: 229.1,
    y: 213.6,
    transform: "matrix(0.8292 -0.559 0.559 0.8292 -78.6 170.1192)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _polygon275 || (_polygon275 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "247.3,208.1 247.4,208.2 230.8,219.3 230.8,219.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect922 || (_rect922 = /*#__PURE__*/React.createElement("rect", {
    x: 229.1,
    y: 213.7,
    transform: "matrix(0.829 -0.5593 0.5593 0.829 -78.6704 170.2846)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect923 || (_rect923 = /*#__PURE__*/React.createElement("rect", {
    x: 229.2,
    y: 213.8,
    transform: "matrix(0.8293 -0.5588 0.5588 0.8293 -78.6732 170.1307)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect924 || (_rect924 = /*#__PURE__*/React.createElement("rect", {
    x: 229.2,
    y: 213.9,
    transform: "matrix(0.8293 -0.5588 0.5588 0.8293 -78.7019 170.1661)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect925 || (_rect925 = /*#__PURE__*/React.createElement("rect", {
    x: 229.3,
    y: 213.9,
    transform: "matrix(0.8269 -0.5623 0.5623 0.8269 -78.9134 171.5493)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect926 || (_rect926 = /*#__PURE__*/React.createElement("rect", {
    x: 229.3,
    y: 214,
    transform: "matrix(0.831 -0.5562 0.5562 0.831 -78.6234 169.2603)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect927 || (_rect927 = /*#__PURE__*/React.createElement("rect", {
    x: 229.4,
    y: 214,
    transform: "matrix(0.8293 -0.5588 0.5588 0.8293 -78.7881 170.2723)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect928 || (_rect928 = /*#__PURE__*/React.createElement("rect", {
    x: 229.4,
    y: 214.1,
    transform: "matrix(0.829 -0.5593 0.5593 0.829 -78.8429 170.4974)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect929 || (_rect929 = /*#__PURE__*/React.createElement("rect", {
    x: 229.4,
    y: 214.2,
    transform: "matrix(0.83 -0.5577 0.5577 0.83 -78.7913 169.9511)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect930 || (_rect930 = /*#__PURE__*/React.createElement("rect", {
    x: 229.5,
    y: 214.2,
    transform: "matrix(0.8293 -0.5588 0.5588 0.8293 -78.8744 170.3786)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect931 || (_rect931 = /*#__PURE__*/React.createElement("rect", {
    x: 229.5,
    y: 214.3,
    transform: "matrix(0.8309 -0.5565 0.5565 0.8309 -78.7801 169.5324)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect932 || (_rect932 = /*#__PURE__*/React.createElement("rect", {
    x: 229.6,
    y: 214.4,
    transform: "matrix(0.83 -0.5577 0.5577 0.83 -78.8774 170.057)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect933 || (_rect933 = /*#__PURE__*/React.createElement("rect", {
    x: 229.6,
    y: 214.4,
    transform: "matrix(0.8294 -0.5587 0.5587 0.8294 -78.9568 170.4575)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect934 || (_rect934 = /*#__PURE__*/React.createElement("rect", {
    x: 229.7,
    y: 214.5,
    transform: "matrix(0.8292 -0.559 0.559 0.8292 -79.0023 170.6153)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect935 || (_rect935 = /*#__PURE__*/React.createElement("rect", {
    x: 229.7,
    y: 214.6,
    transform: "matrix(0.83 -0.5577 0.5577 0.83 -78.9636 170.163)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect936 || (_rect936 = /*#__PURE__*/React.createElement("rect", {
    x: 229.8,
    y: 214.6,
    transform: "matrix(0.831 -0.5563 0.5563 0.831 -78.9137 169.6395)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _polygon276 || (_polygon276 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "248,209.1 248.1,209.2 231.5,220.4 231.5,220.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect937 || (_rect937 = /*#__PURE__*/React.createElement("rect", {
    x: 229.8,
    y: 214.8,
    transform: "matrix(0.8295 -0.5585 0.5585 0.8295 -79.0902 170.5605)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect938 || (_rect938 = /*#__PURE__*/React.createElement("rect", {
    x: 229.9,
    y: 214.8,
    transform: "matrix(0.8295 -0.5585 0.5585 0.8295 -79.1189 170.5959)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect939 || (_rect939 = /*#__PURE__*/React.createElement("rect", {
    x: 229.9,
    y: 214.9,
    transform: "matrix(0.8283 -0.5603 0.5603 0.8283 -79.2421 171.3165)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _polygon277 || (_polygon277 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "248.2,209.4 248.2,209.5 231.7,220.6 231.6,220.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect940 || (_rect940 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 215,
    transform: "matrix(0.8297 -0.5583 0.5583 0.8297 -79.1919 170.6066)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _polygon278 || (_polygon278 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "248.3,209.5 248.3,209.6 231.8,220.8 231.7,220.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect941 || (_rect941 = /*#__PURE__*/React.createElement("rect", {
    x: 230.1,
    y: 215.1,
    transform: "matrix(0.8295 -0.5585 0.5585 0.8295 -79.2626 170.7727)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect942 || (_rect942 = /*#__PURE__*/React.createElement("rect", {
    x: 230.1,
    y: 215.2,
    transform: "matrix(0.83 -0.5577 0.5577 0.83 -79.2505 170.5162)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect943 || (_rect943 = /*#__PURE__*/React.createElement("rect", {
    x: 230.2,
    y: 215.3,
    transform: "matrix(0.83 -0.5577 0.5577 0.83 -79.2785 170.547)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect944 || (_rect944 = /*#__PURE__*/React.createElement("rect", {
    x: 230.2,
    y: 215.3,
    transform: "matrix(0.8292 -0.559 0.559 0.8292 -79.3761 171.0757)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect945 || (_rect945 = /*#__PURE__*/React.createElement("rect", {
    x: 230.3,
    y: 215.4,
    transform: "matrix(0.83 -0.5577 0.5577 0.83 -79.3367 170.6221)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _polygon279 || (_polygon279 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "248.5,209.9 248.6,210 232,221.1 232,221  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect946 || (_rect946 = /*#__PURE__*/React.createElement("rect", {
    x: 230.4,
    y: 215.5,
    transform: "matrix(0.8283 -0.5604 0.5604 0.8283 -79.5338 171.6991)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _polygon280 || (_polygon280 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "248.6,210 248.7,210.1 232.1,221.3 232.1,221.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect947 || (_rect947 = /*#__PURE__*/React.createElement("rect", {
    x: 230.4,
    y: 215.7,
    transform: "matrix(0.8292 -0.559 0.559 0.8292 -79.5198 171.253)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect948 || (_rect948 = /*#__PURE__*/React.createElement("rect", {
    x: 230.5,
    y: 215.7,
    transform: "matrix(0.8288 -0.5595 0.5595 0.8288 -79.576 171.4859)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect949 || (_rect949 = /*#__PURE__*/React.createElement("rect", {
    x: 230.5,
    y: 215.8,
    transform: "matrix(0.83 -0.5577 0.5577 0.83 -79.5089 170.834)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect950 || (_rect950 = /*#__PURE__*/React.createElement("rect", {
    x: 230.6,
    y: 215.9,
    transform: "matrix(0.829 -0.5593 0.5593 0.829 -79.6193 171.4545)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect951 || (_rect951 = /*#__PURE__*/React.createElement("rect", {
    x: 230.6,
    y: 215.9,
    transform: "matrix(0.83 -0.5577 0.5577 0.83 -79.5655 170.9001)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _polygon281 || (_polygon281 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "248.9,210.4 248.9,210.5 232.4,221.7 232.3,221.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect952 || (_rect952 = /*#__PURE__*/React.createElement("rect", {
    x: 230.7,
    y: 216.1,
    transform: "matrix(0.829 -0.5593 0.5593 0.829 -79.7056 171.5608)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _polygon282 || (_polygon282 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "249,210.6 249,210.7 232.5,221.8 232.4,221.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect953 || (_rect953 = /*#__PURE__*/React.createElement("rect", {
    x: 230.8,
    y: 216.2,
    transform: "matrix(0.8296 -0.5583 0.5583 0.8296 -79.7126 171.2706)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect954 || (_rect954 = /*#__PURE__*/React.createElement("rect", {
    x: 230.8,
    y: 216.2,
    transform: "matrix(0.8317 -0.5552 0.5552 0.8317 -79.5698 170.1007)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect955 || (_rect955 = /*#__PURE__*/React.createElement("rect", {
    x: 230.9,
    y: 216.3,
    transform: "matrix(0.8289 -0.5593 0.5593 0.8289 -79.8244 171.7301)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect956 || (_rect956 = /*#__PURE__*/React.createElement("rect", {
    x: 230.9,
    y: 216.4,
    transform: "matrix(0.8297 -0.5583 0.5583 0.8297 -79.795 171.3491)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect957 || (_rect957 = /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 216.4,
    transform: "matrix(0.83 -0.5577 0.5577 0.83 -79.7958 171.1872)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _rect958 || (_rect958 = /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 216.5,
    transform: "matrix(0.829 -0.5593 0.5593 0.829 -79.9068 171.809)",
    className: "st26",
    width: 19.9,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _polygon283 || (_polygon283 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "249.3,211 249.3,211.1 232.8,222.2 232.7,222.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122702809934372598090000004389788044797210264_)"
    }
  }, _polygon284 || (_polygon284 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "249.3,211.1 249.3,211.1 232.8,222.2 232.8,222.2  "
  }))))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M254.5,230.6c-3.6,10.7-7.1,21-9.3,27.5c0.1,0.1,0.1,0.1,0.2,0.1l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0h0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0h0l0.1,0l0,0l0,0l0,0l0,0l0,0l0,0h0l0,0h0l0,0l0,0h0H263h0l0,0l0,0h0l0,0h0l0,0l0,0l0,0 c0.3,0,0.6-0.1,0.8-0.3L254.5,230.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M247,258.4h16h0l0,0h0h0l0,0h0l0,0l0,0l0,0c0.3,0,0.6-0.1,0.8-0.3l-6.6-19.3L245.2,258L247,258.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000130645902980481485020000001556052753276699264_",
    d: "M219.3,230.7l-9.4,27.5l0,0l0,0l0,0l0,0l0,0.1h16.8 h0h0h0.2l0,0l0,0l0,0l0,0h0l0,0l0,0l0,0l0,0l0,0l0,0l0,0h0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0.1,0l0,0l0,0l0,0l0,0l0,0c0.3-0.1,0.7-0.3,1.1-0.6L219.3,230.7z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000130645902980481485020000001556052753276699264_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111192166290163797560000017414642052027277233_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000130645902980481485020000001556052753276699264_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect959 || (_rect959 = /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 226.2,
    transform: "matrix(0.4967 -0.8679 0.8679 0.4967 -90.8616 317.2068)",
    className: "st26",
    width: 2.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect960 || (_rect960 = /*#__PURE__*/React.createElement("rect", {
    x: 227.4,
    y: 227.2,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -91.9886 317.1622)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect961 || (_rect961 = /*#__PURE__*/React.createElement("rect", {
    x: 227.4,
    y: 227.3,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -92.1354 317.0471)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect962 || (_rect962 = /*#__PURE__*/React.createElement("rect", {
    x: 227.3,
    y: 227.4,
    transform: "matrix(0.4963 -0.8682 0.8682 0.4963 -92.174 317.3668)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect963 || (_rect963 = /*#__PURE__*/React.createElement("rect", {
    x: 227.3,
    y: 227.5,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -92.342 317.1642)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect964 || (_rect964 = /*#__PURE__*/React.createElement("rect", {
    x: 227.2,
    y: 227.6,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -92.4887 317.049)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect965 || (_rect965 = /*#__PURE__*/React.createElement("rect", {
    x: 227.1,
    y: 227.7,
    transform: "matrix(0.4963 -0.8681 0.8681 0.4963 -92.5322 317.3503)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect966 || (_rect966 = /*#__PURE__*/React.createElement("rect", {
    x: 227.1,
    y: 227.8,
    transform: "matrix(0.4957 -0.8685 0.8685 0.4957 -92.5954 317.5726)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect967 || (_rect967 = /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 227.9,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -92.8134 317.1672)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect968 || (_rect968 = /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 228,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -92.9313 317.1677)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect969 || (_rect969 = /*#__PURE__*/React.createElement("rect", {
    x: 226.9,
    y: 228.1,
    transform: "matrix(0.4963 -0.8682 0.8682 0.4963 -92.999 317.3716)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect970 || (_rect970 = /*#__PURE__*/React.createElement("rect", {
    x: 226.9,
    y: 228.2,
    transform: "matrix(0.4969 -0.8678 0.8678 0.4969 -93.1714 317.1507)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect971 || (_rect971 = /*#__PURE__*/React.createElement("rect", {
    x: 226.8,
    y: 228.3,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 -93.3626 316.8497)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect972 || (_rect972 = /*#__PURE__*/React.createElement("rect", {
    x: 226.7,
    y: 228.4,
    transform: "matrix(0.4963 -0.8682 0.8682 0.4963 -93.3527 317.3737)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect973 || (_rect973 = /*#__PURE__*/React.createElement("rect", {
    x: 226.7,
    y: 228.5,
    transform: "matrix(0.4957 -0.8685 0.8685 0.4957 -93.4211 317.5781)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect974 || (_rect974 = /*#__PURE__*/React.createElement("rect", {
    x: 226.6,
    y: 228.6,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 -93.7158 316.8516)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect975 || (_rect975 = /*#__PURE__*/React.createElement("rect", {
    x: 226.6,
    y: 228.7,
    transform: "matrix(0.4974 -0.8675 0.8675 0.4974 -93.805 316.9689)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect976 || (_rect976 = /*#__PURE__*/React.createElement("rect", {
    x: 226.5,
    y: 228.8,
    transform: "matrix(0.4957 -0.8685 0.8685 0.4957 -93.7749 317.5804)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect977 || (_rect977 = /*#__PURE__*/React.createElement("rect", {
    x: 226.4,
    y: 228.9,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -93.9916 317.1735)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect978 || (_rect978 = /*#__PURE__*/React.createElement("rect", {
    x: 226.4,
    y: 229,
    transform: "matrix(0.4974 -0.8675 0.8675 0.4974 -94.1582 316.9709)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect979 || (_rect979 = /*#__PURE__*/React.createElement("rect", {
    x: 226.3,
    y: 229.1,
    transform: "matrix(0.4963 -0.8682 0.8682 0.4963 -94.1781 317.3787)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect980 || (_rect980 = /*#__PURE__*/React.createElement("rect", {
    x: 226.3,
    y: 229.2,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -94.345 317.1755)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect981 || (_rect981 = /*#__PURE__*/React.createElement("rect", {
    x: 226.2,
    y: 229.3,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -94.4905 317.0596)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect982 || (_rect982 = /*#__PURE__*/React.createElement("rect", {
    x: 226.2,
    y: 229.4,
    transform: "matrix(0.4963 -0.8681 0.8681 0.4963 -94.5362 317.3622)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect983 || (_rect983 = /*#__PURE__*/React.createElement("rect", {
    x: 226.1,
    y: 229.5,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -94.6984 317.1775)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect984 || (_rect984 = /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 229.6,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -94.8159 317.1783)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect985 || (_rect985 = /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 229.7,
    transform: "matrix(0.4963 -0.8682 0.8682 0.4963 -94.8853 317.3829)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect986 || (_rect986 = /*#__PURE__*/React.createElement("rect", {
    x: 225.9,
    y: 229.8,
    transform: "matrix(0.4941 -0.8694 0.8694 0.4941 -94.8065 318.2004)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect987 || (_rect987 = /*#__PURE__*/React.createElement("rect", {
    x: 225.9,
    y: 230,
    transform: "matrix(0.4972 -0.8676 0.8676 0.4972 -95.2015 317.0448)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect988 || (_rect988 = /*#__PURE__*/React.createElement("rect", {
    x: 225.8,
    y: 230.1,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -95.2875 317.1809)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect989 || (_rect989 = /*#__PURE__*/React.createElement("rect", {
    x: 225.7,
    y: 230.2,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -95.3843 317.2688)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect990 || (_rect990 = /*#__PURE__*/React.createElement("rect", {
    x: 225.7,
    y: 230.3,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -95.502 317.2695)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect991 || (_rect991 = /*#__PURE__*/React.createElement("rect", {
    x: 225.6,
    y: 230.4,
    transform: "matrix(0.4971 -0.8677 0.8677 0.4971 -95.6642 317.0845)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect992 || (_rect992 = /*#__PURE__*/React.createElement("rect", {
    x: 225.6,
    y: 230.5,
    transform: "matrix(0.4971 -0.8677 0.8677 0.4971 -95.7818 317.0852)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect993 || (_rect993 = /*#__PURE__*/React.createElement("rect", {
    x: 225.5,
    y: 230.6,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -95.8555 317.2715)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect994 || (_rect994 = /*#__PURE__*/React.createElement("rect", {
    x: 225.5,
    y: 230.7,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -96.0219 317.0679)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect995 || (_rect995 = /*#__PURE__*/React.createElement("rect", {
    x: 225.4,
    y: 230.8,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -96.1393 317.0687)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect996 || (_rect996 = /*#__PURE__*/React.createElement("rect", {
    x: 225.3,
    y: 230.9,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -96.2046 317.2921)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect997 || (_rect997 = /*#__PURE__*/React.createElement("rect", {
    x: 225.3,
    y: 231,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -96.3752 317.0697)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect998 || (_rect998 = /*#__PURE__*/React.createElement("rect", {
    x: 225.2,
    y: 231.1,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -96.4926 317.0706)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect999 || (_rect999 = /*#__PURE__*/React.createElement("rect", {
    x: 225.2,
    y: 231.2,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -96.5626 317.2755)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1000 || (_rect1000 = /*#__PURE__*/React.createElement("rect", {
    x: 225.1,
    y: 231.3,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -96.7285 317.0717)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1001 || (_rect1001 = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 231.4,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -96.846 317.0725)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1002 || (_rect1002 = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 231.5,
    transform: "matrix(0.496 -0.8683 0.8683 0.496 -96.8614 317.5115)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1003 || (_rect1003 = /*#__PURE__*/React.createElement("rect", {
    x: 224.9,
    y: 231.6,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -97.0341 317.278)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1004 || (_rect1004 = /*#__PURE__*/React.createElement("rect", {
    x: 224.9,
    y: 231.7,
    transform: "matrix(0.4965 -0.868 0.868 0.4965 -97.1449 317.3086)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1005 || (_rect1005 = /*#__PURE__*/React.createElement("rect", {
    x: 224.8,
    y: 231.8,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 -97.3644 316.8701)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1006 || (_rect1006 = /*#__PURE__*/React.createElement("rect", {
    x: 224.8,
    y: 231.9,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -97.3873 317.2802)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _polygon285 || (_polygon285 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "234.1,247.9 234,248.1 215.4,237.5 215.5,237.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1007 || (_rect1007 = /*#__PURE__*/React.createElement("rect", {
    x: 224.6,
    y: 232.1,
    transform: "matrix(0.4971 -0.8677 0.8677 0.4971 -97.6662 317.0952)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1008 || (_rect1008 = /*#__PURE__*/React.createElement("rect", {
    x: 224.6,
    y: 232.2,
    transform: "matrix(0.4967 -0.8679 0.8679 0.4967 -97.745 317.2636)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1009 || (_rect1009 = /*#__PURE__*/React.createElement("rect", {
    x: 224.5,
    y: 232.3,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -97.8589 317.2831)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1010 || (_rect1010 = /*#__PURE__*/React.createElement("rect", {
    x: 224.5,
    y: 232.4,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -98.0237 317.0785)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1011 || (_rect1011 = /*#__PURE__*/React.createElement("rect", {
    x: 224.4,
    y: 232.5,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -98.1142 317.1967)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1012 || (_rect1012 = /*#__PURE__*/React.createElement("rect", {
    x: 224.3,
    y: 232.6,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -98.2081 317.3037)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1013 || (_rect1013 = /*#__PURE__*/React.createElement("rect", {
    x: 224.3,
    y: 232.7,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -98.3502 317.1978)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1014 || (_rect1014 = /*#__PURE__*/React.createElement("rect", {
    x: 224.2,
    y: 232.8,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -98.4677 317.1987)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1015 || (_rect1015 = /*#__PURE__*/React.createElement("rect", {
    x: 224.2,
    y: 232.9,
    transform: "matrix(0.4963 -0.8682 0.8682 0.4963 -98.5391 317.4044)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1016 || (_rect1016 = /*#__PURE__*/React.createElement("rect", {
    x: 224.1,
    y: 233,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -98.7036 317.1998)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1017 || (_rect1017 = /*#__PURE__*/React.createElement("rect", {
    x: 224.1,
    y: 233.1,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -98.8211 317.2007)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1018 || (_rect1018 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 233.2,
    transform: "matrix(0.4963 -0.8682 0.8682 0.4963 -98.8927 317.4065)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1019 || (_rect1019 = /*#__PURE__*/React.createElement("rect", {
    x: 223.9,
    y: 233.3,
    transform: "matrix(0.4963 -0.8681 0.8681 0.4963 -99.0147 317.3883)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1020 || (_rect1020 = /*#__PURE__*/React.createElement("rect", {
    x: 223.9,
    y: 233.4,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -99.201 317.085)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1021 || (_rect1021 = /*#__PURE__*/React.createElement("rect", {
    x: 223.8,
    y: 233.5,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -99.2927 317.2033)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1022 || (_rect1022 = /*#__PURE__*/React.createElement("rect", {
    x: 223.8,
    y: 233.6,
    transform: "matrix(0.4963 -0.8682 0.8682 0.4963 -99.364 317.4093)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1023 || (_rect1023 = /*#__PURE__*/React.createElement("rect", {
    x: 223.7,
    y: 233.7,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -99.5543 317.0869)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1024 || (_rect1024 = /*#__PURE__*/React.createElement("rect", {
    x: 223.6,
    y: 233.8,
    transform: "matrix(0.4969 -0.8678 0.8678 0.4969 -99.6503 317.1866)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1025 || (_rect1025 = /*#__PURE__*/React.createElement("rect", {
    x: 223.6,
    y: 233.9,
    transform: "matrix(0.4963 -0.8681 0.8681 0.4963 -99.7218 317.3927)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1026 || (_rect1026 = /*#__PURE__*/React.createElement("rect", {
    x: 223.5,
    y: 234,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -99.8617 317.2944)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1027 || (_rect1027 = /*#__PURE__*/React.createElement("rect", {
    x: 223.5,
    y: 234.1,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -99.9995 317.2072)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1028 || (_rect1028 = /*#__PURE__*/React.createElement("rect", {
    x: 223.4,
    y: 234.2,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -100.1433 317.0902)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1029 || (_rect1029 = /*#__PURE__*/React.createElement("rect", {
    x: 223.4,
    y: 234.3,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -100.2152 317.2964)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1030 || (_rect1030 = /*#__PURE__*/React.createElement("rect", {
    x: 223.3,
    y: 234.4,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -100.3791 317.0914)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1031 || (_rect1031 = /*#__PURE__*/React.createElement("rect", {
    x: 223.2,
    y: 234.5,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -100.4967 317.0922)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1032 || (_rect1032 = /*#__PURE__*/React.createElement("rect", {
    x: 223.2,
    y: 234.6,
    transform: "matrix(0.496 -0.8683 0.8683 0.496 -100.5164 317.5338)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1033 || (_rect1033 = /*#__PURE__*/React.createElement("rect", {
    x: 223.1,
    y: 234.7,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 -100.7779 316.8875)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1034 || (_rect1034 = /*#__PURE__*/React.createElement("rect", {
    x: 223.1,
    y: 234.8,
    transform: "matrix(0.4965 -0.868 0.868 0.4965 -100.7938 317.3483)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1035 || (_rect1035 = /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 234.9,
    transform: "matrix(0.4961 -0.8683 0.8683 0.4961 -100.8766 317.5065)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1036 || (_rect1036 = /*#__PURE__*/React.createElement("rect", {
    x: 222.9,
    y: 235,
    transform: "matrix(0.4974 -0.8675 0.8675 0.4974 -101.1053 317.0074)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1037 || (_rect1037 = /*#__PURE__*/React.createElement("rect", {
    x: 222.9,
    y: 235.1,
    transform: "matrix(0.4974 -0.8675 0.8675 0.4974 -101.2226 317.0082)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1038 || (_rect1038 = /*#__PURE__*/React.createElement("rect", {
    x: 222.8,
    y: 235.3,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -101.3211 317.0963)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1039 || (_rect1039 = /*#__PURE__*/React.createElement("rect", {
    x: 222.8,
    y: 235.4,
    transform: "matrix(0.4935 -0.8698 0.8698 0.4935 -101.1351 318.4716)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1040 || (_rect1040 = /*#__PURE__*/React.createElement("rect", {
    x: 222.7,
    y: 235.5,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 -101.6016 316.8919)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1041 || (_rect1041 = /*#__PURE__*/React.createElement("rect", {
    x: 222.7,
    y: 235.6,
    transform: "matrix(0.4972 -0.8676 0.8676 0.4972 -101.6784 317.0796)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1042 || (_rect1042 = /*#__PURE__*/React.createElement("rect", {
    x: 222.6,
    y: 235.7,
    transform: "matrix(0.4961 -0.8683 0.8683 0.4961 -101.7063 317.493)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1043 || (_rect1043 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 235.8,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -101.865 317.306)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1044 || (_rect1044 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 235.9,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -102.0277 317.1002)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1045 || (_rect1045 = /*#__PURE__*/React.createElement("rect", {
    x: 222.4,
    y: 236,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -102.1457 317.101)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1046 || (_rect1046 = /*#__PURE__*/React.createElement("rect", {
    x: 222.4,
    y: 236.1,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -102.2185 317.308)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1047 || (_rect1047 = /*#__PURE__*/React.createElement("rect", {
    x: 222.3,
    y: 236.2,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -102.381 317.1021)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1048 || (_rect1048 = /*#__PURE__*/React.createElement("rect", {
    x: 222.2,
    y: 236.3,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -102.4989 317.1031)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1049 || (_rect1049 = /*#__PURE__*/React.createElement("rect", {
    x: 222.2,
    y: 236.4,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -102.572 317.31)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1050 || (_rect1050 = /*#__PURE__*/React.createElement("rect", {
    x: 222.1,
    y: 236.5,
    transform: "matrix(0.4971 -0.8677 0.8677 0.4971 -102.7302 317.1226)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1051 || (_rect1051 = /*#__PURE__*/React.createElement("rect", {
    x: 222.1,
    y: 236.6,
    transform: "matrix(0.4971 -0.8677 0.8677 0.4971 -102.8482 317.1237)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1052 || (_rect1052 = /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 236.7,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -102.9255 317.312)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1053 || (_rect1053 = /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 236.8,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -103.0622 317.2241)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1054 || (_rect1054 = /*#__PURE__*/React.createElement("rect", {
    x: 221.9,
    y: 236.9,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -103.2055 317.1069)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1055 || (_rect1055 = /*#__PURE__*/React.createElement("rect", {
    x: 221.8,
    y: 237,
    transform: "matrix(0.4962 -0.8682 0.8682 0.4962 -103.2496 317.4509)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1056 || (_rect1056 = /*#__PURE__*/React.createElement("rect", {
    x: 221.8,
    y: 237.1,
    transform: "matrix(0.4963 -0.8682 0.8682 0.4963 -103.3715 317.4326)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1057 || (_rect1057 = /*#__PURE__*/React.createElement("rect", {
    x: 221.7,
    y: 237.2,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -103.5588 317.1089)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1058 || (_rect1058 = /*#__PURE__*/React.createElement("rect", {
    x: 221.7,
    y: 237.3,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -103.6513 317.2276)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1059 || (_rect1059 = /*#__PURE__*/React.createElement("rect", {
    x: 221.6,
    y: 237.4,
    transform: "matrix(0.4963 -0.8682 0.8682 0.4963 -103.725 317.435)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1060 || (_rect1060 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 237.5,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -103.887 317.2292)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _polygon286 || (_polygon286 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "230.9,253.6 230.8,253.7 212.2,243.1 212.3,242.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1061 || (_rect1061 = /*#__PURE__*/React.createElement("rect", {
    x: 221.4,
    y: 237.7,
    transform: "matrix(0.4963 -0.8682 0.8682 0.4963 -104.0786 317.4371)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1062 || (_rect1062 = /*#__PURE__*/React.createElement("rect", {
    x: 221.4,
    y: 237.8,
    transform: "matrix(0.4963 -0.8681 0.8681 0.4963 -104.2006 317.4193)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1063 || (_rect1063 = /*#__PURE__*/React.createElement("rect", {
    x: 221.3,
    y: 237.9,
    transform: "matrix(0.4974 -0.8675 0.8675 0.4974 -104.4017 317.0247)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1064 || (_rect1064 = /*#__PURE__*/React.createElement("rect", {
    x: 221.3,
    y: 238,
    transform: "matrix(0.4974 -0.8675 0.8675 0.4974 -104.5192 317.0256)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1065 || (_rect1065 = /*#__PURE__*/React.createElement("rect", {
    x: 221.2,
    y: 238.1,
    transform: "matrix(0.4972 -0.8676 0.8676 0.4972 -104.6248 317.084)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1066 || (_rect1066 = /*#__PURE__*/React.createElement("rect", {
    x: 221.1,
    y: 238.2,
    transform: "matrix(0.4974 -0.8675 0.8675 0.4974 -104.755 317.0266)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1067 || (_rect1067 = /*#__PURE__*/React.createElement("rect", {
    x: 221.1,
    y: 238.3,
    transform: "matrix(0.4974 -0.8675 0.8675 0.4974 -104.8725 317.0274)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1068 || (_rect1068 = /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 238.4,
    transform: "matrix(0.4957 -0.8685 0.8685 0.4957 -104.8601 317.6491)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1069 || (_rect1069 = /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 238.5,
    transform: "matrix(0.4974 -0.8675 0.8675 0.4974 -105.1082 317.0284)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1070 || (_rect1070 = /*#__PURE__*/React.createElement("rect", {
    x: 220.9,
    y: 238.6,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 -105.2503 316.9104)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1071 || (_rect1071 = /*#__PURE__*/React.createElement("rect", {
    x: 220.8,
    y: 238.7,
    transform: "matrix(0.4957 -0.8685 0.8685 0.4957 -105.2139 317.6513)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1072 || (_rect1072 = /*#__PURE__*/React.createElement("rect", {
    x: 220.8,
    y: 238.8,
    transform: "matrix(0.4963 -0.8682 0.8682 0.4963 -105.3755 317.4446)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1073 || (_rect1073 = /*#__PURE__*/React.createElement("rect", {
    x: 220.7,
    y: 238.9,
    transform: "matrix(0.4974 -0.8675 0.8675 0.4974 -105.5789 317.0311)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1074 || (_rect1074 = /*#__PURE__*/React.createElement("rect", {
    x: 220.7,
    y: 239,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -105.6783 317.1199)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1075 || (_rect1075 = /*#__PURE__*/React.createElement("rect", {
    x: 220.6,
    y: 239.1,
    transform: "matrix(0.4963 -0.8682 0.8682 0.4963 -105.729 317.4469)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1076 || (_rect1076 = /*#__PURE__*/React.createElement("rect", {
    x: 220.6,
    y: 239.2,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -105.9139 317.1214)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1077 || (_rect1077 = /*#__PURE__*/React.createElement("rect", {
    x: 220.5,
    y: 239.3,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -106.0316 317.1218)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1078 || (_rect1078 = /*#__PURE__*/React.createElement("rect", {
    x: 220.4,
    y: 239.4,
    transform: "matrix(0.4963 -0.8682 0.8682 0.4963 -106.0826 317.449)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1079 || (_rect1079 = /*#__PURE__*/React.createElement("rect", {
    x: 220.4,
    y: 239.5,
    transform: "matrix(0.4967 -0.8679 0.8679 0.4967 -106.2285 317.3122)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1080 || (_rect1080 = /*#__PURE__*/React.createElement("rect", {
    x: 220.3,
    y: 239.6,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -106.3849 317.1237)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1081 || (_rect1081 = /*#__PURE__*/React.createElement("rect", {
    x: 220.3,
    y: 239.7,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -106.5029 317.1246)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1082 || (_rect1082 = /*#__PURE__*/React.createElement("rect", {
    x: 220.2,
    y: 239.8,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -106.5781 317.3329)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1083 || (_rect1083 = /*#__PURE__*/React.createElement("rect", {
    x: 220.1,
    y: 239.9,
    transform: "matrix(0.4972 -0.8676 0.8676 0.4972 -106.742 317.1069)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1084 || (_rect1084 = /*#__PURE__*/React.createElement("rect", {
    x: 220.1,
    y: 240,
    transform: "matrix(0.4972 -0.8676 0.8676 0.4972 -106.8599 317.1079)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1085 || (_rect1085 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 240.1,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -106.9316 317.3349)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1086 || (_rect1086 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 240.2,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -107.0915 317.1275)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1087 || (_rect1087 = /*#__PURE__*/React.createElement("rect", {
    x: 219.9,
    y: 240.3,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -107.2094 317.1285)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1088 || (_rect1088 = /*#__PURE__*/React.createElement("rect", {
    x: 219.9,
    y: 240.4,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -107.2852 317.337)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1089 || (_rect1089 = /*#__PURE__*/React.createElement("rect", {
    x: 219.8,
    y: 240.6,
    transform: "matrix(0.4957 -0.8685 0.8685 0.4957 -107.3368 317.6643)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1090 || (_rect1090 = /*#__PURE__*/React.createElement("rect", {
    x: 219.7,
    y: 240.7,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -107.5628 317.1305)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1091 || (_rect1091 = /*#__PURE__*/React.createElement("rect", {
    x: 219.7,
    y: 240.8,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 -107.7221 316.9229)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1092 || (_rect1092 = /*#__PURE__*/React.createElement("rect", {
    x: 219.6,
    y: 240.9,
    transform: "matrix(0.4938 -0.8696 0.8696 0.4938 -107.5395 318.4103)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1093 || (_rect1093 = /*#__PURE__*/React.createElement("rect", {
    x: 219.6,
    y: 241,
    transform: "matrix(0.4971 -0.8677 0.8677 0.4971 -107.9123 317.1511)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1094 || (_rect1094 = /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 241.1,
    transform: "matrix(0.4971 -0.8677 0.8677 0.4971 -108.0278 317.163)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1095 || (_rect1095 = /*#__PURE__*/React.createElement("rect", {
    x: 219.4,
    y: 241.2,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -108.1099 317.3416)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1096 || (_rect1096 = /*#__PURE__*/React.createElement("rect", {
    x: 219.4,
    y: 241.3,
    transform: "matrix(0.4955 -0.8686 0.8686 0.4955 -108.1424 317.77)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1097 || (_rect1097 = /*#__PURE__*/React.createElement("rect", {
    x: 219.3,
    y: 241.4,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 -108.4285 316.9264)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1098 || (_rect1098 = /*#__PURE__*/React.createElement("rect", {
    x: 219.3,
    y: 241.5,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 -108.546 316.927)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1099 || (_rect1099 = /*#__PURE__*/React.createElement("rect", {
    x: 219.2,
    y: 241.6,
    transform: "matrix(0.4961 -0.8683 0.8683 0.4961 -108.5401 317.553)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1100 || (_rect1100 = /*#__PURE__*/React.createElement("rect", {
    x: 219.2,
    y: 241.7,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 -108.7816 316.9282)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1101 || (_rect1101 = /*#__PURE__*/React.createElement("rect", {
    x: 219.1,
    y: 241.8,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 -108.899 316.929)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1102 || (_rect1102 = /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 241.9,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -108.9351 317.3465)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1103 || (_rect1103 = /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 242,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -109.0938 317.1384)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1104 || (_rect1104 = /*#__PURE__*/React.createElement("rect", {
    x: 218.9,
    y: 242.1,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -109.1878 317.2586)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1105 || (_rect1105 = /*#__PURE__*/React.createElement("rect", {
    x: 218.9,
    y: 242.2,
    transform: "matrix(0.4963 -0.8682 0.8682 0.4963 -109.265 317.4678)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1106 || (_rect1106 = /*#__PURE__*/React.createElement("rect", {
    x: 218.8,
    y: 242.3,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -109.4237 317.2597)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1107 || (_rect1107 = /*#__PURE__*/React.createElement("rect", {
    x: 218.7,
    y: 242.4,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -109.5412 317.2606)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1108 || (_rect1108 = /*#__PURE__*/React.createElement("rect", {
    x: 218.7,
    y: 242.5,
    transform: "matrix(0.4963 -0.8682 0.8682 0.4963 -109.6187 317.4699)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1109 || (_rect1109 = /*#__PURE__*/React.createElement("rect", {
    x: 218.6,
    y: 242.6,
    transform: "matrix(0.4962 -0.8682 0.8682 0.4962 -109.7328 317.489)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1110 || (_rect1110 = /*#__PURE__*/React.createElement("rect", {
    x: 218.6,
    y: 242.7,
    transform: "matrix(0.4971 -0.8677 0.8677 0.4971 -109.9142 317.1617)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1111 || (_rect1111 = /*#__PURE__*/React.createElement("rect", {
    x: 218.5,
    y: 242.8,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -110.0128 317.2632)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1112 || (_rect1112 = /*#__PURE__*/React.createElement("rect", {
    x: 218.5,
    y: 242.9,
    transform: "matrix(0.4963 -0.8682 0.8682 0.4963 -110.09 317.4727)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1113 || (_rect1113 = /*#__PURE__*/React.createElement("rect", {
    x: 218.4,
    y: 243,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -110.2481 317.2645)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1114 || (_rect1114 = /*#__PURE__*/React.createElement("rect", {
    x: 218.3,
    y: 243.1,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -110.3663 317.2652)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1115 || (_rect1115 = /*#__PURE__*/React.createElement("rect", {
    x: 218.3,
    y: 243.2,
    transform: "matrix(0.4962 -0.8682 0.8682 0.4962 -110.4399 317.4935)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1116 || (_rect1116 = /*#__PURE__*/React.createElement("rect", {
    x: 218.2,
    y: 243.3,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -110.5843 317.3558)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1117 || (_rect1117 = /*#__PURE__*/React.createElement("rect", {
    x: 218.2,
    y: 243.4,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -110.7197 317.2671)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1118 || (_rect1118 = /*#__PURE__*/React.createElement("rect", {
    x: 218.1,
    y: 243.5,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -110.8601 317.1482)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1119 || (_rect1119 = /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 243.6,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -110.9378 317.3578)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1120 || (_rect1120 = /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 243.7,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -111.0731 317.2691)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1121 || (_rect1121 = /*#__PURE__*/React.createElement("rect", {
    x: 217.9,
    y: 243.8,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -111.2134 317.1502)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1122 || (_rect1122 = /*#__PURE__*/React.createElement("rect", {
    x: 217.9,
    y: 243.9,
    transform: "matrix(0.4967 -0.8679 0.8679 0.4967 -111.2949 317.3411)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1123 || (_rect1123 = /*#__PURE__*/React.createElement("rect", {
    x: 217.8,
    y: 244,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -111.4493 317.1513)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1124 || (_rect1124 = /*#__PURE__*/React.createElement("rect", {
    x: 217.8,
    y: 244.1,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -111.5667 317.1521)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1125 || (_rect1125 = /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 244.2,
    transform: "matrix(0.4963 -0.8682 0.8682 0.4963 -111.6222 317.4817)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1126 || (_rect1126 = /*#__PURE__*/React.createElement("rect", {
    x: 217.6,
    y: 244.3,
    transform: "matrix(0.4961 -0.8683 0.8683 0.4961 -111.7232 317.5719)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1127 || (_rect1127 = /*#__PURE__*/React.createElement("rect", {
    x: 217.6,
    y: 244.4,
    transform: "matrix(0.4969 -0.8678 0.8678 0.4969 -111.9011 317.2552)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1128 || (_rect1128 = /*#__PURE__*/React.createElement("rect", {
    x: 217.5,
    y: 244.5,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 -112.0771 316.945)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1129 || (_rect1129 = /*#__PURE__*/React.createElement("rect", {
    x: 217.5,
    y: 244.6,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -112.116 317.3645)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1130 || (_rect1130 = /*#__PURE__*/React.createElement("rect", {
    x: 217.4,
    y: 244.7,
    transform: "matrix(0.4974 -0.8675 0.8675 0.4974 -112.2902 317.0666)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1131 || (_rect1131 = /*#__PURE__*/React.createElement("rect", {
    x: 217.3,
    y: 244.8,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -112.3912 317.1562)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1132 || (_rect1132 = /*#__PURE__*/React.createElement("rect", {
    x: 217.3,
    y: 244.9,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -112.4695 317.3665)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1133 || (_rect1133 = /*#__PURE__*/React.createElement("rect", {
    x: 217.2,
    y: 245,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -112.5877 317.3674)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1134 || (_rect1134 = /*#__PURE__*/React.createElement("rect", {
    x: 217.2,
    y: 245.1,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -112.7445 317.1581)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1135 || (_rect1135 = /*#__PURE__*/React.createElement("rect", {
    x: 217.1,
    y: 245.2,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -112.862 317.1588)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1136 || (_rect1136 = /*#__PURE__*/React.createElement("rect", {
    x: 217.1,
    y: 245.3,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -112.9412 317.3694)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1137 || (_rect1137 = /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 245.4,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -113.0978 317.16)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1138 || (_rect1138 = /*#__PURE__*/React.createElement("rect", {
    x: 216.9,
    y: 245.5,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -113.2152 317.1608)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1139 || (_rect1139 = /*#__PURE__*/React.createElement("rect", {
    x: 216.9,
    y: 245.6,
    transform: "matrix(0.4967 -0.8679 0.8679 0.4967 -113.2981 317.3527)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1140 || (_rect1140 = /*#__PURE__*/React.createElement("rect", {
    x: 216.8,
    y: 245.7,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -113.4511 317.1619)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1141 || (_rect1141 = /*#__PURE__*/React.createElement("rect", {
    x: 216.8,
    y: 245.9,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -113.5464 317.2829)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1142 || (_rect1142 = /*#__PURE__*/React.createElement("rect", {
    x: 216.7,
    y: 246,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -113.6482 317.3734)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1143 || (_rect1143 = /*#__PURE__*/React.createElement("rect", {
    x: 216.6,
    y: 246.1,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -113.7659 317.3738)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1144 || (_rect1144 = /*#__PURE__*/React.createElement("rect", {
    x: 216.6,
    y: 246.2,
    transform: "matrix(0.4969 -0.8678 0.8678 0.4969 -113.9033 317.2661)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1145 || (_rect1145 = /*#__PURE__*/React.createElement("rect", {
    x: 216.5,
    y: 246.3,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -114.018 317.2856)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1146 || (_rect1146 = /*#__PURE__*/React.createElement("rect", {
    x: 216.5,
    y: 246.4,
    transform: "matrix(0.4941 -0.8694 0.8694 0.4941 -113.9425 318.3377)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1147 || (_rect1147 = /*#__PURE__*/React.createElement("rect", {
    x: 216.4,
    y: 246.5,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -114.2532 317.2869)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1148 || (_rect1148 = /*#__PURE__*/React.createElement("rect", {
    x: 216.4,
    y: 246.6,
    transform: "matrix(0.4968 -0.8679 0.8679 0.4968 -114.368 317.3062)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1149 || (_rect1149 = /*#__PURE__*/React.createElement("rect", {
    x: 216.3,
    y: 246.7,
    transform: "matrix(0.4963 -0.8682 0.8682 0.4963 -114.4509 317.4983)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1150 || (_rect1150 = /*#__PURE__*/React.createElement("rect", {
    x: 216.2,
    y: 246.8,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -114.5905 317.3788)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1151 || (_rect1151 = /*#__PURE__*/React.createElement("rect", {
    x: 216.2,
    y: 246.9,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -114.7249 317.2895)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1152 || (_rect1152 = /*#__PURE__*/React.createElement("rect", {
    x: 216.1,
    y: 247,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -114.8426 317.2901)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1153 || (_rect1153 = /*#__PURE__*/React.createElement("rect", {
    x: 216.1,
    y: 247.1,
    transform: "matrix(0.4962 -0.8682 0.8682 0.4962 -114.9189 317.5199)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1154 || (_rect1154 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 247.2,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -115.0784 317.2915)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1155 || (_rect1155 = /*#__PURE__*/React.createElement("rect", {
    x: 215.9,
    y: 247.3,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -115.1959 317.2923)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1156 || (_rect1156 = /*#__PURE__*/React.createElement("rect", {
    x: 215.9,
    y: 247.4,
    transform: "matrix(0.4963 -0.8682 0.8682 0.4963 -115.276 317.5032)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1157 || (_rect1157 = /*#__PURE__*/React.createElement("rect", {
    x: 215.8,
    y: 247.5,
    transform: "matrix(0.4971 -0.8677 0.8677 0.4971 -115.4478 317.2036)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1158 || (_rect1158 = /*#__PURE__*/React.createElement("rect", {
    x: 215.8,
    y: 247.6,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -115.5493 317.2943)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _polygon287 || (_polygon287 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "225.1,263.6 225.1,263.8 206.5,253.2 206.5,253  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1159 || (_rect1159 = /*#__PURE__*/React.createElement("rect", {
    x: 215.7,
    y: 247.8,
    transform: "matrix(0.4974 -0.8675 0.8675 0.4974 -115.8225 317.0849)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1160 || (_rect1160 = /*#__PURE__*/React.createElement("rect", {
    x: 215.6,
    y: 247.9,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -115.9027 317.2963)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _polygon288 || (_polygon288 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "225,263.9 224.9,264.1 206.3,253.5 206.4,253.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1161 || (_rect1161 = /*#__PURE__*/React.createElement("rect", {
    x: 215.5,
    y: 248.1,
    transform: "matrix(0.4963 -0.8682 0.8682 0.4963 -116.1015 317.508)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1162 || (_rect1162 = /*#__PURE__*/React.createElement("rect", {
    x: 215.4,
    y: 248.2,
    transform: "matrix(0.4974 -0.8675 0.8675 0.4974 -116.2932 317.0876)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1163 || (_rect1163 = /*#__PURE__*/React.createElement("rect", {
    x: 215.4,
    y: 248.3,
    transform: "matrix(0.4968 -0.8679 0.8679 0.4968 -116.3706 317.3174)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1164 || (_rect1164 = /*#__PURE__*/React.createElement("rect", {
    x: 215.3,
    y: 248.4,
    transform: "matrix(0.4957 -0.8685 0.8685 0.4957 -116.4178 317.7213)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1165 || (_rect1165 = /*#__PURE__*/React.createElement("rect", {
    x: 215.2,
    y: 248.5,
    transform: "matrix(0.4974 -0.8675 0.8675 0.4974 -116.6464 317.0894)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1166 || (_rect1166 = /*#__PURE__*/React.createElement("rect", {
    x: 215.2,
    y: 248.6,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -116.7484 317.1797)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1167 || (_rect1167 = /*#__PURE__*/React.createElement("rect", {
    x: 215.1,
    y: 248.7,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -116.8454 317.3014)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1168 || (_rect1168 = /*#__PURE__*/React.createElement("rect", {
    x: 215.1,
    y: 248.8,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -116.944 317.4111)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1169 || (_rect1169 = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 248.9,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -117.1017 317.1816)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1170 || (_rect1170 = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 249,
    transform: "matrix(0.4968 -0.8678 0.8678 0.4968 -117.1988 317.3035)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1171 || (_rect1171 = /*#__PURE__*/React.createElement("rect", {
    x: 214.9,
    y: 249.1,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -117.3008 317.3943)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1172 || (_rect1172 = /*#__PURE__*/React.createElement("rect", {
    x: 214.8,
    y: 249.2,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -117.455 317.1835)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1173 || (_rect1173 = /*#__PURE__*/React.createElement("rect", {
    x: 214.8,
    y: 249.3,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -117.5729 317.1846)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1174 || (_rect1174 = /*#__PURE__*/React.createElement("rect", {
    x: 214.7,
    y: 249.4,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -117.6543 317.3963)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1175 || (_rect1175 = /*#__PURE__*/React.createElement("rect", {
    x: 214.7,
    y: 249.5,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -117.8083 317.1855)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1176 || (_rect1176 = /*#__PURE__*/React.createElement("rect", {
    x: 214.6,
    y: 249.6,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -117.9262 317.1865)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1177 || (_rect1177 = /*#__PURE__*/React.createElement("rect", {
    x: 214.5,
    y: 249.7,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -118.0078 317.3983)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1178 || (_rect1178 = /*#__PURE__*/React.createElement("rect", {
    x: 214.5,
    y: 249.8,
    transform: "matrix(0.4966 -0.868 0.868 0.4966 -118.1256 317.3987)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1179 || (_rect1179 = /*#__PURE__*/React.createElement("rect", {
    x: 214.4,
    y: 249.9,
    transform: "matrix(0.4972 -0.8677 0.8677 0.4972 -118.2795 317.1884)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1180 || (_rect1180 = /*#__PURE__*/React.createElement("rect", {
    x: 214.4,
    y: 250,
    transform: "matrix(0.4972 -0.8676 0.8676 0.4972 -118.4004 317.17)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1181 || (_rect1181 = /*#__PURE__*/React.createElement("rect", {
    x: 214.3,
    y: 250.1,
    transform: "matrix(0.4941 -0.8694 0.8694 0.4941 -118.3131 318.369)",
    className: "st26",
    width: 0.2,
    height: 21.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111192166290163797560000017414642052027277233_)"
    }
  }, _rect1182 || (_rect1182 = /*#__PURE__*/React.createElement("rect", {
    x: 214.3,
    y: 250.2,
    transform: "matrix(0.4988 -0.8667 0.8667 0.4988 -118.693 316.553)",
    className: "st26",
    width: 0.1,
    height: 21.4
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000065770787936350271980000012120237063994552450_",
    points: "219.3,230.7 215.5,241.9 221,235.6  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065770787936350271980000012120237063994552450_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078738275371068711470000000216841764971260544_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065770787936350271980000012120237063994552450_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _polygon289 || (_polygon289 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "219.7,230.6 219.7,230.6 213,232.3 213,232.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1183 || (_rect1183 = /*#__PURE__*/React.createElement("rect", {
    x: 212.9,
    y: 231.4,
    transform: "matrix(0.9672 -0.254 0.254 0.9672 -51.7017 62.5413)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1184 || (_rect1184 = /*#__PURE__*/React.createElement("rect", {
    x: 212.9,
    y: 231.5,
    transform: "matrix(0.9668 -0.2555 0.2555 0.9668 -51.9894 62.9617)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1185 || (_rect1185 = /*#__PURE__*/React.createElement("rect", {
    x: 212.9,
    y: 231.6,
    transform: "matrix(0.9664 -0.2569 0.2569 0.9664 -52.2731 63.3767)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1186 || (_rect1186 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 231.8,
    transform: "matrix(0.967 -0.2547 0.2547 0.967 -51.9194 62.777)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1187 || (_rect1187 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 231.9,
    transform: "matrix(0.9673 -0.2537 0.2537 0.9673 -51.7689 62.502)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1188 || (_rect1188 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 232,
    transform: "matrix(0.9671 -0.2544 0.2544 0.9671 -51.9306 62.7216)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1189 || (_rect1189 = /*#__PURE__*/React.createElement("rect", {
    x: 213.1,
    y: 232.1,
    transform: "matrix(0.9668 -0.2554 0.2554 0.9668 -52.1262 62.9951)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _polygon290 || (_polygon290 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "219.9,231.4 219.9,231.6 213.2,233.3 213.2,233.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1190 || (_rect1190 = /*#__PURE__*/React.createElement("rect", {
    x: 213.1,
    y: 232.4,
    transform: "matrix(0.967 -0.2549 0.2549 0.967 -52.109 62.8945)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _polygon291 || (_polygon291 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "219.9,231.6 220,231.8 213.3,233.6 213.3,233.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1191 || (_rect1191 = /*#__PURE__*/React.createElement("rect", {
    x: 213.2,
    y: 232.6,
    transform: "matrix(0.9668 -0.2557 0.2557 0.9668 -52.3079 63.1364)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1192 || (_rect1192 = /*#__PURE__*/React.createElement("rect", {
    x: 213.2,
    y: 232.8,
    transform: "matrix(0.9666 -0.2561 0.2561 0.9666 -52.412 63.2649)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1193 || (_rect1193 = /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: 232.9,
    transform: "matrix(0.9669 -0.2552 0.2552 0.9669 -52.2906 63.0357)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1194 || (_rect1194 = /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: 233,
    transform: "matrix(0.9673 -0.2535 0.2535 0.9673 -52.0189 62.5704)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1195 || (_rect1195 = /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: 233.1,
    transform: "matrix(0.9668 -0.2555 0.2555 0.9668 -52.4039 63.142)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1196 || (_rect1196 = /*#__PURE__*/React.createElement("rect", {
    x: 213.4,
    y: 233.3,
    transform: "matrix(0.9667 -0.2559 0.2559 0.9667 -52.4925 63.2455)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1197 || (_rect1197 = /*#__PURE__*/React.createElement("rect", {
    x: 213.4,
    y: 233.4,
    transform: "matrix(0.967 -0.2549 0.2549 0.967 -52.3577 62.9959)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1198 || (_rect1198 = /*#__PURE__*/React.createElement("rect", {
    x: 213.4,
    y: 233.5,
    transform: "matrix(0.9668 -0.2555 0.2555 0.9668 -52.4974 63.1801)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1199 || (_rect1199 = /*#__PURE__*/React.createElement("rect", {
    x: 213.5,
    y: 233.7,
    transform: "matrix(0.9673 -0.2537 0.2537 0.9673 -52.2117 62.6933)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1200 || (_rect1200 = /*#__PURE__*/React.createElement("rect", {
    x: 213.5,
    y: 233.8,
    transform: "matrix(0.9668 -0.2555 0.2555 0.9668 -52.5597 63.2055)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1201 || (_rect1201 = /*#__PURE__*/React.createElement("rect", {
    x: 213.5,
    y: 233.9,
    transform: "matrix(0.9668 -0.2556 0.2556 0.9668 -52.6038 63.2386)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1202 || (_rect1202 = /*#__PURE__*/React.createElement("rect", {
    x: 213.6,
    y: 234,
    transform: "matrix(0.9668 -0.2555 0.2555 0.9668 -52.6221 63.2309)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1203 || (_rect1203 = /*#__PURE__*/React.createElement("rect", {
    x: 213.6,
    y: 234.2,
    transform: "matrix(0.9674 -0.2532 0.2532 0.9674 -52.24 62.5937)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1204 || (_rect1204 = /*#__PURE__*/React.createElement("rect", {
    x: 213.6,
    y: 234.3,
    transform: "matrix(0.9668 -0.2557 0.2557 0.9668 -52.7132 63.3018)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1205 || (_rect1205 = /*#__PURE__*/React.createElement("rect", {
    x: 213.7,
    y: 234.4,
    transform: "matrix(0.9668 -0.2555 0.2555 0.9668 -52.7093 63.2593)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1206 || (_rect1206 = /*#__PURE__*/React.createElement("rect", {
    x: 213.7,
    y: 234.5,
    transform: "matrix(0.9667 -0.2559 0.2559 0.9667 -52.8141 63.3879)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1207 || (_rect1207 = /*#__PURE__*/React.createElement("rect", {
    x: 213.7,
    y: 234.7,
    transform: "matrix(0.967 -0.2548 0.2548 0.967 -52.653 63.0981)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1208 || (_rect1208 = /*#__PURE__*/React.createElement("rect", {
    x: 213.8,
    y: 234.8,
    transform: "matrix(0.9668 -0.2555 0.2555 0.9668 -52.809 63.3072)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1209 || (_rect1209 = /*#__PURE__*/React.createElement("rect", {
    x: 213.8,
    y: 234.9,
    transform: "matrix(0.9669 -0.255 0.255 0.9669 -52.7536 63.1838)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1210 || (_rect1210 = /*#__PURE__*/React.createElement("rect", {
    x: 213.8,
    y: 235,
    transform: "matrix(0.9666 -0.2561 0.2561 0.9666 -52.9807 63.5046)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1211 || (_rect1211 = /*#__PURE__*/React.createElement("rect", {
    x: 213.9,
    y: 235.2,
    transform: "matrix(0.9668 -0.2557 0.2557 0.9668 -52.9315 63.3908)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1212 || (_rect1212 = /*#__PURE__*/React.createElement("rect", {
    x: 213.9,
    y: 235.3,
    transform: "matrix(0.9673 -0.2537 0.2537 0.9673 -52.6141 62.857)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1213 || (_rect1213 = /*#__PURE__*/React.createElement("rect", {
    x: 213.9,
    y: 235.4,
    transform: "matrix(0.9668 -0.2555 0.2555 0.9668 -52.9649 63.3708)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1214 || (_rect1214 = /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 235.5,
    transform: "matrix(0.9666 -0.2564 0.2564 0.9666 -53.154 63.6318)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1215 || (_rect1215 = /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 235.7,
    transform: "matrix(0.9668 -0.2555 0.2555 0.9668 -53.0272 63.3961)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1216 || (_rect1216 = /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 235.8,
    transform: "matrix(0.9668 -0.2557 0.2557 0.9668 -53.0874 63.4544)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1217 || (_rect1217 = /*#__PURE__*/React.createElement("rect", {
    x: 214.1,
    y: 235.9,
    transform: "matrix(0.9668 -0.2555 0.2555 0.9668 -53.0895 63.4216)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1218 || (_rect1218 = /*#__PURE__*/React.createElement("rect", {
    x: 214.1,
    y: 236.1,
    transform: "matrix(0.967 -0.2547 0.2547 0.967 -52.9757 63.2073)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1219 || (_rect1219 = /*#__PURE__*/React.createElement("rect", {
    x: 214.1,
    y: 236.2,
    transform: "matrix(0.9667 -0.2559 0.2559 0.9667 -53.2198 63.5535)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1220 || (_rect1220 = /*#__PURE__*/React.createElement("rect", {
    x: 214.2,
    y: 236.3,
    transform: "matrix(0.967 -0.2548 0.2548 0.967 -53.0571 63.2627)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1221 || (_rect1221 = /*#__PURE__*/React.createElement("rect", {
    x: 214.2,
    y: 236.4,
    transform: "matrix(0.9672 -0.2538 0.2538 0.9672 -52.9119 63.0003)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1222 || (_rect1222 = /*#__PURE__*/React.createElement("rect", {
    x: 214.2,
    y: 236.6,
    transform: "matrix(0.9669 -0.255 0.255 0.9669 -53.158 63.3486)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1223 || (_rect1223 = /*#__PURE__*/React.createElement("rect", {
    x: 214.3,
    y: 236.7,
    transform: "matrix(0.9666 -0.2561 0.2561 0.9666 -53.3867 63.6704)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1224 || (_rect1224 = /*#__PURE__*/React.createElement("rect", {
    x: 214.3,
    y: 236.8,
    transform: "matrix(0.9669 -0.255 0.255 0.9669 -53.2202 63.3739)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1225 || (_rect1225 = /*#__PURE__*/React.createElement("rect", {
    x: 214.3,
    y: 236.9,
    transform: "matrix(0.9666 -0.2562 0.2562 0.9666 -53.4589 63.7111)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1226 || (_rect1226 = /*#__PURE__*/React.createElement("rect", {
    x: 214.4,
    y: 237.1,
    transform: "matrix(0.9668 -0.2555 0.2555 0.9668 -53.3699 63.536)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1227 || (_rect1227 = /*#__PURE__*/React.createElement("rect", {
    x: 214.4,
    y: 237.2,
    transform: "matrix(0.9667 -0.2561 0.2561 0.9667 -53.5019 63.7061)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1228 || (_rect1228 = /*#__PURE__*/React.createElement("rect", {
    x: 214.4,
    y: 237.3,
    transform: "matrix(0.9668 -0.2554 0.2554 0.9668 -53.4031 63.5157)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1229 || (_rect1229 = /*#__PURE__*/React.createElement("rect", {
    x: 214.5,
    y: 237.4,
    transform: "matrix(0.9668 -0.2557 0.2557 0.9668 -53.4927 63.6198)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1230 || (_rect1230 = /*#__PURE__*/React.createElement("rect", {
    x: 214.5,
    y: 237.6,
    transform: "matrix(0.9673 -0.2537 0.2537 0.9673 -53.1614 63.0684)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1231 || (_rect1231 = /*#__PURE__*/React.createElement("rect", {
    x: 214.5,
    y: 237.7,
    transform: "matrix(0.9667 -0.2559 0.2559 0.9667 -53.5844 63.691)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1232 || (_rect1232 = /*#__PURE__*/React.createElement("rect", {
    x: 214.6,
    y: 237.8,
    transform: "matrix(0.9664 -0.2569 0.2569 0.9664 -53.808 64.0041)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1233 || (_rect1233 = /*#__PURE__*/React.createElement("rect", {
    x: 214.6,
    y: 237.9,
    transform: "matrix(0.967 -0.2548 0.2548 0.967 -53.4611 63.4273)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1234 || (_rect1234 = /*#__PURE__*/React.createElement("rect", {
    x: 214.6,
    y: 238.1,
    transform: "matrix(0.9672 -0.2538 0.2538 0.9672 -53.3145 63.1641)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1235 || (_rect1235 = /*#__PURE__*/React.createElement("rect", {
    x: 214.7,
    y: 238.2,
    transform: "matrix(0.967 -0.2547 0.2547 0.967 -53.5038 63.4225)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1236 || (_rect1236 = /*#__PURE__*/React.createElement("rect", {
    x: 214.7,
    y: 238.3,
    transform: "matrix(0.9665 -0.2568 0.2568 0.9665 -53.9038 64.0093)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1237 || (_rect1237 = /*#__PURE__*/React.createElement("rect", {
    x: 214.7,
    y: 238.5,
    transform: "matrix(0.9669 -0.255 0.255 0.9669 -53.6246 63.5387)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1238 || (_rect1238 = /*#__PURE__*/React.createElement("rect", {
    x: 214.8,
    y: 238.6,
    transform: "matrix(0.9666 -0.2561 0.2561 0.9666 -53.8553 63.8617)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1239 || (_rect1239 = /*#__PURE__*/React.createElement("rect", {
    x: 214.8,
    y: 238.7,
    transform: "matrix(0.9677 -0.252 0.252 0.9677 -53.128 62.7001)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1240 || (_rect1240 = /*#__PURE__*/React.createElement("rect", {
    x: 214.8,
    y: 238.8,
    transform: "matrix(0.9668 -0.2556 0.2556 0.9668 -53.8161 63.7293)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1241 || (_rect1241 = /*#__PURE__*/React.createElement("rect", {
    x: 214.9,
    y: 239,
    transform: "matrix(0.967 -0.2547 0.2547 0.967 -53.6902 63.4984)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1242 || (_rect1242 = /*#__PURE__*/React.createElement("rect", {
    x: 214.9,
    y: 239.1,
    transform: "matrix(0.9669 -0.2551 0.2551 0.9669 -53.7863 63.6117)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _polygon292 || (_polygon292 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "221.7,238.3 221.8,238.5 215.1,240.3 215,240.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1243 || (_rect1243 = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 239.3,
    transform: "matrix(0.9667 -0.2559 0.2559 0.9667 -53.9901 63.8566)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1244 || (_rect1244 = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 239.5,
    transform: "matrix(0.9665 -0.2568 0.2568 0.9665 -54.1856 64.1244)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1245 || (_rect1245 = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 239.6,
    transform: "matrix(0.967 -0.2548 0.2548 0.967 -53.8516 63.5709)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _polygon293 || (_polygon293 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "221.8,238.8 221.9,239 215.2,240.8 215.2,240.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1246 || (_rect1246 = /*#__PURE__*/React.createElement("rect", {
    x: 215.1,
    y: 239.8,
    transform: "matrix(0.9676 -0.2524 0.2524 0.9676 -53.483 62.9325)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1247 || (_rect1247 = /*#__PURE__*/React.createElement("rect", {
    x: 215.1,
    y: 240,
    transform: "matrix(0.9664 -0.2569 0.2569 0.9664 -54.3406 64.2218)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1248 || (_rect1248 = /*#__PURE__*/React.createElement("rect", {
    x: 215.2,
    y: 240.1,
    transform: "matrix(0.9671 -0.2544 0.2544 0.9671 -53.9167 63.5303)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1249 || (_rect1249 = /*#__PURE__*/React.createElement("rect", {
    x: 215.2,
    y: 240.2,
    transform: "matrix(0.9668 -0.2555 0.2555 0.9668 -54.149 63.8537)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1250 || (_rect1250 = /*#__PURE__*/React.createElement("rect", {
    x: 215.2,
    y: 240.3,
    transform: "matrix(0.9674 -0.2532 0.2532 0.9674 -53.7535 63.2089)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1251 || (_rect1251 = /*#__PURE__*/React.createElement("rect", {
    x: 215.3,
    y: 240.5,
    transform: "matrix(0.9668 -0.2556 0.2556 0.9668 -54.2213 63.8946)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1252 || (_rect1252 = /*#__PURE__*/React.createElement("rect", {
    x: 215.3,
    y: 240.6,
    transform: "matrix(0.9668 -0.2557 0.2557 0.9668 -54.2657 63.9278)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1253 || (_rect1253 = /*#__PURE__*/React.createElement("rect", {
    x: 215.3,
    y: 240.7,
    transform: "matrix(0.9668 -0.2555 0.2555 0.9668 -54.2737 63.9045)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _rect1254 || (_rect1254 = /*#__PURE__*/React.createElement("rect", {
    x: 215.4,
    y: 240.9,
    transform: "matrix(0.9667 -0.2559 0.2559 0.9667 -54.381 64.0348)",
    className: "st26",
    width: 6.9,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078738275371068711470000000216841764971260544_)"
    }
  }, _polygon294 || (_polygon294 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "222.2,240.1 222.2,240.1 215.5,241.9 215.5,241.9  "
  }))))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M215.5,241.9l-5.6,16.3l0,0l0,0l0,0l0,0l0,0.1h16.8h0h0h0.2l0,0l0,0h0l0,0h0l0,0l0,0h0l0,0l0,0l0,0l0,0h0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0h0l0.1,0l0,0l0,0l0,0l0,0l0,0 c0.3-0.1,0.7-0.3,1.1-0.6L215.5,241.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWpd);
export default __webpack_public_path__ + "static/media/wpd.af51dd20.svg";
export { ForwardRef as ReactComponent };